// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================================
   BikeDash Beta - Modern Tesla 2024 Design System
   ============================================================================ */

/* Default theme variables (Dark theme fallback) */
:root {
  /* Spacing - Constant across all themes */
  --spacing-xs: 4px;
  --spacing-sm: 8px;
  --spacing-md: 16px;
  --spacing-lg: 24px;
  --spacing-xl: 32px;
  --spacing-2xl: 48px;

  /* Typography - Constant across all themes */
  --font-primary:
    -apple-system, BlinkMacSystemFont, "SF Pro Display", "Segoe UI", system-ui,
    sans-serif;
  --font-mono: "SF Mono", "Cascadia Code", "Roboto Mono", monospace;

  /* Font Sizes - Medium (default, 100%) */
  --font-size-xs: 10px; /* Labels, tiny text */
  --font-size-sm: 12px; /* Secondary text, descriptions */
  --font-size-base: 14px; /* Body text, most UI */
  --font-size-md: 16px; /* Emphasized text */
  --font-size-lg: 18px; /* Headings, important values */
  --font-size-xl: 24px; /* Large headings */
  --font-size-2xl: 32px; /* Activity metrics */
  --font-size-3xl: 44px; /* Primary activity metrics */

  /* Transitions - Constant across all themes */
  --transition-fast: 200ms cubic-bezier(0.16, 1, 0.3, 1);
  --transition-normal: 300ms cubic-bezier(0.16, 1, 0.3, 1);
  --transition-slow: 500ms cubic-bezier(0.16, 1, 0.3, 1);

  /* Z-index layers - Constant across all themes */
  --z-map: 1;
  --z-controls: 10;
  --z-header: 100;
  --z-modal: 1000;

  /* Colors - Dark theme (default fallback) */
  --bg-primary: #000000;
  --bg-elevated: #0a0a0a;
  --bg-subtle: rgba(255, 255, 255, 0.03);

  --text-primary: #ffffff;
  --text-secondary: rgba(255, 255, 255, 0.5);
  --text-muted: rgba(255, 255, 255, 0.3);

  --accent: #3e6ae1;
  --accent-bright: #5e8aff;
  --success: #00d200;
  --warning: #ff9500;
  --danger: #ff3b30;

  --border: rgba(255, 255, 255, 0.1);

  /* Semantic colors */
  --text-on-accent: #ffffff;
  --bg-button-slider: #ffffff;
  --shadow-sm: rgba(0, 0, 0, 0.2);
  --shadow-md: rgba(0, 0, 0, 0.3);
  --shadow-lg: rgba(0, 0, 0, 0.5);
}

/* ============================================================================
   Theme System - 5 Themes
   ============================================================================ */

/* Dark Theme (Default) */
.theme-dark {
  --bg-primary: #000000;
  --bg-elevated: #0a0a0a;
  --bg-subtle: rgba(255, 255, 255, 0.03);
  --bg-overlay: rgba(0, 0, 0, 0.7);
  --bg-modal: rgba(20, 20, 20, 0.95);
  --bg-glass: rgba(0, 0, 0, 0.3);
  --bg-glass-strong: rgba(0, 0, 0, 0.5);

  --text-primary: #ffffff;
  --text-secondary: rgba(255, 255, 255, 0.5);
  --text-muted: rgba(255, 255, 255, 0.3);

  --accent: #3e6ae1;
  --accent-bright: #5e8aff;
  --success: #00d200;
  --warning: #ff9500;
  --danger: #ff3b30;

  --border: rgba(255, 255, 255, 0.1);
  --border-light: rgba(255, 255, 255, 0.05);

  /* Semantic colors */
  --text-on-accent: #ffffff;
  --bg-button-slider: #ffffff;
  --shadow-sm: rgba(0, 0, 0, 0.2);
  --shadow-md: rgba(0, 0, 0, 0.3);
  --shadow-lg: rgba(0, 0, 0, 0.5);

  /* Overlay text (for map visibility) */
  --text-overlay: #ffffff;
  --text-outline: #000000;
}

/* Light Theme */
.theme-light {
  --bg-primary: #ffffff;
  --bg-elevated: #f8f9fa;
  --bg-subtle: rgba(0, 0, 0, 0.03);
  --bg-overlay: rgba(255, 255, 255, 0.7);
  --bg-modal: rgba(255, 255, 255, 0.98);
  --bg-glass: rgba(255, 255, 255, 0.45);
  --bg-glass-strong: rgba(255, 255, 255, 0.6);

  --text-primary: #000000;
  --text-secondary: rgba(0, 0, 0, 0.6);
  --text-muted: rgba(0, 0, 0, 0.4);

  --accent: #3e6ae1;
  --accent-bright: #2563eb;
  --success: #00b300;
  --warning: #e68600;
  --danger: #dc2626;

  --border: rgba(0, 0, 0, 0.1);
  --border-light: rgba(0, 0, 0, 0.05);

  /* Semantic colors */
  --text-on-accent: #ffffff;
  --bg-button-slider: #ffffff;
  --shadow-sm: rgba(0, 0, 0, 0.1);
  --shadow-md: rgba(0, 0, 0, 0.15);
  --shadow-lg: rgba(0, 0, 0, 0.2);

  /* Overlay text (for map visibility) - INVERTED for light theme */
  --text-overlay: #000000;
  --text-outline: #ffffff;
}

/* High Contrast Dark Theme */
.theme-high-contrast-dark {
  --bg-primary: #000000;
  --bg-elevated: #000000;
  --bg-subtle: #1a1a1a;
  --bg-overlay: rgba(0, 0, 0, 0.95);
  --bg-modal: rgba(0, 0, 0, 0.98);
  --bg-glass: rgba(0, 0, 0, 0.8);
  --bg-glass-strong: rgba(0, 0, 0, 0.85);

  --text-primary: #ffffff;
  --text-secondary: #ffffff;
  --text-muted: #cccccc;

  --accent: #4da6ff;
  --accent-bright: #66b3ff;
  --success: #00ff00;
  --warning: #ffaa00;
  --danger: #ff0000;

  --border: #ffffff;
  --border-strong: #ffffff;
  --border-light: rgba(255, 255, 255, 0.3);
  --focus-ring: #4da6ff;

  /* Semantic colors */
  --text-on-accent: #000000;
  --bg-button-slider: #ffffff;
  --shadow-sm: rgba(0, 0, 0, 0.4);
  --shadow-md: rgba(0, 0, 0, 0.5);
  --shadow-lg: rgba(0, 0, 0, 0.7);

  /* Overlay text (for map visibility) */
  --text-overlay: #ffffff;
  --text-outline: #000000;
}

/* High Contrast Light Theme */
.theme-high-contrast-light {
  --bg-primary: #ffffff;
  --bg-elevated: #ffffff;
  --bg-subtle: #f0f0f0;
  --bg-overlay: rgba(255, 255, 255, 0.85);
  --bg-modal: rgba(255, 255, 255, 0.98);
  --bg-glass: rgba(255, 255, 255, 0.8);
  --bg-glass-strong: rgba(255, 255, 255, 0.85);

  --text-primary: #000000;
  --text-secondary: #000000;
  --text-muted: #333333;

  --accent: #0066ff;
  --accent-bright: #0052cc;
  --success: #006600;
  --warning: #cc6600;
  --danger: #cc0000;

  --border: #000000;
  --border-strong: #000000;
  --border-light: rgba(0, 0, 0, 0.3);
  --focus-ring: #0066ff;

  /* Semantic colors */
  --text-on-accent: #ffffff;
  --bg-button-slider: #000000;
  --shadow-sm: rgba(0, 0, 0, 0.3);
  --shadow-md: rgba(0, 0, 0, 0.4);
  --shadow-lg: rgba(0, 0, 0, 0.5);

  /* Overlay text (for map visibility) - INVERTED for light theme */
  --text-overlay: #000000;
  --text-outline: #ffffff;
}

/* ============================================================================
   Text Size System
   ============================================================================ */

/* Small text size (87.5%) */
[data-text-size="small"] {
  --font-size-xs: 10px;
  --font-size-sm: 12px;
  --font-size-base: 14px;
  --font-size-md: 16px;
  --font-size-lg: 18px;
  --font-size-xl: 24px;
  --font-size-2xl: 32px;
  --font-size-3xl: 44px;
}

/* Medium text size - same as large (112.5% of original) */
[data-text-size="medium"] {
  --font-size-xs: 11px;
  --font-size-sm: 13px;
  --font-size-base: 16px;
  --font-size-md: 18px;
  --font-size-lg: 20px;
  --font-size-xl: 27px;
  --font-size-2xl: 36px;
  --font-size-3xl: 50px;
}

/* Large text size (140%) */
[data-text-size="large"] {
  --font-size-xs: 14px;
  --font-size-sm: 17px;
  --font-size-base: 20px;
  --font-size-md: 22px;
  --font-size-lg: 25px;
  --font-size-xl: 34px;
  --font-size-2xl: 45px;
  --font-size-3xl: 62px;
}

/* Smooth transitions for theme changes */
html {
  transition:
    background-color var(--transition-normal),
    color var(--transition-normal);
}

* {
  transition:
    background-color var(--transition-normal),
    color var(--transition-normal),
    border-color var(--transition-normal);
}

/* ============================================================================
   Base Styles
   ============================================================================ */

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: var(--font-primary);
  background: var(--bg-primary);
  color: var(--text-primary);
  line-height: 1.6;
  font-weight: 400;
  letter-spacing: -0.015em;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  overscroll-behavior: none;
  touch-action: manipulation;
}

/* ============================================================================
   App Layout
   ============================================================================ */

.app {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.map-container {
  position: absolute;
  inset: 0;
  z-index: var(--z-map);
}

/* ============================================================================
   Header - Ultra Minimal
   ============================================================================ */

.header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 var(--spacing-lg);
  z-index: var(--z-header);
  pointer-events: none;
}

.header > * {
  pointer-events: auto;
}

.map-cycle-btn {
  position: relative;
  display: flex;
  align-items: center;
  gap: var(--spacing-sm);
  padding: var(--spacing-sm) var(--spacing-md);
  background: var(--bg-glass);
  backdrop-filter: blur(40px) saturate(150%);
  -webkit-backdrop-filter: blur(40px) saturate(150%);
  border: none;
  border-radius: 100px;
  color: var(--text-primary);
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all var(--transition-fast);
}

/* Only enable hover on devices that support it (not touch screens) */
@media (hover: hover) and (pointer: fine) {
  .map-cycle-btn:hover {
    background: var(--bg-glass-strong);
    transform: scale(1.02);
  }
}

.map-cycle-btn:active {
  transform: scale(0.98);
}

/* ============================================================================
   Activity Bar - Floating Design
   ============================================================================ */

.activity-bar-container {
  position: absolute;
  bottom: var(--spacing-lg);
  left: 50%;
  transform: translateX(-50%);
  z-index: var(--z-controls);
  /* width: min(600px, calc(100vw - var(--spacing-2xl))); */
  width: calc(100vw - var(--spacing-2xl));
}

.activity-bar {
  width: 100%;
  background: var(--bg-glass);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border-radius: 24px;
  padding: 12px var(--spacing-lg);
  transition: all var(--transition-normal);
}

.activity-bar.active {
  background: var(--bg-glass-strong);
  padding-top: var(--spacing-md);
  padding-bottom: var(--spacing-md);
}

/* Activity Bar Layout Variants */

/* Expanded Layout (Default) - Full-size metrics */
.activity-bar--expanded {
  /* Uses base .activity-bar styles */
}

.activity-bar--expanded .metrics {
  align-items: flex-end;
}

.activity-bar--expanded .metric-value {
  font-size: var(--font-size-2xl);
  font-weight: 600;
  /* Subtle outline for better visibility */
  text-shadow:
    -1px -1px 0 var(--text-outline),
    0px -1px 0 var(--text-outline),
    1px -1px 0 var(--text-outline),
    -1px 0px 0 var(--text-outline),
    1px 0px 0 var(--text-outline),
    -1px 1px 0 var(--text-outline),
    0px 1px 0 var(--text-outline),
    1px 1px 0 var(--text-outline);
}

.activity-bar--expanded .metric--primary .metric-value {
  font-size: var(--font-size-3xl);
}

.activity-bar--expanded .metric-label {
  font-size: var(--font-size-xs);
  margin-top: 2px;
}

/* Compact Layout - Space-saving design */
.activity-bar--compact {
  padding: 6px var(--spacing-lg);
  border-radius: 18px;
  width: 100%;
}

.activity-bar-container:has(.activity-bar--compact) {
  width: calc(100vw - var(--spacing-xl));
}

.activity-bar--compact.active {
  background: var(--bg-glass-strong);
  padding-top: var(--spacing-sm);
  padding-bottom: var(--spacing-sm);
}

.activity-bar--compact .metrics {
  margin-bottom: var(--spacing-xs);
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  align-items: baseline;
}

.activity-bar--compact .metric--inline:nth-child(1) {
  justify-self: start;
}

.activity-bar--compact .metric--inline:nth-child(2) {
  justify-self: center;
}

.activity-bar--compact .metric--inline:nth-child(3) {
  justify-self: end;
}

.activity-bar--compact .metric--inline {
  flex-direction: row;
  align-items: baseline;
  gap: 4px;
}

.activity-bar--compact .metric {
  min-width: 60px;
}

.activity-bar--compact .metric-value {
  font-size: var(--font-size-2xl) !important;
  font-weight: 600 !important;
  /* Subtle outline for better visibility */
  text-shadow:
    -1px -1px 0 var(--text-outline),
    0px -1px 0 var(--text-outline),
    1px -1px 0 var(--text-outline),
    -1px 0px 0 var(--text-outline),
    1px 0px 0 var(--text-outline),
    -1px 1px 0 var(--text-outline),
    0px 1px 0 var(--text-outline),
    1px 1px 0 var(--text-outline);
}

.activity-bar--compact .metric--inline:nth-child(2) .metric-value {
  font-size: var(--font-size-3xl) !important;
}

.activity-bar--compact .metric-label {
  font-size: var(--font-size-xs) !important;
  margin-top: 0;
  letter-spacing: 0.08em;
}

.activity-bar--compact .activity-controls {
  gap: var(--spacing-xs);
}

.activity-bar--compact .control-btn {
  padding: 8px 24px;
  font-size: var(--font-size-sm);
  min-width: 80px;
}

/* Overlay Layout - Semi-transparent over map with enhanced visibility */
.activity-bar--overlay {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  gap: var(--spacing-md);
  width: 100%;
  background: rgba(0, 0, 0, 0.25);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border-radius: 20px;
  padding: 6px var(--spacing-lg);
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.activity-bar-container:has(.activity-bar--overlay) {
  width: min(820px, calc(100vw - var(--spacing-xl)));
}

.activity-bar--overlay.active {
  background: rgba(0, 0, 0, 0.35);
  padding-top: var(--spacing-sm);
  padding-bottom: var(--spacing-sm);
  padding-left: var(--spacing-lg);
  padding-right: var(--spacing-lg);
}

/* Light theme overlay backgrounds */
.theme-light .activity-bar--overlay {
  background: rgba(255, 255, 255, 0.25);
  border: 1px solid rgba(0, 0, 0, 0.1);
}

.theme-light .activity-bar--overlay.active {
  background: rgba(255, 255, 255, 0.35);
}

/* High contrast dark backgrounds */
.theme-high-contrast-dark .activity-bar.active {
  background: rgba(0, 0, 0, 0.85);
}

.theme-high-contrast-dark .activity-bar--overlay {
  background: rgba(0, 0, 0, 0.75);
}

.theme-high-contrast-dark .activity-bar--overlay.active {
  background: rgba(0, 0, 0, 0.85);
}

/* High contrast light backgrounds */
.theme-high-contrast-light .activity-bar.active {
  background: rgba(255, 255, 255, 0.85);
}

.theme-high-contrast-light .activity-bar--overlay {
  background: rgba(255, 255, 255, 0.75);
  border: 1px solid rgba(0, 0, 0, 0.3);
}

.theme-high-contrast-light .activity-bar--overlay.active {
  background: rgba(255, 255, 255, 0.85);
}

/* High contrast themes - thicker text outlines for speed */
.theme-high-contrast-dark .metric-value-hero,
.theme-high-contrast-light .metric-value-hero {
  text-shadow:
    -1px -1px 0 var(--text-outline),
    0px -1px 0 var(--text-outline),
    1px -1px 0 var(--text-outline),
    -1px 0px 0 var(--text-outline),
    1px 0px 0 var(--text-outline),
    -1px 1px 0 var(--text-outline),
    0px 1px 0 var(--text-outline),
    1px 1px 0 var(--text-outline),
    -2px -2px 0 var(--text-outline),
    -1px -2px 0 var(--text-outline),
    0px -2px 0 var(--text-outline),
    1px -2px 0 var(--text-outline),
    2px -2px 0 var(--text-outline),
    -2px -1px 0 var(--text-outline),
    2px -1px 0 var(--text-outline),
    -2px 0px 0 var(--text-outline),
    2px 0px 0 var(--text-outline),
    -2px 1px 0 var(--text-outline),
    2px 1px 0 var(--text-outline),
    -2px 2px 0 var(--text-outline),
    -1px 2px 0 var(--text-outline),
    0px 2px 0 var(--text-outline),
    1px 2px 0 var(--text-outline),
    2px 2px 0 var(--text-outline),
    -3px -3px 0 var(--text-outline),
    -2px -3px 0 var(--text-outline),
    -1px -3px 0 var(--text-outline),
    0px -3px 0 var(--text-outline),
    1px -3px 0 var(--text-outline),
    2px -3px 0 var(--text-outline),
    3px -3px 0 var(--text-outline),
    -3px -2px 0 var(--text-outline),
    3px -2px 0 var(--text-outline),
    -3px -1px 0 var(--text-outline),
    3px -1px 0 var(--text-outline),
    -3px 0px 0 var(--text-outline),
    3px 0px 0 var(--text-outline),
    -3px 1px 0 var(--text-outline),
    3px 1px 0 var(--text-outline),
    -3px 2px 0 var(--text-outline),
    3px 2px 0 var(--text-outline),
    -3px 3px 0 var(--text-outline),
    -2px 3px 0 var(--text-outline),
    -1px 3px 0 var(--text-outline),
    0px 3px 0 var(--text-outline),
    1px 3px 0 var(--text-outline),
    2px 3px 0 var(--text-outline),
    3px 3px 0 var(--text-outline),
    -4px -4px 0 var(--text-outline),
    -3px -4px 0 var(--text-outline),
    -2px -4px 0 var(--text-outline),
    -1px -4px 0 var(--text-outline),
    0px -4px 0 var(--text-outline),
    1px -4px 0 var(--text-outline),
    2px -4px 0 var(--text-outline),
    3px -4px 0 var(--text-outline),
    4px -4px 0 var(--text-outline),
    -4px -3px 0 var(--text-outline),
    4px -3px 0 var(--text-outline),
    -4px -2px 0 var(--text-outline),
    4px -2px 0 var(--text-outline),
    -4px -1px 0 var(--text-outline),
    4px -1px 0 var(--text-outline),
    -4px 0px 0 var(--text-outline),
    4px 0px 0 var(--text-outline),
    -4px 1px 0 var(--text-outline),
    4px 1px 0 var(--text-outline),
    -4px 2px 0 var(--text-outline),
    4px 2px 0 var(--text-outline),
    -4px 3px 0 var(--text-outline),
    4px 3px 0 var(--text-outline),
    -4px 4px 0 var(--text-outline),
    -3px 4px 0 var(--text-outline),
    -2px 4px 0 var(--text-outline),
    -1px 4px 0 var(--text-outline),
    0px 4px 0 var(--text-outline),
    1px 4px 0 var(--text-outline),
    2px 4px 0 var(--text-outline),
    3px 4px 0 var(--text-outline),
    4px 4px 0 var(--text-outline);
}

.theme-high-contrast-dark .metric-label-hero,
.theme-high-contrast-light .metric-label-hero {
  text-shadow:
    -1px -1px 0 var(--text-outline),
    0px -1px 0 var(--text-outline),
    1px -1px 0 var(--text-outline),
    -1px 0px 0 var(--text-outline),
    1px 0px 0 var(--text-outline),
    -1px 1px 0 var(--text-outline),
    0px 1px 0 var(--text-outline),
    1px 1px 0 var(--text-outline),
    -2px -2px 0 var(--text-outline),
    -1px -2px 0 var(--text-outline),
    0px -2px 0 var(--text-outline),
    1px -2px 0 var(--text-outline),
    2px -2px 0 var(--text-outline),
    -2px -1px 0 var(--text-outline),
    2px -1px 0 var(--text-outline),
    -2px 0px 0 var(--text-outline),
    2px 0px 0 var(--text-outline),
    -2px 1px 0 var(--text-outline),
    2px 1px 0 var(--text-outline),
    -2px 2px 0 var(--text-outline),
    -1px 2px 0 var(--text-outline),
    0px 2px 0 var(--text-outline),
    1px 2px 0 var(--text-outline),
    2px 2px 0 var(--text-outline),
    -3px -3px 0 var(--text-outline),
    -2px -3px 0 var(--text-outline),
    -1px -3px 0 var(--text-outline),
    0px -3px 0 var(--text-outline),
    1px -3px 0 var(--text-outline),
    2px -3px 0 var(--text-outline),
    3px -3px 0 var(--text-outline),
    -3px -2px 0 var(--text-outline),
    3px -2px 0 var(--text-outline),
    -3px -1px 0 var(--text-outline),
    3px -1px 0 var(--text-outline),
    -3px 0px 0 var(--text-outline),
    3px 0px 0 var(--text-outline),
    -3px 1px 0 var(--text-outline),
    3px 1px 0 var(--text-outline),
    -3px 2px 0 var(--text-outline),
    3px 2px 0 var(--text-outline),
    -3px 3px 0 var(--text-outline),
    -2px 3px 0 var(--text-outline),
    -1px 3px 0 var(--text-outline),
    0px 3px 0 var(--text-outline),
    1px 3px 0 var(--text-outline),
    2px 3px 0 var(--text-outline),
    3px 3px 0 var(--text-outline),
    -4px -4px 0 var(--text-outline),
    -3px -4px 0 var(--text-outline),
    -2px -4px 0 var(--text-outline),
    -1px -4px 0 var(--text-outline),
    0px -4px 0 var(--text-outline),
    1px -4px 0 var(--text-outline),
    2px -4px 0 var(--text-outline),
    3px -4px 0 var(--text-outline),
    4px -4px 0 var(--text-outline),
    -4px -3px 0 var(--text-outline),
    4px -3px 0 var(--text-outline),
    -4px -2px 0 var(--text-outline),
    4px -2px 0 var(--text-outline),
    -4px -1px 0 var(--text-outline),
    4px -1px 0 var(--text-outline),
    -4px 0px 0 var(--text-outline),
    4px 0px 0 var(--text-outline),
    -4px 1px 0 var(--text-outline),
    4px 1px 0 var(--text-outline),
    -4px 2px 0 var(--text-outline),
    4px 2px 0 var(--text-outline),
    -4px 3px 0 var(--text-outline),
    4px 3px 0 var(--text-outline),
    -4px 4px 0 var(--text-outline),
    -3px 4px 0 var(--text-outline),
    -2px 4px 0 var(--text-outline),
    -1px 4px 0 var(--text-outline),
    0px 4px 0 var(--text-outline),
    1px 4px 0 var(--text-outline),
    2px 4px 0 var(--text-outline),
    3px 4px 0 var(--text-outline),
    4px 4px 0 var(--text-outline);
}

/* Side columns - left and right */
.overlay-side {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-sm);
}

.overlay-side-left {
  grid-column: 1;
  align-items: flex-start;
}

.overlay-side-right {
  grid-column: 3;
  align-items: flex-end;
}

/* Center column - MPH label in grid with speed above */
.overlay-center {
  grid-column: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  pointer-events: none;
}

.metric-value-hero {
  position: absolute;
  bottom: 100%;
  font-size: 192px;
  font-weight: 600;
  letter-spacing: -0.02em; /* Tighter spacing between numbers */
  line-height: 1;
  color: var(--text-overlay);
  white-space: nowrap;
  /* Smooth solid outline for visibility over map */
  text-shadow:
    -1px -1px 0 var(--text-outline),
    0px -1px 0 var(--text-outline),
    1px -1px 0 var(--text-outline),
    -1px 0px 0 var(--text-outline),
    1px 0px 0 var(--text-outline),
    -1px 1px 0 var(--text-outline),
    0px 1px 0 var(--text-outline),
    1px 1px 0 var(--text-outline),
    -2px -2px 0 var(--text-outline),
    -1px -2px 0 var(--text-outline),
    0px -2px 0 var(--text-outline),
    1px -2px 0 var(--text-outline),
    2px -2px 0 var(--text-outline),
    -2px -1px 0 var(--text-outline),
    2px -1px 0 var(--text-outline),
    -2px 0px 0 var(--text-outline),
    2px 0px 0 var(--text-outline),
    -2px 1px 0 var(--text-outline),
    2px 1px 0 var(--text-outline),
    -2px 2px 0 var(--text-outline),
    -1px 2px 0 var(--text-outline),
    0px 2px 0 var(--text-outline),
    1px 2px 0 var(--text-outline),
    2px 2px 0 var(--text-outline);
}

/* Speed decimal scaling */
.speed-decimal {
  font-size: 0.8em;
  vertical-align: baseline;
  /* Reduced outline - half thickness */
  text-shadow:
    -1px -1px 0 var(--text-outline),
    0px -1px 0 var(--text-outline),
    1px -1px 0 var(--text-outline),
    -1px 0px 0 var(--text-outline),
    1px 0px 0 var(--text-outline),
    -1px 1px 0 var(--text-outline),
    0px 1px 0 var(--text-outline),
    1px 1px 0 var(--text-outline);
}

.speed-decimal--small {
  font-size: 0.6em;
}

.speed-decimal-point {
  letter-spacing: -0.05em; /* Pull the decimal point closer to the integer */
  margin-right: -0.05em; /* Reduce space after decimal point */
}

.metric-label-hero {
  font-size: 36px;
  text-transform: uppercase;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 1;
  color: var(--text-overlay);
  white-space: nowrap;
  text-shadow:
    -1px -1px 0 var(--text-outline),
    0px -1px 0 var(--text-outline),
    1px -1px 0 var(--text-outline),
    -1px 0px 0 var(--text-outline),
    1px 0px 0 var(--text-outline),
    -1px 1px 0 var(--text-outline),
    0px 1px 0 var(--text-outline),
    1px 1px 0 var(--text-outline),
    -2px -2px 0 var(--text-outline),
    -1px -2px 0 var(--text-outline),
    0px -2px 0 var(--text-outline),
    1px -2px 0 var(--text-outline),
    2px -2px 0 var(--text-outline),
    -2px -1px 0 var(--text-outline),
    2px -1px 0 var(--text-outline),
    -2px 0px 0 var(--text-outline),
    2px 0px 0 var(--text-outline),
    -2px 1px 0 var(--text-outline),
    2px 1px 0 var(--text-outline),
    -2px 2px 0 var(--text-outline),
    -1px 2px 0 var(--text-outline),
    0px 2px 0 var(--text-outline),
    1px 2px 0 var(--text-outline),
    2px 2px 0 var(--text-outline);
}

/* Secondary metrics container - center section */
.metrics-secondary {
  display: flex;
  gap: var(--spacing-2xl);
  flex: 1;
  justify-content: center;
  align-items: center;
}

.metric-secondary {
  display: flex;
  flex-direction: row;
  align-items: baseline;
  gap: 4px;
}

.metric-value-secondary {
  font-size: var(--font-size-2xl) !important;
  font-weight: 600 !important;
  line-height: 1;
  font-variant-numeric: tabular-nums;
  letter-spacing: -0.02em;
  color: var(--text-primary);
}

.metric-label-secondary {
  font-size: var(--font-size-xs) !important;
  text-transform: uppercase;
  margin-top: 0;
  font-weight: 500 !important;
  letter-spacing: 0.08em;
  color: var(--text-muted);
}

/* Control buttons for overlay mode - vertical stack on the right */
.activity-controls-overlay {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-sm);
  flex-shrink: 0;
}

.control-btn-overlay {
  padding: 10px 20px;
  font-size: var(--font-size-sm);
  font-weight: 500;
  border-radius: 12px;
  background: rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: var(--text-primary);
  cursor: pointer;
  transition:
    background var(--transition-fast),
    border-color var(--transition-fast),
    transform var(--transition-fast);
  min-width: 85px;
  white-space: nowrap;
}

.control-btn-overlay:hover {
  background: rgba(0, 0, 0, 0.5);
  border-color: rgba(255, 255, 255, 0.3);
  transform: scale(1.02);
}

.control-btn-overlay:active {
  transform: scale(0.98);
}

.control-btn-overlay.primary {
  background: var(--accent);
  border-color: var(--accent);
  color: var(--text-on-accent);
}

.control-btn-overlay.primary:hover {
  background: var(--accent-bright);
  border-color: var(--accent-bright);
}

.control-btn-overlay.primary.recording {
  background: var(--warning);
  border-color: var(--warning);
}

.control-btn-overlay.primary.paused {
  background: var(--success);
  border-color: var(--success);
}

.control-btn-overlay.stop {
  background: rgba(255, 59, 48, 0.2);
  border-color: rgba(255, 59, 48, 0.5);
  color: var(--danger);
}

.control-btn-overlay.stop:hover {
  background: rgba(255, 59, 48, 0.3);
  border-color: rgba(255, 59, 48, 0.6);
}

.metrics {
  display: flex;
  justify-content: space-around;
  gap: var(--spacing-xl);
  margin-bottom: var(--spacing-md);
}

.metric {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
}

.metric-value {
  font-size: var(--font-size-2xl);
  font-weight: 200;
  line-height: 1;
  font-variant-numeric: tabular-nums;
  letter-spacing: -0.02em;
}

.metric-label {
  font-size: var(--font-size-xs);
  text-transform: uppercase;
  color: var(--text-muted);
  margin-top: 2px;
  letter-spacing: 0.08em;
  font-weight: 500;
}

.activity-controls {
  display: flex;
  gap: var(--spacing-sm);
  justify-content: center;
}

/* Floating controls - appear above activity bar when active */
.activity-controls-floating {
  position: absolute;
  bottom: calc(100% + var(--spacing-sm));
  left: 0;
  right: 0;
  display: flex;
  justify-content: space-between;
  gap: var(--spacing-sm);
  z-index: calc(var(--z-controls) + 1);
}

.control-btn-floating {
  padding: 10px 24px;
  border: none;
  border-radius: 100px;
  font-size: var(--font-size-sm);
  font-weight: 500;
  cursor: pointer;
  transition: all var(--transition-fast);
  min-width: 90px;
  background: var(--bg-glass);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  color: var(--text-primary);
}

.control-btn-floating:hover {
  transform: translateY(-2px);
}

.control-btn-floating:active {
  transform: translateY(0);
}

.control-btn-floating.primary {
  background: var(--accent);
  color: var(--text-on-accent);
}

.control-btn-floating.primary:hover {
  background: var(--accent-bright);
}

.control-btn-floating.primary.recording {
  background: var(--warning);
}

.control-btn-floating.primary.paused {
  background: var(--success);
}

.control-btn-floating.stop {
  background: rgba(255, 59, 48, 0.2);
  color: white;
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
}

.control-btn-floating.stop:hover {
  background: rgba(255, 59, 48, 0.3);
}

/* Start button that replaces time metric */
.control-btn-start {
  padding: 12px 32px;
  border: none;
  border-radius: 100px;
  font-size: var(--font-size-sm);
  font-weight: 500;
  cursor: pointer;
  transition: all var(--transition-fast);
  background: var(--accent);
  color: var(--text-on-accent);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.control-btn-start:hover {
  background: var(--accent-bright);
  transform: translateY(-1px);
}

.control-btn-start:active {
  transform: translateY(0);
}

/* Compact start button */
.control-btn-start-compact {
  padding: 10px 24px;
  border: none;
  border-radius: 100px;
  font-size: var(--font-size-sm);
  font-weight: 500;
  cursor: pointer;
  transition: all var(--transition-fast);
  background: var(--accent);
  color: var(--text-on-accent);
  min-width: 90px;
  justify-self: end;
  align-self: center;
}

.control-btn-start-compact:hover {
  background: var(--accent-bright);
  transform: scale(1.02);
}

.control-btn-start-compact:active {
  transform: scale(0.98);
}

/* Overlay start button */
.control-btn-start-overlay {
  padding: 10px 24px;
  border: none;
  border-radius: 100px;
  font-size: var(--font-size-sm);
  font-weight: 500;
  cursor: pointer;
  transition: all var(--transition-fast);
  background: var(--accent);
  color: var(--text-on-accent);
  min-width: 90px;
}

.control-btn-start-overlay:hover {
  background: var(--accent-bright);
  transform: scale(1.02);
}

.control-btn-start-overlay:active {
  transform: scale(0.98);
}

/* ============================================================================
   Compass Rose
   ============================================================================ */

.header-right {
  display: flex;
  align-items: center;
  gap: var(--spacing-md);
}

.compass-rose {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.95);
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all var(--transition-fast);
  position: relative;
  box-shadow: 0 2px 4px var(--shadow-sm);
  color: #4285f4;
}

.compass-rose:hover {
  box-shadow: 0 4px 8px var(--shadow-md);
}

/* Blue dot indicator */
.compass-dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #4285f4;
  position: relative;
}

.compass-dot.no-gps {
  background: #9e9e9e;
}

.compass-dot.active {
  width: 16px;
  height: 16px;
  background: #4285f4;
  box-shadow: 0 0 0 3px rgba(66, 133, 244, 0.3);
}

/* Compass arrow */
.compass-arrow {
  color: #4285f4;
  transition: none; /* No transition since parent rotates */
}

/* North mode */
.compass-north {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0;
}

.compass-north .compass-arrow-small {
  color: #ea4335;
  margin-bottom: -4px;
}

.compass-north span {
  font-size: var(--font-size-sm);
  font-weight: 600;
  color: #ea4335;
}

/* Active states */
.compass-rose.mode-center,
.compass-rose.mode-compass,
.compass-rose.mode-compass-locked,
.compass-rose.mode-north {
  background: white;
}

.compass-rose.mode-compass .compass-arrow,
.compass-rose.mode-compass-locked .compass-arrow {
  color: #4285f4;
}

/* Subtle pulse for active tracking */
.compass-rose.mode-center .compass-dot,
.compass-rose.mode-compass,
.compass-rose.mode-compass-locked,
.compass-rose.mode-north {
  animation: subtlePulse 3s ease-in-out infinite;
}

@keyframes subtlePulse {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.8;
  }
}

/* Error state - red border */
.compass-rose.error {
  border: 3px solid #ff3b30 !important;
  animation: errorPulse 2s ease-in-out infinite;
}

.compass-rose.error .compass-dot {
  background: #ff3b30;
}

.compass-rose.error .compass-arrow {
  color: #ff3b30;
}

@keyframes errorPulse {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.85;
  }
}

/* ============================================================================
   Buttons - Clean & Modern
   ============================================================================ */

.btn,
.control-btn {
  padding: 12px 32px;
  border: none;
  border-radius: 100px;
  font-size: 13px;
  font-weight: 500;
  letter-spacing: 0.02em;
  cursor: pointer;
  transition: all var(--transition-fast);
  min-width: 100px;
  background: rgba(255, 255, 255, 0.1);
  color: var(--text-primary);
  position: relative;
  overflow: hidden;
}

.btn::before,
.control-btn::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.1);
  transform: translate(-50%, -50%);
  transition:
    width var(--transition-normal),
    height var(--transition-normal);
}

.btn:hover::before,
.control-btn:hover::before {
  width: 300px;
  height: 300px;
}

.btn:hover,
.control-btn:hover {
  transform: translateY(-1px);
}

.btn:active,
.control-btn:active {
  transform: translateY(0);
}

.btn:disabled,
.control-btn:disabled {
  opacity: 0.3;
  cursor: not-allowed;
}

.control-btn.primary {
  background: var(--accent);
  color: var(--text-on-accent);
}

.control-btn.primary:hover {
  background: var(--accent-bright);
}

.control-btn.primary.recording {
  background: var(--warning);
}

.control-btn.primary.paused {
  background: var(--success);
}

.control-btn.stop {
  background: rgba(255, 59, 48, 0.2);
  color: var(--danger);
}

.control-btn.stop:hover {
  background: rgba(255, 59, 48, 0.3);
}

/* ============================================================================
   User Menu - Floating Avatar
   ============================================================================ */

.user-menu {
  position: relative;
}

.user-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: var(--bg-glass);
  backdrop-filter: blur(40px);
  -webkit-backdrop-filter: blur(40px);
  border: none;
  cursor: pointer;
  transition: all var(--transition-fast);
  position: relative;
}

.user-btn:hover {
  transform: scale(1.05);
  background: var(--bg-glass-strong);
}

.user-avatar {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.avatar-initial {
  font-size: var(--font-size-base);
  font-weight: 600;
  color: var(--text-primary);
}

.guest-icon {
  font-size: var(--font-size-lg);
  opacity: 0.7;
}

/* Status indicator dot */
.status-dot {
  position: absolute;
  bottom: -2px;
  right: -2px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  border: 2px solid var(--bg-primary);
  transition: all var(--transition-fast);
}

.status-dot.location-sharing {
  width: 14px;
  height: 14px;
  bottom: -4px;
  right: -4px;
  animation: pulse-glow 2s ease-in-out infinite;
}

@keyframes pulse-glow {
  0%,
  100% {
    box-shadow: 0 0 4px rgba(59, 130, 246, 0.5);
  }
  50% {
    box-shadow: 0 0 8px rgba(59, 130, 246, 0.8);
  }
}

.status-dot.pulse {
  animation: pulse 2s infinite;
}

.install-badge {
  position: absolute;
  bottom: -2px;
  left: -2px;
  width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: var(--font-size-xs);
  background: var(--bg-primary);
  border-radius: 50%;
  border: 2px solid var(--bg-primary);
}

.install-badge.pulse {
  animation: installPulse 2.5s ease-out infinite;
}

@keyframes installPulse {
  0% {
    box-shadow: 0 0 0 0 rgba(62, 106, 225, 1);
    opacity: 1;
  }
  35% {
    box-shadow: 0 0 0 6px rgba(62, 106, 225, 0.7);
    opacity: 0.85;
  }
  60% {
    box-shadow: 0 0 0 7px rgba(62, 106, 225, 0);
    opacity: 0.7;
  }
  100% {
    box-shadow: 0 0 0 7px rgba(62, 106, 225, 0);
    opacity: 1;
  }
}

@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 currentColor;
    opacity: 1;
  }
  70% {
    box-shadow: 0 0 0 6px transparent;
    opacity: 0.7;
  }
  100% {
    box-shadow: 0 0 0 0 transparent;
    opacity: 1;
  }
}

.menu-overlay {
  position: fixed;
  inset: 0;
  z-index: var(--z-modal);
}

.menu-dropdown {
  position: absolute;
  top: calc(100% + var(--spacing-sm));
  right: 0;
  min-width: 280px;
  max-height: calc(100vh - 60px);
  background: var(--bg-modal);
  backdrop-filter: blur(40px) saturate(150%);
  -webkit-backdrop-filter: blur(40px) saturate(150%);
  border-radius: 16px;
  overflow-y: auto;
  z-index: var(--z-modal);
  box-shadow: 0 10px 40px var(--bg-overlay);
  animation: slideDown var(--transition-fast);
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Center menu on smaller screens */
@media (max-width: 480px) {
  .menu-dropdown {
    position: fixed;
    top: 60px;
    left: 50%;
    right: auto;
    transform: translateX(-50%);
    animation: slideDownCentered var(--transition-fast);
  }

  @keyframes slideDownCentered {
    from {
      opacity: 0;
      transform: translateX(-50%) translateY(-10px);
    }
    to {
      opacity: 1;
      transform: translateX(-50%) translateY(0);
    }
  }
}

/* Update banner */
.update-banner {
  padding: 10px 12px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: var(--text-on-accent);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.update-content {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
}

.update-icon {
  font-size: var(--font-size-md);
}

.update-text {
  font-size: 13px;
  font-weight: 500;
}

.update-actions {
  display: flex;
  gap: 4px;
}

.update-btn {
  padding: 4px 10px;
  background: rgba(255, 255, 255, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 6px;
  color: var(--text-on-accent);
  font-size: 11px;
  font-weight: 500;
  cursor: pointer;
  transition: all var(--transition-fast);
}

.update-btn:hover {
  background: rgba(255, 255, 255, 0.35);
}

.dismiss-btn {
  background: transparent;
  border: none;
  color: var(--text-on-accent);
  font-size: var(--font-size-lg);
  cursor: pointer;
  opacity: 0.7;
  transition: opacity var(--transition-fast);
  padding: 0 4px;
}

.dismiss-btn:hover {
  opacity: 1;
}

.menu-header {
  padding: var(--spacing-lg);
  background: var(--bg-subtle);
  position: relative;
}

.menu-header-close {
  position: absolute;
  top: 0;
  right: 0;
  background: transparent;
  border: none;
  color: var(--text-secondary);
  font-size: 28px;
  line-height: 1;
  cursor: pointer;
  opacity: 0.7;
  transition: opacity var(--transition-fast);
  padding: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.menu-header-close:hover {
  opacity: 1;
}

/* User details section */
.user-details {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
}

.user-avatar-large {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  background: var(--accent);
  color: var(--text-on-accent);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: var(--font-size-lg);
  font-weight: 600;
}

.user-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1;
  width: 240px;
}

.user-name {
  font-size: var(--font-size-md);
  font-weight: 600;
  color: var(--text-primary);
  letter-spacing: -0.01em;
}

.user-email {
  font-size: var(--font-size-sm);
  color: var(--text-secondary);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Status grid */
.status-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  padding: 12px;
  background: rgba(255, 255, 255, 0.02);
  border-radius: 10px;
}

.status-item {
  text-align: center;
}

.status-item-toggle {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.status-item-toggle .status-value {
  display: flex;
  justify-content: center;
  align-items: center;
}

.status-label {
  font-size: var(--font-size-xs);
  text-transform: uppercase;
  color: var(--text-muted);
  letter-spacing: 0.05em;
  margin-bottom: 4px;
}

.status-label-clickable {
  font-size: var(--font-size-xs);
  text-transform: uppercase;
  color: var(--text-muted);
  letter-spacing: 0.05em;
  margin-bottom: 4px;
  cursor: pointer;
  transition: color var(--transition-fast);
}

.status-label-clickable:hover {
  color: var(--text-primary);
}

.status-value {
  font-size: var(--font-size-sm);
  font-weight: 500;
  color: var(--text-primary);
}

.status-value.online {
  color: var(--success);
}

.status-value.offline {
  color: var(--text-muted);
}

.status-value.warning {
  color: var(--warning);
}

/* Guest state */
.guest-state {
  text-align: center;
  padding: var(--spacing-md) 0;
}

.guest-avatar {
  width: 48px;
  height: 48px;
  margin: 0 auto 12px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.05);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: var(--font-size-xl);
}

.guest-message {
  font-size: var(--font-size-base);
  font-weight: 500;
  color: var(--text-primary);
  margin-bottom: 4px;
}

.guest-submessage {
  font-size: var(--font-size-sm);
  color: var(--text-secondary);
}

.menu-items {
  padding: var(--spacing-sm);
}

.menu-item {
  width: 100%;
  padding: 12px var(--spacing-md);
  background: transparent;
  border: none;
  border-radius: 8px;
  color: var(--text-secondary);
  font-size: var(--font-size-base);
  text-align: left;
  cursor: pointer;
  transition: all var(--transition-fast);
  display: flex;
  align-items: center;
  gap: 12px;
}

.menu-item .menu-icon {
  font-size: var(--font-size-md);
  width: 20px;
  text-align: center;
}

.menu-item:hover {
  background: var(--bg-subtle);
  color: var(--text-primary);
}

.menu-item.logout {
  color: var(--danger);
}

.menu-item.primary {
  background: var(--accent);
  color: var(--text-on-accent);
  font-weight: 500;
  justify-content: center;
  padding: 14px;
}

.menu-item.primary:hover {
  background: var(--accent-bright);
}

.menu-item:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.menu-item:disabled:hover {
  background: transparent;
}

.menu-divider {
  margin: var(--spacing-sm);
  border: none;
  height: 1px;
  background: var(--bg-subtle);
}

/* ============================================================================
   Modals - Clean & Modern
   ============================================================================ */

.modal-overlay,
.login-modal-overlay {
  position: fixed;
  inset: 0;
  background: var(--bg-overlay);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: var(--z-modal);
  animation: fadeIn var(--transition-fast);
}

.modal,
.login-modal {
  position: relative;
  width: 90%;
  max-width: 380px;
  background: var(--bg-modal);
  backdrop-filter: blur(40px) saturate(150%);
  -webkit-backdrop-filter: blur(40px) saturate(150%);
  border-radius: 24px;
  padding: var(--spacing-2xl) var(--spacing-xl) var(--spacing-xl);
  animation: slideUp var(--transition-normal);
  box-shadow: 0 20px 60px var(--bg-overlay);
}

.modal h2,
.login-modal h2 {
  font-size: var(--font-size-xl);
  font-weight: 300;
  margin-bottom: var(--spacing-xl);
  text-align: center;
  letter-spacing: -0.02em;
}

.settings-modal .close-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 48px;
  height: calc(
    var(--spacing-lg) + 8px + 12px + 2px
  ); /* Match tab area height */
  background: transparent;
  border: none;
  color: var(--text-muted);
  font-size: var(--font-size-lg);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all var(--transition-fast);
  z-index: 10;
}

.settings-modal .close-btn:hover {
  background: var(--bg-subtle);
  color: var(--text-primary);
}

.settings-modal .close-btn span {
  transition: transform var(--transition-fast);
}

.settings-modal .close-btn:hover span {
  transform: rotate(90deg);
}

/* ============================================================================
   Forms - Minimal & Clean
   ============================================================================ */

.form-group {
  margin-bottom: var(--spacing-md);
}

input[type="text"],
input[type="email"],
input[type="password"],
input[type="number"],
textarea,
select {
  width: 100%;
  padding: 14px var(--spacing-md);
  background: var(--bg-subtle);
  border: 1px solid transparent;
  border-radius: 12px;
  color: var(--text-primary);
  font-size: var(--font-size-base);
  font-weight: 400;
  transition: all var(--transition-fast);
}

input:focus,
textarea:focus,
select:focus {
  outline: none;
  background: var(--bg-elevated);
  border-color: var(--accent);
}

input:disabled,
textarea:disabled,
select:disabled {
  opacity: 0.3;
  cursor: not-allowed;
}

input::placeholder {
  color: var(--text-muted);
}

.submit-btn {
  width: 100%;
  padding: 14px;
  background: var(--accent);
  border: none;
  border-radius: 100px;
  color: var(--text-on-accent);
  font-size: var(--font-size-sm);
  font-weight: 500;
  letter-spacing: 0.02em;
  cursor: pointer;
  transition: all var(--transition-fast);
  margin-top: var(--spacing-lg);
}

.submit-btn:hover {
  background: var(--accent-bright);
  transform: scale(1.02);
}

.submit-btn:active {
  transform: scale(0.98);
}

.submit-btn:disabled {
  opacity: 0.3;
  cursor: not-allowed;
  transform: none;
}

.text-btn {
  background: transparent;
  border: none;
  color: var(--text-secondary);
  font-size: var(--font-size-sm);
  cursor: pointer;
  padding: var(--spacing-sm);
  transition: opacity var(--transition-fast);
}

.text-btn:hover {
  color: var(--text-primary);
}

.text-btn.guest {
  color: var(--text-muted);
}

.modal-footer {
  margin-top: var(--spacing-xl);
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: var(--spacing-sm);
}

.error-message {
  padding: var(--spacing-sm) var(--spacing-md);
  background: rgba(255, 59, 48, 0.1);
  border-radius: 8px;
  color: var(--danger);
  font-size: var(--font-size-sm);
  margin-bottom: var(--spacing-md);
}

/* ============================================================================
   Panels - Slide-out Design
   ============================================================================ */

.panel {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  width: 320px;
  max-width: 80vw;
  background: var(--bg-overlay);
  backdrop-filter: blur(40px) saturate(150%);
  -webkit-backdrop-filter: blur(40px) saturate(150%);
  transform: translateX(-100%);
  transition: transform var(--transition-normal);
  z-index: var(--z-controls);
  overflow-y: auto;
}

.panel.open {
  transform: translateX(0);
  box-shadow: 0 0 40px var(--shadow-lg);
}

.panel-header {
  padding: var(--spacing-lg);
  background: var(--bg-subtle);
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: sticky;
  top: 0;
  z-index: 1;
}

.panel-title {
  font-size: var(--font-size-md);
  font-weight: 400;
  letter-spacing: -0.02em;
}

.panel-content {
  padding: var(--spacing-lg);
}

/* ============================================================================
   Animations
   ============================================================================ */

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(20px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

/* ============================================================================
   Settings Modal
   ============================================================================ */

.modal.settings-modal {
  position: fixed !important;
  top: 50% !important;
  left: 50% !important;
  transform: translate(-50%, -50%) !important;
  width: min(80vw, calc(100vw - 40px)) !important;
  max-width: none !important;
  height: min(80vh, calc(100vh - 40px)) !important;
  min-height: min(500px, calc(100vh - 80px)) !important;
  overflow: hidden !important;
  display: flex !important;
  flex-direction: column !important;
  padding: 0 !important;
}

@media (max-width: 600px) {
  .modal.settings-modal {
    top: 40px !important;
    left: 10px !important;
    transform: none !important;
    width: calc(100vw - 20px) !important;
    height: calc(100vh - 80px) !important;
    min-height: calc(100vh - 80px) !important;
    border-radius: 6px !important;
  }
}

.settings-modal h2 {
  flex-shrink: 0;
  padding: 0 var(--spacing-xl);
  margin-bottom: var(--spacing-lg);
}

.settings-tabs {
  display: flex;
  gap: 4px;
  margin-bottom: var(--spacing-md);
  flex-shrink: 0;
  border-bottom: 1px solid var(--bg-subtle);
  overflow-x: auto;
  padding: 0 var(--spacing-xl) 0 var(--spacing-xl);
  padding-right: 48px; /* Make room for close button */
  position: relative;
}

.settings-tabs .tab {
  padding: var(--spacing-lg) 12px 8px 12px; /* Extra top padding for larger click area */
  background: transparent;
  border: none;
  border-bottom: 2px solid transparent;
  color: var(--text-secondary);
  font-size: var(--font-size-sm);
  font-weight: 500;
  cursor: pointer;
  transition: all var(--transition-fast);
  white-space: nowrap;
}

.settings-tabs .tab:hover {
  color: var(--text-primary);
}

.settings-tabs .tab.active {
  color: var(--accent);
  border-bottom-color: var(--accent);
}

.settings-content {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 0 var(--spacing-xl) var(--spacing-xl) var(--spacing-xl);
}

/* Custom scrollbar for settings */
.settings-content::-webkit-scrollbar {
  width: 6px;
}

.settings-content::-webkit-scrollbar-track {
  background: transparent;
}

.settings-content::-webkit-scrollbar-thumb {
  background: var(--bg-subtle);
  border-radius: 3px;
}

/* Activity detail modal with full map background */
.modal.activity-detail-modal {
  padding: 0 !important;
  background: transparent !important;
  backdrop-filter: none !important;
  -webkit-backdrop-filter: none !important;
}

/* Ensure embedded maps fill their containers */
.embedded-map .ol-viewport {
  position: absolute !important;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
  width: 100% !important;
  height: 100% !important;
}

.settings-content::-webkit-scrollbar-thumb:hover {
  background: var(--border);
}

.settings-section {
  display: flex;
  flex-direction: column;
}

.settings-group-header {
  font-size: var(--font-size-md);
  font-weight: 700;
  color: var(--text-primary);
  margin: var(--spacing-2xl) calc(var(--spacing-xl) * -1) var(--spacing-lg)
    calc(var(--spacing-xl) * -1);
  padding: var(--spacing-md) var(--spacing-xl);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-left: 4px solid var(--accent);
  background: var(--bg-subtle);
}

.settings-group-header:first-child {
  margin-top: 0;
}

/* Setting Row with Toggle */
.setting-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--spacing-md) 0;
}

/* Ensure slider comes before toggle on larger screens */
.setting-row .slider-controls {
  order: 1;
}

.setting-row .toggle-button {
  order: 2;
}

@media (max-width: 500px) {
  .setting-row {
    flex-wrap: wrap;
  }

  .setting-info {
    margin-right: var(--spacing-sm);
    min-width: auto;
    flex: 1;
  }

  .setting-row .setting-description {
    display: none;
  }

  /* Stack slider controls below on mobile */
  .setting-row .slider-controls {
    order: 3;
    width: 100%;
    margin-top: var(--spacing-sm);
    justify-content: flex-start !important;
  }

  .setting-row .toggle-button {
    order: 2;
  }
}

.setting-info {
  flex: 1;
  margin-right: var(--spacing-lg);
  min-width: 200px;
}

.setting-label {
  font-size: var(--font-size-base);
  font-weight: 500;
  color: var(--text-primary);
  margin-bottom: 2px;
}

.setting-row .setting-description {
  font-size: var(--font-size-sm);
  color: var(--text-secondary);
  margin: 0;
  line-height: 1.3;
}

/* Toggle Switch */
.toggle-button {
  position: relative;
  width: 48px;
  height: 26px;
  background: var(--bg-subtle);
  border: 1px solid var(--border);
  border-radius: 13px;
  cursor: pointer;
  transition: all var(--transition-fast);
  padding: 0;
  flex-shrink: 0;
}

.toggle-button.checked {
  background: var(--accent);
  border-color: var(--accent);
}

.toggle-slider {
  position: absolute;
  top: 2px;
  left: 2px;
  width: 20px;
  height: 20px;
  background: var(--bg-button-slider);
  border-radius: 50%;
  box-shadow: 0 2px 4px var(--shadow-sm);
  transition: all var(--transition-fast);
}

.toggle-button.checked .toggle-slider {
  transform: translateX(22px);
}

/* High contrast light theme - add white border to knob */
.theme-high-contrast-light .toggle-slider {
  border: 1px solid #ffffff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

/* Traditional Setting Groups */
.setting-group {
  display: flex;
  flex-direction: column;
  flex: 1;
}

.setting-group > label {
  display: block;
  font-size: var(--font-size-sm);
  font-weight: 500;
  color: var(--text-primary);
  margin-bottom: var(--spacing-sm);
}

.setting-group select {
  width: 100%;
  padding: 10px 12px;
  background: var(--bg-subtle);
  border: 1px solid var(--border-light);
  border-radius: 8px;
  color: var(--text-primary);
  font-size: var(--font-size-sm);
  cursor: pointer;
}

/* Slider Settings */
.slider-setting {
  padding: var(--spacing-sm) 0;
  border-bottom: 1px solid var(--border);
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.slider-setting label {
  color: var(--text-primary);
  font-size: var(--font-size-base);
  font-weight: 500;
  margin-right: var(--spacing-md);
  flex-shrink: 0;
}

.slider-setting input[type="range"],
.opacity-slider,
.track-width-slider {
  width: 150px;
  height: 4px;
  background: var(--bg-subtle);
  border-radius: 2px;
  outline: none;
  -webkit-appearance: none;
  border: none;
}

.track-width-slider {
  background: var(--track-color, #3e6ae1) !important;
  height: var(--track-width, 4px) !important;
  border-radius: calc(var(--track-width, 4px) / 2) !important;
  min-height: 1px !important;
  max-height: 15px !important;
  box-shadow: var(
    --track-outline,
    0 0 0 1px #ffffff
  ) !important; /* White outline if enabled */
}

.slider-setting input[type="range"]::-webkit-slider-thumb,
.opacity-slider::-webkit-slider-thumb,
.track-width-slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  width: 20px;
  height: 20px;
  background: var(--accent);
  border-radius: 50%;
  cursor: pointer;
  box-shadow: 0 2px 4px var(--shadow-sm);
  border: none;
}

.slider-setting input[type="range"]::-moz-range-thumb,
.opacity-slider::-moz-range-thumb,
.track-width-slider::-moz-range-thumb {
  width: 20px;
  height: 20px;
  background: var(--accent);
  border-radius: 50%;
  cursor: pointer;
  box-shadow: 0 2px 4px var(--shadow-sm);
  border: none;
}

.setting-description {
  font-size: var(--font-size-sm);
  color: var(--text-secondary);
  line-height: 1.5;
  margin: 4px 0;
}

.setting-description a {
  color: var(--accent);
  text-decoration: none;
}

.setting-description a:hover {
  text-decoration: underline;
}

.radio-group {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-sm);
}

.radio-group label {
  display: flex;
  align-items: center;
  gap: var(--spacing-sm);
  margin-bottom: 0;
  font-weight: normal;
}

/* Map Styles Section */
.map-category {
  font-size: var(--font-size-sm);
  font-weight: 600;
  color: var(--text-secondary);
  margin: var(--spacing-lg) 0 var(--spacing-sm) 0;
  display: flex;
  align-items: center;
  gap: var(--spacing-sm);
}

.api-badge {
  font-size: var(--font-size-xs);
  background: var(--accent);
  color: var(--text-on-accent);
  padding: 2px 6px;
  border-radius: 4px;
}

.map-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--spacing-sm);
  margin-bottom: var(--spacing-md);
}

.map-style-button {
  padding: var(--spacing-sm);
  border-radius: 8px;
  border: 1px solid var(--border);
  background: transparent;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  text-align: left;
  position: relative;
  transition: all var(--transition-fast);
  color: var(--text-primary);
}

.map-style-button.selected {
  border-color: var(--accent);
  background: var(--bg-subtle);
}

.map-style-button.unavailable {
  opacity: 0.5;
  cursor: not-allowed;
}

.map-style-button:hover:not(.unavailable) {
  border-color: var(--accent);
}

.map-style-info {
  flex: 1;
}

.map-style-name {
  font-size: 13px;
  font-weight: 500;
  color: var(--text-primary);
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px;
  white-space: nowrap;
}

.map-style-desc {
  font-size: var(--font-size-xs);
  color: var(--text-secondary);
  margin-top: 2px;
}

.star-icon {
  font-size: var(--font-size-base);
  opacity: 0.3;
  transition: opacity var(--transition-fast);
}

.star-icon.starred {
  opacity: 1;
}

.lock-icon {
  font-size: var(--font-size-xs);
}

.api-key-input {
  display: flex;
  gap: var(--spacing-sm);
  align-items: center;
}

.api-key-input input {
  flex: 1;
}

.api-key-input .btn {
  padding: 10px 20px;
  background: var(--accent);
  color: var(--text-on-accent);
  border: none;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all var(--transition-fast);
}

.api-key-input .btn:hover {
  background: var(--accent-bright);
}

/* Help Section Styles */
.help-section {
  margin-bottom: var(--spacing-xl);
}

.help-section-title {
  font-size: var(--font-size-base);
  font-weight: 600;
  color: var(--text-primary);
  margin-bottom: var(--spacing-md);
}

.help-content {
  font-size: var(--font-size-sm);
  color: var(--text-secondary);
  line-height: 1.6;
}

.help-content p {
  margin-bottom: var(--spacing-md);
}

.help-content ul {
  margin: var(--spacing-md) 0;
  padding-left: var(--spacing-xl);
}

.help-content li {
  margin-bottom: var(--spacing-sm);
}

.help-content strong {
  color: var(--text-primary);
  font-weight: 600;
}

.help-image-placeholder {
  background: var(--bg-subtle);
  border: 2px dashed var(--border);
  border-radius: 8px;
  padding: var(--spacing-xl);
  margin: var(--spacing-md) 0;
  text-align: center;
  color: var(--text-secondary);
  font-size: 13px;
  font-style: italic;
}

/* ============================================================================
   Dynamic Island - iOS-style expandable notification
   ============================================================================ */

.dynamic-island {
  position: fixed;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  transform-origin: top center;
  z-index: calc(var(--z-modal) + 100);
  background: var(--bg-glass);
  backdrop-filter: blur(40px) saturate(150%);
  -webkit-backdrop-filter: blur(40px) saturate(150%);
  border-radius: 0 0 20px 20px;
  overflow: visible;
  animation: dynamicIslandSlideDown 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94)
    forwards;
  transition:
    width 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94),
    height 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94),
    background 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94),
    transform 0.2s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  pointer-events: auto;
  cursor: pointer;
  width: 200px;
  height: 36px;
  box-shadow: 0 4px 20px var(--shadow-md);
}

.dynamic-island.expanded {
  width: 380px;
  max-width: calc(100vw - 20px);
  height: 200px;
  background: var(--bg-glass-strong);
  cursor: default;
  padding-top: 0;
}

.dynamic-island:hover:not(.expanded) {
  transform: translateX(-50%) scale(1.05);
}

.dynamic-island.notification {
  border: 1px solid rgba(62, 106, 225, 0.3);
}

.dynamic-island.warning {
  border: 1px solid rgba(255, 149, 0, 0.3);
}

.dynamic-island.success {
  border: 1px solid rgba(0, 210, 0, 0.3);
}

.island-compact-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 0;
}

.island-compact {
  padding: 13px var(--spacing-sm) var(--spacing-xs);
  display: flex;
  align-items: center;
  gap: 0;
  min-height: 30px;
  width: 100%;
  transform-origin: top center;
}

.island-compact:hover {
  background: rgba(255, 255, 255, 0.05);
}

.island-compact-left {
  display: flex;
  align-items: center;
  gap: var(--spacing-xs);
}

.island-compact-icon {
  font-size: var(--font-size-base);
  width: 16px;
  text-align: center;
}

.island-compact-text {
  font-size: 11px;
  font-weight: 600;
  color: var(--text-primary);
  white-space: nowrap;
}

.island-compact-center {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--spacing-xs);
  min-width: 0; /* Allow shrinking */
}

.island-compact-progress {
  flex: 1;
  height: 2px;
  background: rgba(255, 255, 255, 0.15);
  border-radius: 1px;
  overflow: hidden;
  max-width: 60px;
}

.island-compact-progress-fill {
  height: 100%;
  background: var(--accent);
  transition: width var(--transition-fast);
  border-radius: 1px;
}

.island-compact-progress-fill.sim {
  background: rgba(255, 193, 7, 0.9);
}

.island-compact-right {
  display: flex;
  align-items: center;
  gap: var(--spacing-xs);
}

.island-compact-stat {
  font-size: var(--font-size-xs);
  font-weight: 500;
  color: var(--text-secondary);
  white-space: nowrap;
}

.island-compact-percentage {
  font-size: var(--font-size-xs);
  font-weight: 600;
  color: var(--text-primary);
  white-space: nowrap;
}

.dynamic-island-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: calc(var(--z-modal) + 99);
  background: transparent;
  cursor: pointer;
}

.island-expanded-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  overflow: hidden;
}

.island-expanded-content {
  padding: 0;
  width: 380px;
  height: 200px;
  transform-origin: top center;
  flex-shrink: 0;
  box-sizing: border-box;
}

.island-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: var(--spacing-md);
  padding: var(--spacing-sm);
}

.island-header-content {
  display: flex;
  align-items: center;
  gap: var(--spacing-sm);
  flex: 1;
}

.island-icon {
  font-size: var(--font-size-md);
  width: 20px;
  text-align: center;
}

.island-text {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.island-title {
  font-size: var(--font-size-sm);
  font-weight: 600;
  color: var(--text-primary);
  line-height: 1.2;
}

.island-subtitle {
  font-size: var(--font-size-xs);
  color: var(--text-secondary);
  line-height: 1.2;
}

.island-actions {
  display: flex;
  gap: 4px;
  align-items: center;
}

.island-btn {
  padding: 6px 12px;
  border: none;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.1);
  color: var(--text-primary);
  font-size: 11px;
  font-weight: 500;
  cursor: pointer;
  transition: all var(--transition-fast);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  min-width: 50px;
}

.island-btn:hover {
  background: rgba(255, 255, 255, 0.2);
}

.island-btn.primary {
  background: var(--accent);
  color: var(--text-on-accent);
}

.island-btn.primary:hover {
  background: var(--accent-bright);
}

.island-btn.stop {
  background: rgba(255, 59, 48, 0.2);
  color: var(--danger);
}

.island-btn.stop:hover {
  background: rgba(255, 59, 48, 0.3);
}

.island-close {
  width: 40px;
  height: 40px;
  border: none;
  background: none;
  color: var(--text-secondary);
  cursor: pointer;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px; /* Larger × symbol for easier clicking */
  transition: all var(--transition-fast);
  margin-left: var(--spacing-xs);
  margin-right: -8px; /* Expand clickable area to the edge */
  margin-top: -6px;
  margin-bottom: -6px;
}

.island-close:hover {
  background: rgba(255, 255, 255, 0.1);
  color: var(--text-primary);
}

.island-close-btn {
  width: 40px !important;
  height: 40px !important;
  font-size: 22px !important;
  background: none;
  border: none;
  color: var(--text-secondary);
  cursor: pointer;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: all var(--transition-fast);
  padding: 0 !important;
  margin: -6px -8px -6px -4px !important; /* Expand clickable area: top right bottom left */
}

.island-close-btn:hover {
  background: rgba(255, 255, 255, 0.1) !important;
  color: var(--text-primary);
}

.island-details {
  padding: 0 var(--spacing-md) var(--spacing-sm) var(--spacing-md);
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  background: rgba(255, 255, 255, 0.02);
}

.island-progress {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: var(--spacing-xs);
}

.island-progress-text {
  font-size: var(--font-size-xs);
  color: var(--text-secondary);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.island-progress-bar {
  flex: 1;
  height: 2px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 1px;
  margin: 0 var(--spacing-sm);
  overflow: hidden;
}

.island-progress-fill {
  height: 100%;
  background: var(--accent);
  transition: width var(--transition-fast);
  border-radius: 1px;
}

.island-progress-fill.sim {
  background: rgba(255, 193, 7, 0.8);
}

.island-stats {
  display: flex;
  justify-content: space-between;
  font-size: var(--font-size-xs);
  color: var(--text-secondary);
}

.island-stat {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
}

.island-stat-value {
  font-weight: 600;
  color: var(--text-primary);
}

.island-stat-label {
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

@keyframes dynamicIslandSlideDown {
  from {
    opacity: 0;
    transform: translateX(-50%) translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateX(-50%) translateY(0);
  }
}

/* always fixed size */
.dynamic-island {
  width: 160px;
  height: 40px;
}

/* Mobile responsive */
@media (max-width: 600px) {
  .dynamic-island {
    width: 160px;
    height: 40px;
  }

  /* .dynamic-island.expanded {
    width: calc(100vw - 20px);
    max-width: calc(100vw - 20px);
  } */

  .island-title {
    font-size: var(--font-size-sm);
  }

  .island-subtitle {
    font-size: var(--font-size-xs);
  }

  .island-btn {
    padding: 6px 12px;
    font-size: 11px;
    min-width: 50px;
  }

  .island-actions {
    gap: 4px;
  }
}

/* ============================================================================
   Utility Classes
   ============================================================================ */

.hidden {
  display: none !important;
}

.text-center {
  text-align: center;
}

.text-muted {
  color: var(--text-secondary);
}

/* ============================================================================
   Responsive Design
   ============================================================================ */

@media (max-width: 768px) {
  .header {
    padding: 0 var(--spacing-md);
  }

  .activity-bar {
    bottom: var(--spacing-md);
    width: calc(100vw - var(--spacing-xl));
    border-radius: 20px;
  }

  .metrics {
    gap: var(--spacing-lg);
  }

  .metric-value {
    font-size: 28px;
  }

  /* Compact layout responsive */
  .activity-bar--compact {
    width: calc(100vw - var(--spacing-lg));
  }

  .activity-bar--compact .metric-value {
    font-size: var(--font-size-lg);
  }

  .activity-bar--compact .metrics {
    gap: var(--spacing-sm);
  }

  /* Overlay layout responsive */
  .activity-bar--overlay {
    width: calc(100vw - var(--spacing-lg));
    padding: var(--spacing-xs) var(--spacing-lg);
    gap: var(--spacing-lg);
  }

  .metric-value-hero {
    font-size: 144px;
  }

  .metric-label-hero {
    font-size: 32px;
  }

  .metric-value-secondary {
    font-size: 26px;
  }

  .control-btn-overlay {
    font-size: var(--font-size-sm);
    padding: 8px 16px;
    min-width: 75px;
  }

  .modal,
  .login-modal {
    width: 95%;
    padding: var(--spacing-xl) var(--spacing-lg) var(--spacing-lg);
  }

  .panel {
    width: 100%;
    max-width: 100%;
  }
}

/* Map button styling */
.map-cycle-btn {
  display: flex;
  align-items: center;
  gap: var(--spacing-xs);
}

.map-icon {
  font-size: 16px;
  line-height: 1;
  display: inline-block;
}

.map-name {
  max-width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

@media (max-width: 480px) {
  .map-cycle-btn {
    padding: var(--spacing-sm);
    min-width: auto;
    width: auto;
    max-width: 90px;
    height: 32px;
    border-radius: 16px;
    justify-content: center;
    gap: var(--spacing-xs);
  }

  .map-icon {
    font-size: 14px;
  }

  .map-name {
    max-width: 50px;
  }

  .activity-bar {
    padding: var(--spacing-md);
  }

  .metric-value {
    font-size: var(--font-size-xl);
  }

  /* Compact layout - extra small screens */
  .activity-bar--compact {
    padding: var(--spacing-xs) var(--spacing-sm);
    border-radius: 16px;
  }

  .activity-bar--compact .metric {
    min-width: 50px;
  }

  .activity-bar--compact .metric-value {
    font-size: var(--font-size-lg);
  }

  .activity-bar--compact .metric-label {
    font-size: 7px;
  }

  .activity-bar--compact .control-btn {
    padding: 6px 16px;
    font-size: 11px;
    min-width: 70px;
  }

  /* Overlay layout - extra small screens */
  .activity-bar--overlay {
    padding: var(--spacing-xs) var(--spacing-md);
    border-radius: 16px;
    gap: var(--spacing-md);
  }

  .metric-value-hero {
    font-size: 128px;
  }

  .metric-label-hero {
    font-size: 28px;
  }

  .metric-value-secondary {
    font-size: var(--font-size-lg);
  }

  .metric-label-secondary {
    font-size: 9px;
  }

  .control-btn-overlay {
    padding: 8px 14px;
    font-size: 11px;
    min-width: 65px;
  }
}

/* ============================================================================
   Debug Console - Allow Text Selection
   ============================================================================ */

/* Allow text selection in debug console and related elements */
.debug-console,
.debug-console *,
.debug-object,
pre {
  -webkit-user-select: text !important;
  -moz-user-select: text !important;
  -ms-user-select: text !important;
  user-select: text !important;
}

.debug-console *[style*="display: none"],
.debug-console *[id^="caret-stack-"] {
  -webkit-user-select: none !important;
  -moz-user-select: none !important;
  -ms-user-select: none !important;
  user-select: none !important;
}

/* Debug Console Scrollbars */
.debug-console-scroll {
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.3) rgba(255, 255, 255, 0.1);
  overflow-y: scroll !important;
  overflow-x: hidden !important;
}

.debug-console-scroll::-webkit-scrollbar {
  width: 8px;
  height: 8px;
  -webkit-appearance: none;
}

.debug-console-scroll::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 4px;
}

.debug-console-scroll::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.3);
  border-radius: 4px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  min-height: 20px;
}

.debug-console-scroll::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.5);
}

.debug-console-scroll::-webkit-scrollbar-corner {
  background: rgba(255, 255, 255, 0.1);
}

/* Make stack trace arrows inherit container font size */
.debug-console-scroll [id*="caret-"] {
  font-size: inherit !important;
  margin-top: 0 !important;
  line-height: inherit !important;
}

/* Hide VSCode file links on small screens - only the right-side file link divs */
@media (max-width: 768px) {
  .debug-console-scroll
    div[style*="margin-left: auto"][style*="padding-left: 8px"] {
    display: none !important;
  }
}

/* ============================================================================
   Activity Detail View
   ============================================================================ */

.activity-detail-header {
  position: absolute;
  top: var(--spacing-lg);
  left: 70px; /* Account for fit button */
  right: 70px; /* Account for close button */
  width: auto;
  margin: 0 auto;
  max-width: 400px;
  background: var(--bg-overlay);
  backdrop-filter: blur(40px) saturate(150%);
  -webkit-backdrop-filter: blur(40px) saturate(150%);
  border-radius: 16px;
  padding: 4px 12px;
  pointer-events: auto;
}

.activity-detail-header h2 {
  margin: 0;
  padding: 0 !important; /* Override any inherited padding */
  color: var(--text-primary);
  font-size: 1.1rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: left;
}

.activity-detail-stats {
  position: absolute;
  bottom: var(--spacing-lg);
  left: var(--spacing-lg);
  right: var(--spacing-lg);
  width: auto;
  margin: 0 auto;
  max-width: fit-content;
  background: var(--bg-overlay);
  backdrop-filter: blur(40px) saturate(150%);
  -webkit-backdrop-filter: blur(40px) saturate(150%);
  border-radius: 16px;
  padding: 12px 20px;
  pointer-events: auto;
}

.activity-detail-stats-grid {
  display: flex;
  gap: 24px;
  justify-content: center;
}

.activity-detail-stat {
  text-align: center;
  white-space: nowrap;
  flex-shrink: 1;
}

.activity-detail-stat-label {
  font-size: var(--font-size-xs);
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: var(--text-muted);
  margin-bottom: 2px;
  line-height: 1;
  opacity: 0.7;
}

.activity-detail-stat-value {
  font-size: var(--font-size-lg);
  font-weight: 300;
  color: var(--text-primary);
  line-height: 1.1;
}

/* Distance and Duration - larger */
.activity-detail-stat:nth-child(1) .activity-detail-stat-value,
.activity-detail-stat:nth-child(2) .activity-detail-stat-value {
  font-size: var(--font-size-xl);
}

/* Avg Speed and Max Speed - smaller */
.activity-detail-stat:nth-child(3) .activity-detail-stat-value,
.activity-detail-stat:nth-child(4) .activity-detail-stat-value {
  font-size: var(--font-size-lg);
}

/* Responsive adjustments - only layout changes, not font sizes */
@media (max-width: 600px) {
  .activity-detail-stats {
    padding: var(--spacing-md);
  }

  .activity-detail-stats-grid {
    gap: var(--spacing-md);
    flex-wrap: wrap;
  }

  /* All stats wrap to 2x2 grid */
  .activity-detail-stat {
    flex: 1 1 calc(50% - var(--spacing-md) / 2);
    min-width: 0;
  }
}

/* ============================================================================
   Persistent Quick Island - Always visible mini control center
   ============================================================================ */

.persistent-quick-island {
  position: fixed;
  top: 8px;
  left: 50%;
  transform: translateX(-50%);
  z-index: calc(var(--z-modal) + 50);
  background: var(--bg-glass-strong);
  backdrop-filter: blur(40px) saturate(150%);
  -webkit-backdrop-filter: blur(40px) saturate(150%);
  border-radius: 100px;
  padding: 4px 8px;
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 280px;
  height: 40px;
  box-shadow: 0 4px 20px var(--shadow-md);
  transition: all var(--transition-fast);
}

.quick-island-items {
  display: flex;
  align-items: center;
  gap: 4px;
}

.quick-island-items.left {
  flex: 1;
  justify-content: flex-end;
}

.quick-island-items.right {
  flex: 1;
  justify-content: flex-start;
}

.quick-island-clock {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 12px;
  min-width: 80px;
}

.clock-time {
  font-size: 13px;
  font-weight: 600;
  color: var(--text-primary);
  font-variant-numeric: tabular-nums;
  letter-spacing: -0.01em;
}

.quick-island-item {
  position: relative;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: transparent;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all var(--transition-fast);
  padding: 0;
}

.quick-island-item:hover {
  background: var(--bg-subtle);
  transform: scale(1.1);
}

.quick-island-item:active {
  transform: scale(0.95);
}

.quick-island-item.active {
  background: rgba(var(--accent-rgb, 62, 106, 225), 0.2);
}

.quick-island-item.pulse {
  animation: quickIslandPulse 2s ease-in-out infinite;
}

@keyframes quickIslandPulse {
  0%,
  100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.7;
    transform: scale(0.95);
  }
}

.quick-island-item.expanded {
  background: var(--bg-elevated);
}

.quick-island-icon {
  font-size: var(--font-size-md);
  z-index: 2;
  position: relative;
}

.quick-island-badge {
  position: absolute;
  top: -2px;
  right: -2px;
  background: var(--danger);
  color: var(--text-on-accent);
  font-size: 9px;
  font-weight: 600;
  padding: 1px 4px;
  border-radius: 10px;
  min-width: 14px;
  text-align: center;
  z-index: 3;
}

.progress-ring {
  pointer-events: none;
}

/* Detail view that expands from clicked item */
.quick-island-detail-view {
  position: fixed;
  top: 60px;
  left: 50%;
  transform: translateX(-50%);
  z-index: calc(var(--z-modal) + 45);
  background: var(--bg-modal);
  backdrop-filter: blur(40px) saturate(150%);
  -webkit-backdrop-filter: blur(40px) saturate(150%);
  border-radius: 20px;
  padding: var(--spacing-lg);
  min-width: 320px;
  max-width: 420px;
  box-shadow: 0 10px 40px var(--bg-overlay);
  animation: expandIn var(--transition-normal);
}

@keyframes expandIn {
  from {
    opacity: 0;
    transform: translateX(-50%) translateY(-10px) scale(0.9);
  }
  to {
    opacity: 1;
    transform: translateX(-50%) translateY(0) scale(1);
  }
}

.detail-view-close {
  position: absolute;
  top: 12px;
  right: 12px;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: var(--bg-subtle);
  border: none;
  color: var(--text-secondary);
  font-size: var(--font-size-lg);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all var(--transition-fast);
  padding: 0;
  line-height: 1;
}

.detail-view-close:hover {
  background: rgba(255, 255, 255, 0.2);
  color: var(--text-primary);
  transform: rotate(90deg);
}

/* Map styles selector overlay */
.map-styles-overlay {
  position: fixed;
  top: 60px;
  left: 50%;
  transform: translateX(-50%);
  z-index: calc(var(--z-modal) + 48);
  background: rgba(10, 10, 10, 0.98);
  backdrop-filter: blur(40px) saturate(150%);
  -webkit-backdrop-filter: blur(40px) saturate(150%);
  border-radius: 20px;
  padding: var(--spacing-md);
  width: min(90vw, 480px);
  max-width: 480px;
  box-shadow: 0 10px 40px var(--shadow-lg);
  animation: slideUpFast var(--transition-fast);
}

@keyframes slideUpFast {
  from {
    opacity: 0;
    transform: translateX(-50%) translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateX(-50%) translateY(0);
  }
}

.map-styles-header {
  font-size: var(--font-size-sm);
  font-weight: 600;
  color: var(--text-secondary);
  text-transform: uppercase;
  letter-spacing: 0.1em;
  margin-bottom: var(--spacing-md);
  text-align: center;
}

.map-styles-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
  gap: 8px;
  max-height: calc(100vh - 160px);
  overflow-y: auto;
  padding: 4px;
}

.map-styles-grid::-webkit-scrollbar {
  width: 4px;
}

.map-styles-grid::-webkit-scrollbar-track {
  background: transparent;
}

.map-styles-grid::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 2px;
}

.map-style-option {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  padding: 8px 4px;
  background: transparent;
  border: 1px solid transparent;
  border-radius: 12px;
  cursor: pointer;
  transition: all var(--transition-fast);
  position: relative;
  min-height: fit-content;
  gap: 4px;
}

.map-style-option:hover:not(.unavailable) {
  background: rgba(255, 255, 255, 0.05);
  border-color: rgba(255, 255, 255, 0.2);
}

.map-style-option.current {
  background: rgba(var(--accent-rgb, 62, 106, 225), 0.1);
  border-color: var(--accent);
}

.map-style-option.selected {
  background: rgba(var(--accent-rgb, 62, 106, 225), 0.2);
  border-color: var(--accent-bright);
  transform: scale(0.95);
}

.map-style-option.unavailable {
  opacity: 0.4;
  cursor: not-allowed;
}

.map-style-icon {
  font-size: var(--font-size-xl);
  margin-bottom: 4px;
  flex-shrink: 0;
}

.map-style-name {
  font-size: var(--font-size-xs);
  font-weight: 500;
  color: var(--text-primary);
  text-align: center;
  line-height: 1.2;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding: 0 2px;
  flex: 0 1 auto;
}

.map-style-star {
  position: absolute;
  top: 2px;
  right: 2px;
  font-size: var(--font-size-xs);
}

.map-style-lock {
  position: absolute;
  top: 2px;
  left: 2px;
  font-size: var(--font-size-xs);
  opacity: 0.7;
}

/* ============================================================================
   Alert Popover
   ============================================================================ */

.alert-popover {
  position: fixed;
  bottom: 140px; /* Above activity bar */
  left: 50%;
  transform: translateX(-50%);
  z-index: 999998;
  background: var(--warning);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border-radius: 20px;
  padding: 8px 16px;
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  box-shadow: 0 4px 12px var(--warning);
  animation: pulse 2s ease-in-out infinite;
  font-size: 13px;
  font-weight: 600;
  color: var(--text-primary);
  user-select: none;
  max-width: min(400px, calc(100vw - 48px));
}

.alert-popover--info {
  background: var(--accent);
  box-shadow: 0 4px 12px var(--accent);
}

.alert-popover--success {
  background: var(--success);
  box-shadow: 0 4px 12px var(--success);
}

.alert-popover--danger {
  background: var(--danger);
  box-shadow: 0 4px 12px var(--danger);
}

.alert-popover-icon {
  font-size: var(--font-size-md);
}

.alert-popover-message {
  flex: 1;
  cursor: pointer;
}

.alert-popover-dismiss {
  background: transparent;
  border: none;
  color: var(--text-primary);
  font-size: 24px;
  line-height: 1;
  cursor: pointer;
  padding: 0;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0.8;
  transition: opacity var(--transition-fast);
}

.alert-popover-dismiss:hover {
  opacity: 1;
}

/* ============================================================================
   Search Busy Indicator
   ============================================================================ */

.search-busy-indicator {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 100000;
  background: var(--bg-overlay);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border-radius: 12px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

.search-busy-indicator-spinner {
  width: 40px;
  height: 40px;
  border: 3px solid var(--border);
  border-top: 3px solid var(--text-primary);
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

.search-busy-indicator-text {
  color: var(--text-primary);
  font-size: var(--font-size-base);
}

/* ============================================================================
   Quick Island Inline Components
   ============================================================================ */

.quick-island-icon-btn {
  background: none;
  border: none;
  color: var(--text-primary);
  font-size: 14px;
  padding: 12px 2px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.quick-island-search-icon {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
}

.quick-island-search-spinner {
  position: absolute;
  top: 0;
  left: 0;
  transform: rotate(-90deg);
  animation: spin 1s linear infinite;
}

.quick-island-search-spinner circle {
  stroke: var(--accent-bright);
}

.quick-island-cache-grid {
  display: grid;
  gap: 0.5px;
  padding: 2px;
  background: var(--bg-glass);
  border-radius: 3px;
  position: relative;
  width: 24px;
  height: 24px;
  box-sizing: border-box;
}

.quick-island-cache-cell {
  width: 100%;
  height: 100%;
  border-radius: 1px;
  transition: background 0.3s;
}

.quick-island-cache-cell--cached {
  background: rgba(100, 255, 100, 0.5);
}

.quick-island-cache-cell--failed {
  background: rgba(255, 50, 50, 0.6);
}

.quick-island-cache-cell--fetching {
  background: rgba(50, 100, 50, 0.7);
}

.quick-island-cache-cell--none {
  background: rgba(120, 120, 120, 0.3);
}

.quick-island-cache-dot {
  position: absolute;
  width: 3px;
  height: 3px;
  background: var(--accent);
  border: 0.5px solid var(--bg-elevated);
  border-radius: 50%;
  transform: translate(-50%, -50%);
  pointer-events: none;
  box-shadow: 0 0 3px var(--accent);
}

.quick-island-clock {
  font-size: 24px;
  font-weight: 600;
  line-height: 1;
  padding: 8px 0;
  cursor: pointer;
}

.quick-island-route-icon {
  background: none;
  border: none;
  cursor: pointer;
  padding: 12px 4px;
  color: var(--accent-bright);
  font-size: 18px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.quick-island-route-icon path {
  stroke: var(--accent-bright);
}

.quick-island-placeholder {
  width: 24px;
  padding: 8px 0;
}

/* Wake lock indicator */
.wake-lock-indicator {
  position: fixed;
  top: 60px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 999999;
  background: var(--warning);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border-radius: 20px;
  padding: 8px 16px;
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  box-shadow: 0 4px 12px var(--warning);
  animation: pulse 2s ease-in-out infinite;
  font-size: 13px;
  font-weight: 600;
  color: var(--text-primary);
  user-select: none;
}

.wake-lock-indicator--centered {
  top: 50%;
  transform: translate(-50%, -50%);
}

.wake-lock-indicator-icon {
  font-size: var(--font-size-md);
}

/* ============================================================================
   Activity Context Menu - Theme-aware dropdown menu
   ============================================================================ */

.activity-context-menu {
  background: var(--bg-modal);
  border: 1px solid var(--border);
  border-radius: 8px;
  padding: 4px 0;
  min-width: 200px;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  box-shadow: 0 4px 12px var(--shadow-lg);
}

.activity-context-menu-header {
  padding: 8px 12px;
  font-size: 12px;
  color: var(--text-secondary);
  border-bottom: 1px solid var(--border-light);
}

.activity-context-menu-item {
  display: block;
  width: 100%;
  padding: 8px 12px;
  background: transparent;
  border: none;
  color: var(--text-primary);
  text-align: left;
  cursor: pointer;
  font-size: 13px;
  transition: background var(--transition-fast);
}

.activity-context-menu-item:hover {
  background: var(--bg-subtle);
}

.activity-context-menu-item--danger {
  color: var(--danger);
}

.activity-context-menu-item--danger:hover {
  background: rgba(255, 107, 107, 0.1);
}

/* Mobile responsiveness */
@media (max-width: 480px) {
  .persistent-quick-island {
    min-width: 240px;
    transform: translateX(-50%) scale(0.95);
  }

  .clock-time {
    font-size: 12px;
  }

  .quick-island-clock {
    min-width: 70px;
    padding: 0 8px;
  }

  .quick-island-detail-view {
    width: calc(100vw - 20px);
    max-width: calc(100vw - 20px);
  }

  .map-styles-overlay {
    width: calc(100vw - 20px);
    max-width: calc(100vw - 20px);
    min-width: auto;
  }

  .map-styles-grid {
    grid-template-columns: repeat(auto-fill, minmax(60px, 1fr));
  }
}
`, "",{"version":3,"sources":["webpack://./client/src/App.css"],"names":[],"mappings":"AAAA;;iFAEiF;;AAEjF,kDAAkD;AAClD;EACE,yCAAyC;EACzC,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;;EAEnB,4CAA4C;EAC5C;;cAEY;EACZ,iEAAiE;;EAEjE,wCAAwC;EACxC,oBAAoB,EAAE,sBAAsB;EAC5C,oBAAoB,EAAE,iCAAiC;EACvD,sBAAsB,EAAE,uBAAuB;EAC/C,oBAAoB,EAAE,oBAAoB;EAC1C,oBAAoB,EAAE,+BAA+B;EACrD,oBAAoB,EAAE,mBAAmB;EACzC,qBAAqB,EAAE,qBAAqB;EAC5C,qBAAqB,EAAE,6BAA6B;;EAEpD,6CAA6C;EAC7C,sDAAsD;EACtD,wDAAwD;EACxD,sDAAsD;;EAEtD,gDAAgD;EAChD,UAAU;EACV,gBAAgB;EAChB,eAAe;EACf,eAAe;;EAEf,2CAA2C;EAC3C,qBAAqB;EACrB,sBAAsB;EACtB,sCAAsC;;EAEtC,uBAAuB;EACvB,0CAA0C;EAC1C,sCAAsC;;EAEtC,iBAAiB;EACjB,wBAAwB;EACxB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;;EAEjB,kCAAkC;;EAElC,oBAAoB;EACpB,yBAAyB;EACzB,2BAA2B;EAC3B,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;AACjC;;AAEA;;iFAEiF;;AAEjF,yBAAyB;AACzB;EACE,qBAAqB;EACrB,sBAAsB;EACtB,sCAAsC;EACtC,gCAAgC;EAChC,kCAAkC;EAClC,8BAA8B;EAC9B,qCAAqC;;EAErC,uBAAuB;EACvB,0CAA0C;EAC1C,sCAAsC;;EAEtC,iBAAiB;EACjB,wBAAwB;EACxB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;;EAEjB,kCAAkC;EAClC,yCAAyC;;EAEzC,oBAAoB;EACpB,yBAAyB;EACzB,2BAA2B;EAC3B,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;;EAE/B,sCAAsC;EACtC,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA,gBAAgB;AAChB;EACE,qBAAqB;EACrB,sBAAsB;EACtB,gCAAgC;EAChC,sCAAsC;EACtC,qCAAqC;EACrC,qCAAqC;EACrC,2CAA2C;;EAE3C,uBAAuB;EACvB,oCAAoC;EACpC,gCAAgC;;EAEhC,iBAAiB;EACjB,wBAAwB;EACxB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;;EAEjB,4BAA4B;EAC5B,mCAAmC;;EAEnC,oBAAoB;EACpB,yBAAyB;EACzB,2BAA2B;EAC3B,+BAA+B;EAC/B,gCAAgC;EAChC,+BAA+B;;EAE/B,iEAAiE;EACjE,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA,6BAA6B;AAC7B;EACE,qBAAqB;EACrB,sBAAsB;EACtB,oBAAoB;EACpB,iCAAiC;EACjC,+BAA+B;EAC/B,8BAA8B;EAC9B,sCAAsC;;EAEtC,uBAAuB;EACvB,yBAAyB;EACzB,qBAAqB;;EAErB,iBAAiB;EACjB,wBAAwB;EACxB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;;EAEjB,iBAAiB;EACjB,wBAAwB;EACxB,wCAAwC;EACxC,qBAAqB;;EAErB,oBAAoB;EACpB,yBAAyB;EACzB,2BAA2B;EAC3B,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;;EAE/B,sCAAsC;EACtC,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA,8BAA8B;AAC9B;EACE,qBAAqB;EACrB,sBAAsB;EACtB,oBAAoB;EACpB,uCAAuC;EACvC,qCAAqC;EACrC,oCAAoC;EACpC,4CAA4C;;EAE5C,uBAAuB;EACvB,yBAAyB;EACzB,qBAAqB;;EAErB,iBAAiB;EACjB,wBAAwB;EACxB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;;EAEjB,iBAAiB;EACjB,wBAAwB;EACxB,kCAAkC;EAClC,qBAAqB;;EAErB,oBAAoB;EACpB,yBAAyB;EACzB,2BAA2B;EAC3B,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;;EAE/B,iEAAiE;EACjE,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;;iFAEiF;;AAEjF,4BAA4B;AAC5B;EACE,oBAAoB;EACpB,oBAAoB;EACpB,sBAAsB;EACtB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA,0DAA0D;AAC1D;EACE,oBAAoB;EACpB,oBAAoB;EACpB,sBAAsB;EACtB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA,2BAA2B;AAC3B;EACE,oBAAoB;EACpB,oBAAoB;EACpB,sBAAsB;EACtB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA,yCAAyC;AACzC;EACE;;kCAEgC;AAClC;;AAEA;EACE;;;yCAGuC;AACzC;;AAEA;;iFAEiF;;AAEjF;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;EAChC,6BAA6B;EAC7B,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,wBAAwB;EACxB,mCAAmC;EACnC,kCAAkC;EAClC,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;;iFAEiF;;AAEjF;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,qBAAqB;AACvB;;AAEA;;iFAEiF;;AAEjF;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,4BAA4B;EAC5B,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,4CAA4C;EAC5C,2BAA2B;EAC3B,0CAA0C;EAC1C,kDAAkD;EAClD,YAAY;EACZ,oBAAoB;EACpB,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,sCAAsC;AACxC;;AAEA,qEAAqE;AACrE;EACE;IACE,kCAAkC;IAClC,sBAAsB;EACxB;AACF;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;iFAEiF;;AAEjF;EACE,kBAAkB;EAClB,yBAAyB;EACzB,SAAS;EACT,2BAA2B;EAC3B,0BAA0B;EAC1B,yDAAyD;EACzD,uCAAuC;AACzC;;AAEA;EACE,WAAW;EACX,2BAA2B;EAC3B,2BAA2B;EAC3B,mCAAmC;EACnC,mBAAmB;EACnB,+BAA+B;EAC/B,wCAAwC;AAC1C;;AAEA;EACE,kCAAkC;EAClC,8BAA8B;EAC9B,iCAAiC;AACnC;;AAEA,iCAAiC;;AAEjC,kDAAkD;AAClD;EACE,mCAAmC;AACrC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,yCAAyC;EACzC;;;;;;;;iCAQ+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,8BAA8B;EAC9B,eAAe;AACjB;;AAEA,yCAAyC;AACzC;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,kCAAkC;EAClC,8BAA8B;EAC9B,iCAAiC;AACnC;;AAEA;EACE,gCAAgC;EAChC,aAAa;EACb,kCAAkC;EAClC,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,0CAA0C;EAC1C,2BAA2B;EAC3B,yCAAyC;EACzC;;;;;;;;iCAQ+B;AACjC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,yCAAyC;EACzC,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA,wEAAwE;AACxE;EACE,aAAa;EACb,mCAAmC;EACnC,mBAAmB;EACnB,sBAAsB;EACtB,WAAW;EACX,+BAA+B;EAC/B,2BAA2B;EAC3B,mCAAmC;EACnC,mBAAmB;EACnB,8BAA8B;EAC9B,0CAA0C;AAC5C;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,+BAA+B;EAC/B,8BAA8B;EAC9B,iCAAiC;EACjC,+BAA+B;EAC/B,gCAAgC;AAClC;;AAEA,oCAAoC;AACpC;EACE,qCAAqC;EACrC,oCAAoC;AACtC;;AAEA;EACE,qCAAqC;AACvC;;AAEA,mCAAmC;AACnC;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA,oCAAoC;AACpC;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;EACrC,oCAAoC;AACtC;;AAEA;EACE,qCAAqC;AACvC;;AAEA,2DAA2D;AAC3D;;EAEE;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;iCAgF+B;AACjC;;AAEA;;EAEE;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;iCAgF+B;AACjC;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA,uDAAuD;AACvD;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB,EAAE,oCAAoC;EAC7D,cAAc;EACd,0BAA0B;EAC1B,mBAAmB;EACnB,iDAAiD;EACjD;;;;;;;;;;;;;;;;;;;;;;;;iCAwB+B;AACjC;;AAEA,0BAA0B;AAC1B;EACE,gBAAgB;EAChB,wBAAwB;EACxB,qCAAqC;EACrC;;;;;;;;iCAQ+B;AACjC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,uBAAuB,EAAE,iDAAiD;EAC1E,qBAAqB,EAAE,qCAAqC;AAC9D;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,0BAA0B;EAC1B,mBAAmB;EACnB;;;;;;;;;;;;;;;;;;;;;;;;iCAwB+B;AACjC;;AAEA,iDAAiD;AACjD;EACE,aAAa;EACb,uBAAuB;EACvB,OAAO;EACP,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,0CAA0C;EAC1C,2BAA2B;EAC3B,cAAc;EACd,kCAAkC;EAClC,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,yCAAyC;EACzC,yBAAyB;EACzB,aAAa;EACb,2BAA2B;EAC3B,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA,mEAAmE;AACnE;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,gBAAgB;EAChB,mBAAmB;EACnB,8BAA8B;EAC9B,2BAA2B;EAC3B,0CAA0C;EAC1C,0BAA0B;EAC1B,eAAe;EACf;;;oCAGkC;EAClC,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,sCAAsC;EACtC,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;EAChC,kCAAkC;AACpC;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;EACpC,oBAAoB;AACtB;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,OAAO;AACT;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,cAAc;EACd,kCAAkC;EAClC,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,wBAAwB;EACxB,eAAe;EACf,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA,8DAA8D;AAC9D;EACE,kBAAkB;EAClB,sCAAsC;EACtC,OAAO;EACP,QAAQ;EACR,aAAa;EACb,8BAA8B;EAC9B,sBAAsB;EACtB,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,oBAAoB;EACpB,8BAA8B;EAC9B,gBAAgB;EAChB,eAAe;EACf,sCAAsC;EACtC,eAAe;EACf,2BAA2B;EAC3B,2BAA2B;EAC3B,mCAAmC;EACnC,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kCAAkC;EAClC,YAAY;EACZ,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA;EACE,kCAAkC;AACpC;;AAEA,2CAA2C;AAC3C;EACE,kBAAkB;EAClB,YAAY;EACZ,oBAAoB;EACpB,8BAA8B;EAC9B,gBAAgB;EAChB,eAAe;EACf,sCAAsC;EACtC,yBAAyB;EACzB,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,YAAY;EACZ,oBAAoB;EACpB,8BAA8B;EAC9B,gBAAgB;EAChB,eAAe;EACf,sCAAsC;EACtC,yBAAyB;EACzB,4BAA4B;EAC5B,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,YAAY;EACZ,oBAAoB;EACpB,8BAA8B;EAC9B,gBAAgB;EAChB,eAAe;EACf,sCAAsC;EACtC,yBAAyB;EACzB,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;iFAEiF;;AAEjF;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,sCAAsC;EACtC,kBAAkB;EAClB,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,sCAAsC;AACxC;;AAEA,uBAAuB;AACvB;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA,kBAAkB;AAClB;EACE,cAAc;EACd,gBAAgB,EAAE,uCAAuC;AAC3D;;AAEA,eAAe;AACf;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,MAAM;AACR;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,cAAc;AAChB;;AAEA,kBAAkB;AAClB;;;;EAIE,iBAAiB;AACnB;;AAEA;;EAEE,cAAc;AAChB;;AAEA,qCAAqC;AACrC;;;;EAIE,8CAA8C;AAChD;;AAEA;EACE;;IAEE,UAAU;EACZ;EACA;IACE,YAAY;EACd;AACF;;AAEA,6BAA6B;AAC7B;EACE,oCAAoC;EACpC,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;;IAEE,UAAU;EACZ;EACA;IACE,aAAa;EACf;AACF;;AAEA;;iFAEiF;;AAEjF;;EAEE,kBAAkB;EAClB,YAAY;EACZ,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,sCAAsC;EACtC,gBAAgB;EAChB,oCAAoC;EACpC,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,QAAQ;EACR,SAAS;EACT,kBAAkB;EAClB,oCAAoC;EACpC,gCAAgC;EAChC;;mCAEiC;AACnC;;AAEA;;EAEE,YAAY;EACZ,aAAa;AACf;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;;EAEE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kCAAkC;EAClC,oBAAoB;AACtB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;;iFAEiF;;AAEjF;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;EAC3B,2BAA2B;EAC3B,mCAAmC;EACnC,YAAY;EACZ,eAAe;EACf,sCAAsC;EACtC,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;EAC9B,YAAY;AACd;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mCAAmC;EACnC,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,6CAA6C;AAC/C;;AAEA;EACE;;IAEE,2CAA2C;EAC7C;EACA;IACE,2CAA2C;EAC7C;AACF;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;EAC9B,6BAA6B;EAC7B,kBAAkB;EAClB,mCAAmC;AACrC;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE;IACE,yCAAyC;IACzC,UAAU;EACZ;EACA;IACE,6CAA6C;IAC7C,aAAa;EACf;EACA;IACE,2CAA2C;IAC3C,YAAY;EACd;EACA;IACE,2CAA2C;IAC3C,UAAU;EACZ;AACF;;AAEA;EACE;IACE,gCAAgC;IAChC,UAAU;EACZ;EACA;IACE,iCAAiC;IACjC,YAAY;EACd;EACA;IACE,+BAA+B;IAC/B,UAAU;EACZ;AACF;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,mCAAmC;EACnC,QAAQ;EACR,gBAAgB;EAChB,8BAA8B;EAC9B,2BAA2B;EAC3B,0CAA0C;EAC1C,kDAAkD;EAClD,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,yCAAyC;EACzC,2CAA2C;AAC7C;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,mCAAmC;AACnC;EACE;IACE,eAAe;IACf,SAAS;IACT,SAAS;IACT,WAAW;IACX,2BAA2B;IAC3B,mDAAmD;EACrD;;EAEA;IACE;MACE,UAAU;MACV,6CAA6C;IAC/C;IACA;MACE,UAAU;MACV,yCAAyC;IAC3C;EACF;AACF;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,6DAA6D;EAC7D,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,OAAO;AACT;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,oCAAoC;EACpC,0CAA0C;EAC1C,kBAAkB;EAClB,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,4BAA4B;EAC5B,8BAA8B;EAC9B,eAAe;EACf,YAAY;EACZ,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,uBAAuB;EACvB,YAAY;EACZ,4BAA4B;EAC5B,eAAe;EACf,cAAc;EACd,eAAe;EACf,YAAY;EACZ,0CAA0C;EAC1C,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,UAAU;AACZ;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,OAAO;EACP,YAAY;AACd;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;EAC9B,4BAA4B;EAC5B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,aAAa;EACb,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,wBAAwB;EACxB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,wBAAwB;EACxB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;AACvB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,+BAA+B;EAC/B,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,4BAA4B;EAC5B,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,sCAAsC;EACtC,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,8BAA8B;EAC9B,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,gBAAgB;EAChB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,WAAW;EACX,4BAA4B;AAC9B;;AAEA;;iFAEiF;;AAEjF;;EAEE,eAAe;EACf,QAAQ;EACR,6BAA6B;EAC7B,2BAA2B;EAC3B,mCAAmC;EACnC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,wCAAwC;AAC1C;;AAEA;;EAEE,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,2BAA2B;EAC3B,0CAA0C;EAC1C,kDAAkD;EAClD,mBAAmB;EACnB,+DAA+D;EAC/D,2CAA2C;EAC3C,yCAAyC;AAC3C;;AAEA;;EAEE,8BAA8B;EAC9B,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,WAAW;EACX;;GAEC,EAAE,0BAA0B;EAC7B,uBAAuB;EACvB,YAAY;EACZ,wBAAwB;EACxB,8BAA8B;EAC9B,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sCAAsC;EACtC,WAAW;AACb;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;iFAEiF;;AAEjF;EACE,gCAAgC;AAClC;;AAEA;;;;;;EAME,WAAW;EACX,+BAA+B;EAC/B,4BAA4B;EAC5B,6BAA6B;EAC7B,mBAAmB;EACnB,0BAA0B;EAC1B,gCAAgC;EAChC,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;;;EAGE,aAAa;EACb,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;;;EAGE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,oBAAoB;EACpB,4BAA4B;EAC5B,8BAA8B;EAC9B,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,sCAAsC;EACtC,6BAA6B;AAC/B;;AAEA;EACE,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,4BAA4B;EAC5B,8BAA8B;EAC9B,eAAe;EACf,0BAA0B;EAC1B,0CAA0C;AAC5C;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,4CAA4C;EAC5C,kCAAkC;EAClC,kBAAkB;EAClB,oBAAoB;EACpB,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;;iFAEiF;;AAEjF;EACE,eAAe;EACf,MAAM;EACN,SAAS;EACT,OAAO;EACP,YAAY;EACZ,eAAe;EACf,6BAA6B;EAC7B,0CAA0C;EAC1C,kDAAkD;EAClD,4BAA4B;EAC5B,8CAA8C;EAC9C,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,qCAAqC;AACvC;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,MAAM;EACN,UAAU;AACZ;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;iFAEiF;;AAEjF;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;;iFAEiF;;AAEjF;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,oBAAoB;EACpB,2CAA2C;EAC3C,+CAA+C;EAC/C,0BAA0B;EAC1B,gDAAgD;EAChD,qDAAqD;EACrD,2BAA2B;EAC3B,wBAAwB;EACxB,iCAAiC;EACjC,qBAAqB;AACvB;;AAEA;EACE;IACE,oBAAoB;IACpB,qBAAqB;IACrB,0BAA0B;IAC1B,oCAAoC;IACpC,qCAAqC;IACrC,yCAAyC;IACzC,6BAA6B;EAC/B;AACF;;AAEA;EACE,cAAc;EACd,4BAA4B;EAC5B,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gCAAgC;EAChC,cAAc;EACd,yCAAyC;EACzC,gBAAgB;EAChB,gDAAgD;EAChD,mBAAmB,EAAE,+BAA+B;EACpD,kBAAkB;AACpB;;AAEA;EACE,wCAAwC,EAAE,4CAA4C;EACtF,uBAAuB;EACvB,YAAY;EACZ,oCAAoC;EACpC,4BAA4B;EAC5B,8BAA8B;EAC9B,gBAAgB;EAChB,eAAe;EACf,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,kCAAkC;AACpC;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,gEAAgE;AAClE;;AAEA,kCAAkC;AAClC;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA,mDAAmD;AACnD;EACE,qBAAqB;EACrB,kCAAkC;EAClC,gCAAgC;EAChC,wCAAwC;AAC1C;;AAEA,+CAA+C;AAC/C;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,0BAA0B;EAC1B;gCAC8B;EAC9B,4CAA4C;EAC5C,yBAAyB;EACzB,qBAAqB;EACrB,oCAAoC;EACpC,4BAA4B;AAC9B;;AAEA;EACE,aAAa;AACf;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,4BAA4B;AAC9B;;AAEA,wDAAwD;AACxD;EACE,QAAQ;AACV;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,+BAA+B;IAC/B,eAAe;IACf,OAAO;EACT;;EAEA;IACE,aAAa;EACf;;EAEA,0CAA0C;EAC1C;IACE,QAAQ;IACR,WAAW;IACX,6BAA6B;IAC7B,sCAAsC;EACxC;;EAEA;IACE,QAAQ;EACV;AACF;;AAEA;EACE,OAAO;EACP,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,4BAA4B;EAC5B,SAAS;EACT,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,+BAA+B;EAC/B,mBAAmB;EACnB,eAAe;EACf,sCAAsC;EACtC,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,mCAAmC;EACnC,kBAAkB;EAClB,sCAAsC;EACtC,sCAAsC;AACxC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,yDAAyD;AACzD;EACE,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,sBAAsB;EACtB,OAAO;AACT;;AAEA;EACE,cAAc;EACd,8BAA8B;EAC9B,gBAAgB;EAChB,0BAA0B;EAC1B,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,4BAA4B;EAC5B,qCAAqC;EACrC,kBAAkB;EAClB,0BAA0B;EAC1B,8BAA8B;EAC9B,eAAe;AACjB;;AAEA,oBAAoB;AACpB;EACE,4BAA4B;EAC5B,sCAAsC;EACtC,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;EAC1B,gCAAgC;EAChC,gBAAgB;EAChB,+BAA+B;EAC/B,cAAc;AAChB;;AAEA;;;EAGE,YAAY;EACZ,WAAW;EACX,4BAA4B;EAC5B,kBAAkB;EAClB,aAAa;EACb,wBAAwB;EACxB,YAAY;AACd;;AAEA;EACE,kDAAkD;EAClD,0CAA0C;EAC1C,2DAA2D;EAC3D,0BAA0B;EAC1B,2BAA2B;EAC3B;;;cAGY,EAAE,6BAA6B;AAC7C;;AAEA;;;EAGE,wBAAwB;EACxB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,sCAAsC;EACtC,YAAY;AACd;;AAEA;;;EAGE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,sCAAsC;EACtC,YAAY;AACd;;AAEA;EACE,8BAA8B;EAC9B,4BAA4B;EAC5B,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,4BAA4B;EAC5B,+CAA+C;EAC/C,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,+BAA+B;EAC/B,uBAAuB;EACvB,eAAe;EACf,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,sCAAsC;EACtC,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,YAAY;EACZ,0CAA0C;AAC5C;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,4BAA4B;EAC5B,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,gCAAgC;AAClC;;AAEA,wBAAwB;AACxB;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,0BAA0B;EAC1B,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;EAC9B,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,2BAA2B;EAC3B,+BAA+B;AACjC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,gCAAgC;EAChC,kBAAkB;EAClB,0BAA0B;EAC1B,2BAA2B;EAC3B,kBAAkB;EAClB,4BAA4B;EAC5B,eAAe;EACf,kBAAkB;AACpB;;AAEA;;iFAEiF;;AAEjF;EACE,eAAe;EACf,MAAM;EACN,SAAS;EACT,2BAA2B;EAC3B,4BAA4B;EAC5B,mCAAmC;EACnC,2BAA2B;EAC3B,0CAA0C;EAC1C,kDAAkD;EAClD,4BAA4B;EAC5B,iBAAiB;EACjB;YACU;EACV;;;;uDAIqD;EACrD,oBAAoB;EACpB,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,uCAAuC;AACzC;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,aAAa;EACb,kCAAkC;EAClC,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,iDAAiD;EACjD,aAAa;EACb,mBAAmB;EACnB,MAAM;EACN,gBAAgB;EAChB,WAAW;EACX,4BAA4B;AAC9B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;EAChC,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,YAAY,EAAE,oBAAoB;AACpC;;AAEA;EACE,OAAO;EACP,WAAW;EACX,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,wCAAwC;EACxC,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,kCAAkC;EAClC,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,aAAa;EACb,4BAA4B;EAC5B,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gCAAgC;EAChC,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,OAAO;AACT;;AAEA;EACE,8BAA8B;EAC9B,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;EACpC,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,sCAAsC;EACtC,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,kCAAkC;EAClC,oBAAoB;AACtB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,4BAA4B;EAC5B,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe,EAAE,wCAAwC;EACzD,sCAAsC;EACtC,8BAA8B;EAC9B,kBAAkB,EAAE,sCAAsC;EAC1D,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,0BAA0B;EAC1B,gBAAgB;EAChB,YAAY;EACZ,4BAA4B;EAC5B,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,sCAAsC;EACtC,qBAAqB;EACrB,sCAAsC,EAAE,iDAAiD;AAC3F;;AAEA;EACE,+CAA+C;EAC/C,0BAA0B;AAC5B;;AAEA;EACE,gEAAgE;EAChE,+CAA+C;EAC/C,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;EAC9B,4BAA4B;EAC5B,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,OAAO;EACP,WAAW;EACX,oCAAoC;EACpC,kBAAkB;EAClB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,wCAAwC;EACxC,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,8BAA8B;EAC9B,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE;IACE,UAAU;IACV,6CAA6C;EAC/C;EACA;IACE,UAAU;IACV,yCAAyC;EAC3C;AACF;;AAEA,sBAAsB;AACtB;EACE,YAAY;EACZ,YAAY;AACd;;AAEA,sBAAsB;AACtB;EACE;IACE,YAAY;IACZ,YAAY;EACd;;EAEA;;;KAGG;;EAEH;IACE,8BAA8B;EAChC;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,QAAQ;EACV;AACF;;AAEA;;iFAEiF;;AAEjF;EACE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;;iFAEiF;;AAEjF;EACE;IACE,4BAA4B;EAC9B;;EAEA;IACE,yBAAyB;IACzB,sCAAsC;IACtC,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,eAAe;EACjB;;EAEA,8BAA8B;EAC9B;IACE,sCAAsC;EACxC;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,sBAAsB;EACxB;;EAEA,8BAA8B;EAC9B;IACE,sCAAsC;IACtC,4CAA4C;IAC5C,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,8BAA8B;IAC9B,iBAAiB;IACjB,eAAe;EACjB;;EAEA;;IAEE,UAAU;IACV,8DAA8D;EAChE;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;AACF;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE;IACE,0BAA0B;IAC1B,eAAe;IACf,WAAW;IACX,eAAe;IACf,YAAY;IACZ,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;EACxB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,8BAA8B;EAChC;;EAEA,yCAAyC;EACzC;IACE,4CAA4C;IAC5C,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,eAAe;EACjB;;EAEA,yCAAyC;EACzC;IACE,4CAA4C;IAC5C,mBAAmB;IACnB,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,eAAe;EACjB;AACF;;AAEA;;iFAEiF;;AAEjF,+DAA+D;AAC/D;;;;EAIE,oCAAoC;EACpC,iCAAiC;EACjC,gCAAgC;EAChC,4BAA4B;AAC9B;;AAEA;;EAEE,oCAAoC;EACpC,iCAAiC;EACjC,gCAAgC;EAChC,4BAA4B;AAC9B;;AAEA,6BAA6B;AAC7B;EACE,qBAAqB;EACrB,kEAAkE;EAClE,6BAA6B;EAC7B,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,WAAW;EACX,wBAAwB;AAC1B;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA,wDAAwD;AACxD;EACE,6BAA6B;EAC7B,wBAAwB;EACxB,+BAA+B;AACjC;;AAEA,iFAAiF;AACjF;EACE;;IAEE,wBAAwB;EAC1B;AACF;;AAEA;;iFAEiF;;AAEjF;EACE,kBAAkB;EAClB,sBAAsB;EACtB,UAAU,EAAE,2BAA2B;EACvC,WAAW,EAAE,6BAA6B;EAC1C,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,6BAA6B;EAC7B,0CAA0C;EAC1C,kDAAkD;EAClD,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,SAAS;EACT,qBAAqB,EAAE,mCAAmC;EAC1D,0BAA0B;EAC1B,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,uBAAuB;EACvB,wBAAwB;EACxB,WAAW;EACX,cAAc;EACd,sBAAsB;EACtB,6BAA6B;EAC7B,0CAA0C;EAC1C,kDAAkD;EAClD,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,qBAAqB;EACrB,wBAAwB;EACxB,kBAAkB;EAClB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA,mCAAmC;AACnC;;EAEE,8BAA8B;AAChC;;AAEA,sCAAsC;AACtC;;EAEE,8BAA8B;AAChC;;AAEA,iEAAiE;AACjE;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,eAAe;EACjB;;EAEA,+BAA+B;EAC/B;IACE,2CAA2C;IAC3C,YAAY;EACd;AACF;;AAEA;;iFAEiF;;AAEjF;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,2BAA2B;EAC3B,kCAAkC;EAClC,kCAAkC;EAClC,0CAA0C;EAC1C,kDAAkD;EAClD,oBAAoB;EACpB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,YAAY;EACZ,uCAAuC;EACvC,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,OAAO;EACP,yBAAyB;AAC3B;;AAEA;EACE,OAAO;EACP,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,kCAAkC;EAClC,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sCAAsC;EACtC,UAAU;AACZ;;AAEA;EACE,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sDAAsD;AACxD;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE;;IAEE,UAAU;IACV,mBAAmB;EACrB;EACA;IACE,YAAY;IACZ,sBAAsB;EACxB;AACF;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,yBAAyB;EACzB,4BAA4B;EAC5B,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,oBAAoB;AACtB;;AAEA,+CAA+C;AAC/C;EACE,eAAe;EACf,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,kCAAkC;EAClC,2BAA2B;EAC3B,0CAA0C;EAC1C,kDAAkD;EAClD,mBAAmB;EACnB,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,yCAAyC;EACzC,4CAA4C;AAC9C;;AAEA;EACE;IACE,UAAU;IACV,wDAAwD;EAC1D;EACA;IACE,UAAU;IACV,kDAAkD;EACpD;AACF;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,4BAA4B;EAC5B,YAAY;EACZ,4BAA4B;EAC5B,8BAA8B;EAC9B,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sCAAsC;EACtC,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,0BAA0B;EAC1B,wBAAwB;AAC1B;;AAEA,gCAAgC;AAChC;EACE,eAAe;EACf,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,kCAAkC;EAClC,kCAAkC;EAClC,0CAA0C;EAC1C,kDAAkD;EAClD,mBAAmB;EACnB,0BAA0B;EAC1B,uBAAuB;EACvB,gBAAgB;EAChB,wCAAwC;EACxC,6CAA6C;AAC/C;;AAEA;EACE;IACE,UAAU;IACV,4CAA4C;EAC9C;EACA;IACE,UAAU;IACV,yCAAyC;EAC3C;AACF;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,4BAA4B;EAC5B,yBAAyB;EACzB,qBAAqB;EACrB,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,QAAQ;EACR,+BAA+B;EAC/B,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,uBAAuB;EACvB,6BAA6B;EAC7B,mBAAmB;EACnB,eAAe;EACf,sCAAsC;EACtC,kBAAkB;EAClB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;AACxC;;AAEA;EACE,sDAAsD;EACtD,2BAA2B;AAC7B;;AAEA;EACE,sDAAsD;EACtD,kCAAkC;EAClC,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,YAAY;AACd;;AAEA;;iFAEiF;;AAEjF;EACE,eAAe;EACf,aAAa,EAAE,uBAAuB;EACtC,SAAS;EACT,2BAA2B;EAC3B,eAAe;EACf,0BAA0B;EAC1B,2BAA2B;EAC3B,mCAAmC;EACnC,mBAAmB;EACnB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,qCAAqC;EACrC,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,iBAAiB;EACjB,yCAAyC;AAC3C;;AAEA;EACE,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE,0BAA0B;EAC1B,qCAAqC;AACvC;;AAEA;EACE,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,OAAO;EACP,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,0BAA0B;EAC1B,eAAe;EACf,cAAc;EACd,eAAe;EACf,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,0CAA0C;AAC5C;;AAEA;EACE,UAAU;AACZ;;AAEA;;iFAEiF;;AAEjF;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,eAAe;EACf,6BAA6B;EAC7B,2BAA2B;EAC3B,mCAAmC;EACnC,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,yCAAyC;EACzC,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,0BAA0B;EAC1B,gCAAgC;AAClC;;AAEA;;iFAEiF;;AAEjF;EACE,gBAAgB;EAChB,YAAY;EACZ,0BAA0B;EAC1B,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,yBAAyB;EACzB,kCAAkC;AACpC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,UAAU;EACV,YAAY;EACZ,2BAA2B;EAC3B,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,sCAAsC;EACtC,kBAAkB;EAClB,gCAAgC;EAChC,oBAAoB;EACpB,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,2BAA2B;EAC3B,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,cAAc;AAChB;;AAEA,wBAAwB;AACxB;EACE,eAAe;EACf,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,eAAe;EACf,0BAA0B;EAC1B,2BAA2B;EAC3B,mCAAmC;EACnC,mBAAmB;EACnB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,qCAAqC;EACrC,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,QAAQ;EACR,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;;iFAEiF;;AAEjF;EACE,2BAA2B;EAC3B,+BAA+B;EAC/B,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,2BAA2B;EAC3B,mCAAmC;EACnC,uCAAuC;AACzC;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,4BAA4B;EAC5B,4CAA4C;AAC9C;;AAEA;EACE,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,uBAAuB;EACvB,YAAY;EACZ,0BAA0B;EAC1B,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,6CAA6C;AAC/C;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oCAAoC;AACtC;;AAEA,0BAA0B;AAC1B;EACE;IACE,gBAAgB;IAChB,uCAAuC;EACzC;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,yBAAyB;IACzB,6BAA6B;EAC/B;;EAEA;IACE,yBAAyB;IACzB,6BAA6B;IAC7B,eAAe;EACjB;;EAEA;IACE,2DAA2D;EAC7D;AACF","sourcesContent":["/* ============================================================================\n   BikeDash Beta - Modern Tesla 2024 Design System\n   ============================================================================ */\n\n/* Default theme variables (Dark theme fallback) */\n:root {\n  /* Spacing - Constant across all themes */\n  --spacing-xs: 4px;\n  --spacing-sm: 8px;\n  --spacing-md: 16px;\n  --spacing-lg: 24px;\n  --spacing-xl: 32px;\n  --spacing-2xl: 48px;\n\n  /* Typography - Constant across all themes */\n  --font-primary:\n    -apple-system, BlinkMacSystemFont, \"SF Pro Display\", \"Segoe UI\", system-ui,\n    sans-serif;\n  --font-mono: \"SF Mono\", \"Cascadia Code\", \"Roboto Mono\", monospace;\n\n  /* Font Sizes - Medium (default, 100%) */\n  --font-size-xs: 10px; /* Labels, tiny text */\n  --font-size-sm: 12px; /* Secondary text, descriptions */\n  --font-size-base: 14px; /* Body text, most UI */\n  --font-size-md: 16px; /* Emphasized text */\n  --font-size-lg: 18px; /* Headings, important values */\n  --font-size-xl: 24px; /* Large headings */\n  --font-size-2xl: 32px; /* Activity metrics */\n  --font-size-3xl: 44px; /* Primary activity metrics */\n\n  /* Transitions - Constant across all themes */\n  --transition-fast: 200ms cubic-bezier(0.16, 1, 0.3, 1);\n  --transition-normal: 300ms cubic-bezier(0.16, 1, 0.3, 1);\n  --transition-slow: 500ms cubic-bezier(0.16, 1, 0.3, 1);\n\n  /* Z-index layers - Constant across all themes */\n  --z-map: 1;\n  --z-controls: 10;\n  --z-header: 100;\n  --z-modal: 1000;\n\n  /* Colors - Dark theme (default fallback) */\n  --bg-primary: #000000;\n  --bg-elevated: #0a0a0a;\n  --bg-subtle: rgba(255, 255, 255, 0.03);\n\n  --text-primary: #ffffff;\n  --text-secondary: rgba(255, 255, 255, 0.5);\n  --text-muted: rgba(255, 255, 255, 0.3);\n\n  --accent: #3e6ae1;\n  --accent-bright: #5e8aff;\n  --success: #00d200;\n  --warning: #ff9500;\n  --danger: #ff3b30;\n\n  --border: rgba(255, 255, 255, 0.1);\n\n  /* Semantic colors */\n  --text-on-accent: #ffffff;\n  --bg-button-slider: #ffffff;\n  --shadow-sm: rgba(0, 0, 0, 0.2);\n  --shadow-md: rgba(0, 0, 0, 0.3);\n  --shadow-lg: rgba(0, 0, 0, 0.5);\n}\n\n/* ============================================================================\n   Theme System - 5 Themes\n   ============================================================================ */\n\n/* Dark Theme (Default) */\n.theme-dark {\n  --bg-primary: #000000;\n  --bg-elevated: #0a0a0a;\n  --bg-subtle: rgba(255, 255, 255, 0.03);\n  --bg-overlay: rgba(0, 0, 0, 0.7);\n  --bg-modal: rgba(20, 20, 20, 0.95);\n  --bg-glass: rgba(0, 0, 0, 0.3);\n  --bg-glass-strong: rgba(0, 0, 0, 0.5);\n\n  --text-primary: #ffffff;\n  --text-secondary: rgba(255, 255, 255, 0.5);\n  --text-muted: rgba(255, 255, 255, 0.3);\n\n  --accent: #3e6ae1;\n  --accent-bright: #5e8aff;\n  --success: #00d200;\n  --warning: #ff9500;\n  --danger: #ff3b30;\n\n  --border: rgba(255, 255, 255, 0.1);\n  --border-light: rgba(255, 255, 255, 0.05);\n\n  /* Semantic colors */\n  --text-on-accent: #ffffff;\n  --bg-button-slider: #ffffff;\n  --shadow-sm: rgba(0, 0, 0, 0.2);\n  --shadow-md: rgba(0, 0, 0, 0.3);\n  --shadow-lg: rgba(0, 0, 0, 0.5);\n\n  /* Overlay text (for map visibility) */\n  --text-overlay: #ffffff;\n  --text-outline: #000000;\n}\n\n/* Light Theme */\n.theme-light {\n  --bg-primary: #ffffff;\n  --bg-elevated: #f8f9fa;\n  --bg-subtle: rgba(0, 0, 0, 0.03);\n  --bg-overlay: rgba(255, 255, 255, 0.7);\n  --bg-modal: rgba(255, 255, 255, 0.98);\n  --bg-glass: rgba(255, 255, 255, 0.45);\n  --bg-glass-strong: rgba(255, 255, 255, 0.6);\n\n  --text-primary: #000000;\n  --text-secondary: rgba(0, 0, 0, 0.6);\n  --text-muted: rgba(0, 0, 0, 0.4);\n\n  --accent: #3e6ae1;\n  --accent-bright: #2563eb;\n  --success: #00b300;\n  --warning: #e68600;\n  --danger: #dc2626;\n\n  --border: rgba(0, 0, 0, 0.1);\n  --border-light: rgba(0, 0, 0, 0.05);\n\n  /* Semantic colors */\n  --text-on-accent: #ffffff;\n  --bg-button-slider: #ffffff;\n  --shadow-sm: rgba(0, 0, 0, 0.1);\n  --shadow-md: rgba(0, 0, 0, 0.15);\n  --shadow-lg: rgba(0, 0, 0, 0.2);\n\n  /* Overlay text (for map visibility) - INVERTED for light theme */\n  --text-overlay: #000000;\n  --text-outline: #ffffff;\n}\n\n/* High Contrast Dark Theme */\n.theme-high-contrast-dark {\n  --bg-primary: #000000;\n  --bg-elevated: #000000;\n  --bg-subtle: #1a1a1a;\n  --bg-overlay: rgba(0, 0, 0, 0.95);\n  --bg-modal: rgba(0, 0, 0, 0.98);\n  --bg-glass: rgba(0, 0, 0, 0.8);\n  --bg-glass-strong: rgba(0, 0, 0, 0.85);\n\n  --text-primary: #ffffff;\n  --text-secondary: #ffffff;\n  --text-muted: #cccccc;\n\n  --accent: #4da6ff;\n  --accent-bright: #66b3ff;\n  --success: #00ff00;\n  --warning: #ffaa00;\n  --danger: #ff0000;\n\n  --border: #ffffff;\n  --border-strong: #ffffff;\n  --border-light: rgba(255, 255, 255, 0.3);\n  --focus-ring: #4da6ff;\n\n  /* Semantic colors */\n  --text-on-accent: #000000;\n  --bg-button-slider: #ffffff;\n  --shadow-sm: rgba(0, 0, 0, 0.4);\n  --shadow-md: rgba(0, 0, 0, 0.5);\n  --shadow-lg: rgba(0, 0, 0, 0.7);\n\n  /* Overlay text (for map visibility) */\n  --text-overlay: #ffffff;\n  --text-outline: #000000;\n}\n\n/* High Contrast Light Theme */\n.theme-high-contrast-light {\n  --bg-primary: #ffffff;\n  --bg-elevated: #ffffff;\n  --bg-subtle: #f0f0f0;\n  --bg-overlay: rgba(255, 255, 255, 0.85);\n  --bg-modal: rgba(255, 255, 255, 0.98);\n  --bg-glass: rgba(255, 255, 255, 0.8);\n  --bg-glass-strong: rgba(255, 255, 255, 0.85);\n\n  --text-primary: #000000;\n  --text-secondary: #000000;\n  --text-muted: #333333;\n\n  --accent: #0066ff;\n  --accent-bright: #0052cc;\n  --success: #006600;\n  --warning: #cc6600;\n  --danger: #cc0000;\n\n  --border: #000000;\n  --border-strong: #000000;\n  --border-light: rgba(0, 0, 0, 0.3);\n  --focus-ring: #0066ff;\n\n  /* Semantic colors */\n  --text-on-accent: #ffffff;\n  --bg-button-slider: #000000;\n  --shadow-sm: rgba(0, 0, 0, 0.3);\n  --shadow-md: rgba(0, 0, 0, 0.4);\n  --shadow-lg: rgba(0, 0, 0, 0.5);\n\n  /* Overlay text (for map visibility) - INVERTED for light theme */\n  --text-overlay: #000000;\n  --text-outline: #ffffff;\n}\n\n/* ============================================================================\n   Text Size System\n   ============================================================================ */\n\n/* Small text size (87.5%) */\n[data-text-size=\"small\"] {\n  --font-size-xs: 10px;\n  --font-size-sm: 12px;\n  --font-size-base: 14px;\n  --font-size-md: 16px;\n  --font-size-lg: 18px;\n  --font-size-xl: 24px;\n  --font-size-2xl: 32px;\n  --font-size-3xl: 44px;\n}\n\n/* Medium text size - same as large (112.5% of original) */\n[data-text-size=\"medium\"] {\n  --font-size-xs: 11px;\n  --font-size-sm: 13px;\n  --font-size-base: 16px;\n  --font-size-md: 18px;\n  --font-size-lg: 20px;\n  --font-size-xl: 27px;\n  --font-size-2xl: 36px;\n  --font-size-3xl: 50px;\n}\n\n/* Large text size (140%) */\n[data-text-size=\"large\"] {\n  --font-size-xs: 14px;\n  --font-size-sm: 17px;\n  --font-size-base: 20px;\n  --font-size-md: 22px;\n  --font-size-lg: 25px;\n  --font-size-xl: 34px;\n  --font-size-2xl: 45px;\n  --font-size-3xl: 62px;\n}\n\n/* Smooth transitions for theme changes */\nhtml {\n  transition:\n    background-color var(--transition-normal),\n    color var(--transition-normal);\n}\n\n* {\n  transition:\n    background-color var(--transition-normal),\n    color var(--transition-normal),\n    border-color var(--transition-normal);\n}\n\n/* ============================================================================\n   Base Styles\n   ============================================================================ */\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nbody {\n  font-family: var(--font-primary);\n  background: var(--bg-primary);\n  color: var(--text-primary);\n  line-height: 1.6;\n  font-weight: 400;\n  letter-spacing: -0.015em;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  overscroll-behavior: none;\n  touch-action: manipulation;\n}\n\n/* ============================================================================\n   App Layout\n   ============================================================================ */\n\n.app {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n.map-container {\n  position: absolute;\n  inset: 0;\n  z-index: var(--z-map);\n}\n\n/* ============================================================================\n   Header - Ultra Minimal\n   ============================================================================ */\n\n.header {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 48px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 var(--spacing-lg);\n  z-index: var(--z-header);\n  pointer-events: none;\n}\n\n.header > * {\n  pointer-events: auto;\n}\n\n.map-cycle-btn {\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-sm);\n  padding: var(--spacing-sm) var(--spacing-md);\n  background: var(--bg-glass);\n  backdrop-filter: blur(40px) saturate(150%);\n  -webkit-backdrop-filter: blur(40px) saturate(150%);\n  border: none;\n  border-radius: 100px;\n  color: var(--text-primary);\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all var(--transition-fast);\n}\n\n/* Only enable hover on devices that support it (not touch screens) */\n@media (hover: hover) and (pointer: fine) {\n  .map-cycle-btn:hover {\n    background: var(--bg-glass-strong);\n    transform: scale(1.02);\n  }\n}\n\n.map-cycle-btn:active {\n  transform: scale(0.98);\n}\n\n/* ============================================================================\n   Activity Bar - Floating Design\n   ============================================================================ */\n\n.activity-bar-container {\n  position: absolute;\n  bottom: var(--spacing-lg);\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: var(--z-controls);\n  /* width: min(600px, calc(100vw - var(--spacing-2xl))); */\n  width: calc(100vw - var(--spacing-2xl));\n}\n\n.activity-bar {\n  width: 100%;\n  background: var(--bg-glass);\n  backdrop-filter: blur(20px);\n  -webkit-backdrop-filter: blur(20px);\n  border-radius: 24px;\n  padding: 12px var(--spacing-lg);\n  transition: all var(--transition-normal);\n}\n\n.activity-bar.active {\n  background: var(--bg-glass-strong);\n  padding-top: var(--spacing-md);\n  padding-bottom: var(--spacing-md);\n}\n\n/* Activity Bar Layout Variants */\n\n/* Expanded Layout (Default) - Full-size metrics */\n.activity-bar--expanded {\n  /* Uses base .activity-bar styles */\n}\n\n.activity-bar--expanded .metrics {\n  align-items: flex-end;\n}\n\n.activity-bar--expanded .metric-value {\n  font-size: var(--font-size-2xl);\n  font-weight: 600;\n  /* Subtle outline for better visibility */\n  text-shadow:\n    -1px -1px 0 var(--text-outline),\n    0px -1px 0 var(--text-outline),\n    1px -1px 0 var(--text-outline),\n    -1px 0px 0 var(--text-outline),\n    1px 0px 0 var(--text-outline),\n    -1px 1px 0 var(--text-outline),\n    0px 1px 0 var(--text-outline),\n    1px 1px 0 var(--text-outline);\n}\n\n.activity-bar--expanded .metric--primary .metric-value {\n  font-size: var(--font-size-3xl);\n}\n\n.activity-bar--expanded .metric-label {\n  font-size: var(--font-size-xs);\n  margin-top: 2px;\n}\n\n/* Compact Layout - Space-saving design */\n.activity-bar--compact {\n  padding: 6px var(--spacing-lg);\n  border-radius: 18px;\n  width: 100%;\n}\n\n.activity-bar-container:has(.activity-bar--compact) {\n  width: calc(100vw - var(--spacing-xl));\n}\n\n.activity-bar--compact.active {\n  background: var(--bg-glass-strong);\n  padding-top: var(--spacing-sm);\n  padding-bottom: var(--spacing-sm);\n}\n\n.activity-bar--compact .metrics {\n  margin-bottom: var(--spacing-xs);\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr;\n  align-items: baseline;\n}\n\n.activity-bar--compact .metric--inline:nth-child(1) {\n  justify-self: start;\n}\n\n.activity-bar--compact .metric--inline:nth-child(2) {\n  justify-self: center;\n}\n\n.activity-bar--compact .metric--inline:nth-child(3) {\n  justify-self: end;\n}\n\n.activity-bar--compact .metric--inline {\n  flex-direction: row;\n  align-items: baseline;\n  gap: 4px;\n}\n\n.activity-bar--compact .metric {\n  min-width: 60px;\n}\n\n.activity-bar--compact .metric-value {\n  font-size: var(--font-size-2xl) !important;\n  font-weight: 600 !important;\n  /* Subtle outline for better visibility */\n  text-shadow:\n    -1px -1px 0 var(--text-outline),\n    0px -1px 0 var(--text-outline),\n    1px -1px 0 var(--text-outline),\n    -1px 0px 0 var(--text-outline),\n    1px 0px 0 var(--text-outline),\n    -1px 1px 0 var(--text-outline),\n    0px 1px 0 var(--text-outline),\n    1px 1px 0 var(--text-outline);\n}\n\n.activity-bar--compact .metric--inline:nth-child(2) .metric-value {\n  font-size: var(--font-size-3xl) !important;\n}\n\n.activity-bar--compact .metric-label {\n  font-size: var(--font-size-xs) !important;\n  margin-top: 0;\n  letter-spacing: 0.08em;\n}\n\n.activity-bar--compact .activity-controls {\n  gap: var(--spacing-xs);\n}\n\n.activity-bar--compact .control-btn {\n  padding: 8px 24px;\n  font-size: var(--font-size-sm);\n  min-width: 80px;\n}\n\n/* Overlay Layout - Semi-transparent over map with enhanced visibility */\n.activity-bar--overlay {\n  display: grid;\n  grid-template-columns: 1fr auto 1fr;\n  align-items: center;\n  gap: var(--spacing-md);\n  width: 100%;\n  background: rgba(0, 0, 0, 0.25);\n  backdrop-filter: blur(20px);\n  -webkit-backdrop-filter: blur(20px);\n  border-radius: 20px;\n  padding: 6px var(--spacing-lg);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.activity-bar-container:has(.activity-bar--overlay) {\n  width: min(820px, calc(100vw - var(--spacing-xl)));\n}\n\n.activity-bar--overlay.active {\n  background: rgba(0, 0, 0, 0.35);\n  padding-top: var(--spacing-sm);\n  padding-bottom: var(--spacing-sm);\n  padding-left: var(--spacing-lg);\n  padding-right: var(--spacing-lg);\n}\n\n/* Light theme overlay backgrounds */\n.theme-light .activity-bar--overlay {\n  background: rgba(255, 255, 255, 0.25);\n  border: 1px solid rgba(0, 0, 0, 0.1);\n}\n\n.theme-light .activity-bar--overlay.active {\n  background: rgba(255, 255, 255, 0.35);\n}\n\n/* High contrast dark backgrounds */\n.theme-high-contrast-dark .activity-bar.active {\n  background: rgba(0, 0, 0, 0.85);\n}\n\n.theme-high-contrast-dark .activity-bar--overlay {\n  background: rgba(0, 0, 0, 0.75);\n}\n\n.theme-high-contrast-dark .activity-bar--overlay.active {\n  background: rgba(0, 0, 0, 0.85);\n}\n\n/* High contrast light backgrounds */\n.theme-high-contrast-light .activity-bar.active {\n  background: rgba(255, 255, 255, 0.85);\n}\n\n.theme-high-contrast-light .activity-bar--overlay {\n  background: rgba(255, 255, 255, 0.75);\n  border: 1px solid rgba(0, 0, 0, 0.3);\n}\n\n.theme-high-contrast-light .activity-bar--overlay.active {\n  background: rgba(255, 255, 255, 0.85);\n}\n\n/* High contrast themes - thicker text outlines for speed */\n.theme-high-contrast-dark .metric-value-hero,\n.theme-high-contrast-light .metric-value-hero {\n  text-shadow:\n    -1px -1px 0 var(--text-outline),\n    0px -1px 0 var(--text-outline),\n    1px -1px 0 var(--text-outline),\n    -1px 0px 0 var(--text-outline),\n    1px 0px 0 var(--text-outline),\n    -1px 1px 0 var(--text-outline),\n    0px 1px 0 var(--text-outline),\n    1px 1px 0 var(--text-outline),\n    -2px -2px 0 var(--text-outline),\n    -1px -2px 0 var(--text-outline),\n    0px -2px 0 var(--text-outline),\n    1px -2px 0 var(--text-outline),\n    2px -2px 0 var(--text-outline),\n    -2px -1px 0 var(--text-outline),\n    2px -1px 0 var(--text-outline),\n    -2px 0px 0 var(--text-outline),\n    2px 0px 0 var(--text-outline),\n    -2px 1px 0 var(--text-outline),\n    2px 1px 0 var(--text-outline),\n    -2px 2px 0 var(--text-outline),\n    -1px 2px 0 var(--text-outline),\n    0px 2px 0 var(--text-outline),\n    1px 2px 0 var(--text-outline),\n    2px 2px 0 var(--text-outline),\n    -3px -3px 0 var(--text-outline),\n    -2px -3px 0 var(--text-outline),\n    -1px -3px 0 var(--text-outline),\n    0px -3px 0 var(--text-outline),\n    1px -3px 0 var(--text-outline),\n    2px -3px 0 var(--text-outline),\n    3px -3px 0 var(--text-outline),\n    -3px -2px 0 var(--text-outline),\n    3px -2px 0 var(--text-outline),\n    -3px -1px 0 var(--text-outline),\n    3px -1px 0 var(--text-outline),\n    -3px 0px 0 var(--text-outline),\n    3px 0px 0 var(--text-outline),\n    -3px 1px 0 var(--text-outline),\n    3px 1px 0 var(--text-outline),\n    -3px 2px 0 var(--text-outline),\n    3px 2px 0 var(--text-outline),\n    -3px 3px 0 var(--text-outline),\n    -2px 3px 0 var(--text-outline),\n    -1px 3px 0 var(--text-outline),\n    0px 3px 0 var(--text-outline),\n    1px 3px 0 var(--text-outline),\n    2px 3px 0 var(--text-outline),\n    3px 3px 0 var(--text-outline),\n    -4px -4px 0 var(--text-outline),\n    -3px -4px 0 var(--text-outline),\n    -2px -4px 0 var(--text-outline),\n    -1px -4px 0 var(--text-outline),\n    0px -4px 0 var(--text-outline),\n    1px -4px 0 var(--text-outline),\n    2px -4px 0 var(--text-outline),\n    3px -4px 0 var(--text-outline),\n    4px -4px 0 var(--text-outline),\n    -4px -3px 0 var(--text-outline),\n    4px -3px 0 var(--text-outline),\n    -4px -2px 0 var(--text-outline),\n    4px -2px 0 var(--text-outline),\n    -4px -1px 0 var(--text-outline),\n    4px -1px 0 var(--text-outline),\n    -4px 0px 0 var(--text-outline),\n    4px 0px 0 var(--text-outline),\n    -4px 1px 0 var(--text-outline),\n    4px 1px 0 var(--text-outline),\n    -4px 2px 0 var(--text-outline),\n    4px 2px 0 var(--text-outline),\n    -4px 3px 0 var(--text-outline),\n    4px 3px 0 var(--text-outline),\n    -4px 4px 0 var(--text-outline),\n    -3px 4px 0 var(--text-outline),\n    -2px 4px 0 var(--text-outline),\n    -1px 4px 0 var(--text-outline),\n    0px 4px 0 var(--text-outline),\n    1px 4px 0 var(--text-outline),\n    2px 4px 0 var(--text-outline),\n    3px 4px 0 var(--text-outline),\n    4px 4px 0 var(--text-outline);\n}\n\n.theme-high-contrast-dark .metric-label-hero,\n.theme-high-contrast-light .metric-label-hero {\n  text-shadow:\n    -1px -1px 0 var(--text-outline),\n    0px -1px 0 var(--text-outline),\n    1px -1px 0 var(--text-outline),\n    -1px 0px 0 var(--text-outline),\n    1px 0px 0 var(--text-outline),\n    -1px 1px 0 var(--text-outline),\n    0px 1px 0 var(--text-outline),\n    1px 1px 0 var(--text-outline),\n    -2px -2px 0 var(--text-outline),\n    -1px -2px 0 var(--text-outline),\n    0px -2px 0 var(--text-outline),\n    1px -2px 0 var(--text-outline),\n    2px -2px 0 var(--text-outline),\n    -2px -1px 0 var(--text-outline),\n    2px -1px 0 var(--text-outline),\n    -2px 0px 0 var(--text-outline),\n    2px 0px 0 var(--text-outline),\n    -2px 1px 0 var(--text-outline),\n    2px 1px 0 var(--text-outline),\n    -2px 2px 0 var(--text-outline),\n    -1px 2px 0 var(--text-outline),\n    0px 2px 0 var(--text-outline),\n    1px 2px 0 var(--text-outline),\n    2px 2px 0 var(--text-outline),\n    -3px -3px 0 var(--text-outline),\n    -2px -3px 0 var(--text-outline),\n    -1px -3px 0 var(--text-outline),\n    0px -3px 0 var(--text-outline),\n    1px -3px 0 var(--text-outline),\n    2px -3px 0 var(--text-outline),\n    3px -3px 0 var(--text-outline),\n    -3px -2px 0 var(--text-outline),\n    3px -2px 0 var(--text-outline),\n    -3px -1px 0 var(--text-outline),\n    3px -1px 0 var(--text-outline),\n    -3px 0px 0 var(--text-outline),\n    3px 0px 0 var(--text-outline),\n    -3px 1px 0 var(--text-outline),\n    3px 1px 0 var(--text-outline),\n    -3px 2px 0 var(--text-outline),\n    3px 2px 0 var(--text-outline),\n    -3px 3px 0 var(--text-outline),\n    -2px 3px 0 var(--text-outline),\n    -1px 3px 0 var(--text-outline),\n    0px 3px 0 var(--text-outline),\n    1px 3px 0 var(--text-outline),\n    2px 3px 0 var(--text-outline),\n    3px 3px 0 var(--text-outline),\n    -4px -4px 0 var(--text-outline),\n    -3px -4px 0 var(--text-outline),\n    -2px -4px 0 var(--text-outline),\n    -1px -4px 0 var(--text-outline),\n    0px -4px 0 var(--text-outline),\n    1px -4px 0 var(--text-outline),\n    2px -4px 0 var(--text-outline),\n    3px -4px 0 var(--text-outline),\n    4px -4px 0 var(--text-outline),\n    -4px -3px 0 var(--text-outline),\n    4px -3px 0 var(--text-outline),\n    -4px -2px 0 var(--text-outline),\n    4px -2px 0 var(--text-outline),\n    -4px -1px 0 var(--text-outline),\n    4px -1px 0 var(--text-outline),\n    -4px 0px 0 var(--text-outline),\n    4px 0px 0 var(--text-outline),\n    -4px 1px 0 var(--text-outline),\n    4px 1px 0 var(--text-outline),\n    -4px 2px 0 var(--text-outline),\n    4px 2px 0 var(--text-outline),\n    -4px 3px 0 var(--text-outline),\n    4px 3px 0 var(--text-outline),\n    -4px 4px 0 var(--text-outline),\n    -3px 4px 0 var(--text-outline),\n    -2px 4px 0 var(--text-outline),\n    -1px 4px 0 var(--text-outline),\n    0px 4px 0 var(--text-outline),\n    1px 4px 0 var(--text-outline),\n    2px 4px 0 var(--text-outline),\n    3px 4px 0 var(--text-outline),\n    4px 4px 0 var(--text-outline);\n}\n\n/* Side columns - left and right */\n.overlay-side {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-sm);\n}\n\n.overlay-side-left {\n  grid-column: 1;\n  align-items: flex-start;\n}\n\n.overlay-side-right {\n  grid-column: 3;\n  align-items: flex-end;\n}\n\n/* Center column - MPH label in grid with speed above */\n.overlay-center {\n  grid-column: 2;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  position: relative;\n  pointer-events: none;\n}\n\n.metric-value-hero {\n  position: absolute;\n  bottom: 100%;\n  font-size: 192px;\n  font-weight: 600;\n  letter-spacing: -0.02em; /* Tighter spacing between numbers */\n  line-height: 1;\n  color: var(--text-overlay);\n  white-space: nowrap;\n  /* Smooth solid outline for visibility over map */\n  text-shadow:\n    -1px -1px 0 var(--text-outline),\n    0px -1px 0 var(--text-outline),\n    1px -1px 0 var(--text-outline),\n    -1px 0px 0 var(--text-outline),\n    1px 0px 0 var(--text-outline),\n    -1px 1px 0 var(--text-outline),\n    0px 1px 0 var(--text-outline),\n    1px 1px 0 var(--text-outline),\n    -2px -2px 0 var(--text-outline),\n    -1px -2px 0 var(--text-outline),\n    0px -2px 0 var(--text-outline),\n    1px -2px 0 var(--text-outline),\n    2px -2px 0 var(--text-outline),\n    -2px -1px 0 var(--text-outline),\n    2px -1px 0 var(--text-outline),\n    -2px 0px 0 var(--text-outline),\n    2px 0px 0 var(--text-outline),\n    -2px 1px 0 var(--text-outline),\n    2px 1px 0 var(--text-outline),\n    -2px 2px 0 var(--text-outline),\n    -1px 2px 0 var(--text-outline),\n    0px 2px 0 var(--text-outline),\n    1px 2px 0 var(--text-outline),\n    2px 2px 0 var(--text-outline);\n}\n\n/* Speed decimal scaling */\n.speed-decimal {\n  font-size: 0.8em;\n  vertical-align: baseline;\n  /* Reduced outline - half thickness */\n  text-shadow:\n    -1px -1px 0 var(--text-outline),\n    0px -1px 0 var(--text-outline),\n    1px -1px 0 var(--text-outline),\n    -1px 0px 0 var(--text-outline),\n    1px 0px 0 var(--text-outline),\n    -1px 1px 0 var(--text-outline),\n    0px 1px 0 var(--text-outline),\n    1px 1px 0 var(--text-outline);\n}\n\n.speed-decimal--small {\n  font-size: 0.6em;\n}\n\n.speed-decimal-point {\n  letter-spacing: -0.05em; /* Pull the decimal point closer to the integer */\n  margin-right: -0.05em; /* Reduce space after decimal point */\n}\n\n.metric-label-hero {\n  font-size: 36px;\n  text-transform: uppercase;\n  font-weight: 600;\n  letter-spacing: 0;\n  line-height: 1;\n  color: var(--text-overlay);\n  white-space: nowrap;\n  text-shadow:\n    -1px -1px 0 var(--text-outline),\n    0px -1px 0 var(--text-outline),\n    1px -1px 0 var(--text-outline),\n    -1px 0px 0 var(--text-outline),\n    1px 0px 0 var(--text-outline),\n    -1px 1px 0 var(--text-outline),\n    0px 1px 0 var(--text-outline),\n    1px 1px 0 var(--text-outline),\n    -2px -2px 0 var(--text-outline),\n    -1px -2px 0 var(--text-outline),\n    0px -2px 0 var(--text-outline),\n    1px -2px 0 var(--text-outline),\n    2px -2px 0 var(--text-outline),\n    -2px -1px 0 var(--text-outline),\n    2px -1px 0 var(--text-outline),\n    -2px 0px 0 var(--text-outline),\n    2px 0px 0 var(--text-outline),\n    -2px 1px 0 var(--text-outline),\n    2px 1px 0 var(--text-outline),\n    -2px 2px 0 var(--text-outline),\n    -1px 2px 0 var(--text-outline),\n    0px 2px 0 var(--text-outline),\n    1px 2px 0 var(--text-outline),\n    2px 2px 0 var(--text-outline);\n}\n\n/* Secondary metrics container - center section */\n.metrics-secondary {\n  display: flex;\n  gap: var(--spacing-2xl);\n  flex: 1;\n  justify-content: center;\n  align-items: center;\n}\n\n.metric-secondary {\n  display: flex;\n  flex-direction: row;\n  align-items: baseline;\n  gap: 4px;\n}\n\n.metric-value-secondary {\n  font-size: var(--font-size-2xl) !important;\n  font-weight: 600 !important;\n  line-height: 1;\n  font-variant-numeric: tabular-nums;\n  letter-spacing: -0.02em;\n  color: var(--text-primary);\n}\n\n.metric-label-secondary {\n  font-size: var(--font-size-xs) !important;\n  text-transform: uppercase;\n  margin-top: 0;\n  font-weight: 500 !important;\n  letter-spacing: 0.08em;\n  color: var(--text-muted);\n}\n\n/* Control buttons for overlay mode - vertical stack on the right */\n.activity-controls-overlay {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-sm);\n  flex-shrink: 0;\n}\n\n.control-btn-overlay {\n  padding: 10px 20px;\n  font-size: var(--font-size-sm);\n  font-weight: 500;\n  border-radius: 12px;\n  background: rgba(0, 0, 0, 0.4);\n  backdrop-filter: blur(10px);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  color: var(--text-primary);\n  cursor: pointer;\n  transition:\n    background var(--transition-fast),\n    border-color var(--transition-fast),\n    transform var(--transition-fast);\n  min-width: 85px;\n  white-space: nowrap;\n}\n\n.control-btn-overlay:hover {\n  background: rgba(0, 0, 0, 0.5);\n  border-color: rgba(255, 255, 255, 0.3);\n  transform: scale(1.02);\n}\n\n.control-btn-overlay:active {\n  transform: scale(0.98);\n}\n\n.control-btn-overlay.primary {\n  background: var(--accent);\n  border-color: var(--accent);\n  color: var(--text-on-accent);\n}\n\n.control-btn-overlay.primary:hover {\n  background: var(--accent-bright);\n  border-color: var(--accent-bright);\n}\n\n.control-btn-overlay.primary.recording {\n  background: var(--warning);\n  border-color: var(--warning);\n}\n\n.control-btn-overlay.primary.paused {\n  background: var(--success);\n  border-color: var(--success);\n}\n\n.control-btn-overlay.stop {\n  background: rgba(255, 59, 48, 0.2);\n  border-color: rgba(255, 59, 48, 0.5);\n  color: var(--danger);\n}\n\n.control-btn-overlay.stop:hover {\n  background: rgba(255, 59, 48, 0.3);\n  border-color: rgba(255, 59, 48, 0.6);\n}\n\n.metrics {\n  display: flex;\n  justify-content: space-around;\n  gap: var(--spacing-xl);\n  margin-bottom: var(--spacing-md);\n}\n\n.metric {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  flex: 1;\n}\n\n.metric-value {\n  font-size: var(--font-size-2xl);\n  font-weight: 200;\n  line-height: 1;\n  font-variant-numeric: tabular-nums;\n  letter-spacing: -0.02em;\n}\n\n.metric-label {\n  font-size: var(--font-size-xs);\n  text-transform: uppercase;\n  color: var(--text-muted);\n  margin-top: 2px;\n  letter-spacing: 0.08em;\n  font-weight: 500;\n}\n\n.activity-controls {\n  display: flex;\n  gap: var(--spacing-sm);\n  justify-content: center;\n}\n\n/* Floating controls - appear above activity bar when active */\n.activity-controls-floating {\n  position: absolute;\n  bottom: calc(100% + var(--spacing-sm));\n  left: 0;\n  right: 0;\n  display: flex;\n  justify-content: space-between;\n  gap: var(--spacing-sm);\n  z-index: calc(var(--z-controls) + 1);\n}\n\n.control-btn-floating {\n  padding: 10px 24px;\n  border: none;\n  border-radius: 100px;\n  font-size: var(--font-size-sm);\n  font-weight: 500;\n  cursor: pointer;\n  transition: all var(--transition-fast);\n  min-width: 90px;\n  background: var(--bg-glass);\n  backdrop-filter: blur(20px);\n  -webkit-backdrop-filter: blur(20px);\n  color: var(--text-primary);\n}\n\n.control-btn-floating:hover {\n  transform: translateY(-2px);\n}\n\n.control-btn-floating:active {\n  transform: translateY(0);\n}\n\n.control-btn-floating.primary {\n  background: var(--accent);\n  color: var(--text-on-accent);\n}\n\n.control-btn-floating.primary:hover {\n  background: var(--accent-bright);\n}\n\n.control-btn-floating.primary.recording {\n  background: var(--warning);\n}\n\n.control-btn-floating.primary.paused {\n  background: var(--success);\n}\n\n.control-btn-floating.stop {\n  background: rgba(255, 59, 48, 0.2);\n  color: white;\n  backdrop-filter: blur(20px);\n  -webkit-backdrop-filter: blur(20px);\n}\n\n.control-btn-floating.stop:hover {\n  background: rgba(255, 59, 48, 0.3);\n}\n\n/* Start button that replaces time metric */\n.control-btn-start {\n  padding: 12px 32px;\n  border: none;\n  border-radius: 100px;\n  font-size: var(--font-size-sm);\n  font-weight: 500;\n  cursor: pointer;\n  transition: all var(--transition-fast);\n  background: var(--accent);\n  color: var(--text-on-accent);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n.control-btn-start:hover {\n  background: var(--accent-bright);\n  transform: translateY(-1px);\n}\n\n.control-btn-start:active {\n  transform: translateY(0);\n}\n\n/* Compact start button */\n.control-btn-start-compact {\n  padding: 10px 24px;\n  border: none;\n  border-radius: 100px;\n  font-size: var(--font-size-sm);\n  font-weight: 500;\n  cursor: pointer;\n  transition: all var(--transition-fast);\n  background: var(--accent);\n  color: var(--text-on-accent);\n  min-width: 90px;\n  justify-self: end;\n  align-self: center;\n}\n\n.control-btn-start-compact:hover {\n  background: var(--accent-bright);\n  transform: scale(1.02);\n}\n\n.control-btn-start-compact:active {\n  transform: scale(0.98);\n}\n\n/* Overlay start button */\n.control-btn-start-overlay {\n  padding: 10px 24px;\n  border: none;\n  border-radius: 100px;\n  font-size: var(--font-size-sm);\n  font-weight: 500;\n  cursor: pointer;\n  transition: all var(--transition-fast);\n  background: var(--accent);\n  color: var(--text-on-accent);\n  min-width: 90px;\n}\n\n.control-btn-start-overlay:hover {\n  background: var(--accent-bright);\n  transform: scale(1.02);\n}\n\n.control-btn-start-overlay:active {\n  transform: scale(0.98);\n}\n\n/* ============================================================================\n   Compass Rose\n   ============================================================================ */\n\n.header-right {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-md);\n}\n\n.compass-rose {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.95);\n  border: none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all var(--transition-fast);\n  position: relative;\n  box-shadow: 0 2px 4px var(--shadow-sm);\n  color: #4285f4;\n}\n\n.compass-rose:hover {\n  box-shadow: 0 4px 8px var(--shadow-md);\n}\n\n/* Blue dot indicator */\n.compass-dot {\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n  background: #4285f4;\n  position: relative;\n}\n\n.compass-dot.no-gps {\n  background: #9e9e9e;\n}\n\n.compass-dot.active {\n  width: 16px;\n  height: 16px;\n  background: #4285f4;\n  box-shadow: 0 0 0 3px rgba(66, 133, 244, 0.3);\n}\n\n/* Compass arrow */\n.compass-arrow {\n  color: #4285f4;\n  transition: none; /* No transition since parent rotates */\n}\n\n/* North mode */\n.compass-north {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 0;\n}\n\n.compass-north .compass-arrow-small {\n  color: #ea4335;\n  margin-bottom: -4px;\n}\n\n.compass-north span {\n  font-size: var(--font-size-sm);\n  font-weight: 600;\n  color: #ea4335;\n}\n\n/* Active states */\n.compass-rose.mode-center,\n.compass-rose.mode-compass,\n.compass-rose.mode-compass-locked,\n.compass-rose.mode-north {\n  background: white;\n}\n\n.compass-rose.mode-compass .compass-arrow,\n.compass-rose.mode-compass-locked .compass-arrow {\n  color: #4285f4;\n}\n\n/* Subtle pulse for active tracking */\n.compass-rose.mode-center .compass-dot,\n.compass-rose.mode-compass,\n.compass-rose.mode-compass-locked,\n.compass-rose.mode-north {\n  animation: subtlePulse 3s ease-in-out infinite;\n}\n\n@keyframes subtlePulse {\n  0%,\n  100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.8;\n  }\n}\n\n/* Error state - red border */\n.compass-rose.error {\n  border: 3px solid #ff3b30 !important;\n  animation: errorPulse 2s ease-in-out infinite;\n}\n\n.compass-rose.error .compass-dot {\n  background: #ff3b30;\n}\n\n.compass-rose.error .compass-arrow {\n  color: #ff3b30;\n}\n\n@keyframes errorPulse {\n  0%,\n  100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.85;\n  }\n}\n\n/* ============================================================================\n   Buttons - Clean & Modern\n   ============================================================================ */\n\n.btn,\n.control-btn {\n  padding: 12px 32px;\n  border: none;\n  border-radius: 100px;\n  font-size: 13px;\n  font-weight: 500;\n  letter-spacing: 0.02em;\n  cursor: pointer;\n  transition: all var(--transition-fast);\n  min-width: 100px;\n  background: rgba(255, 255, 255, 0.1);\n  color: var(--text-primary);\n  position: relative;\n  overflow: hidden;\n}\n\n.btn::before,\n.control-btn::before {\n  content: \"\";\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 0;\n  height: 0;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.1);\n  transform: translate(-50%, -50%);\n  transition:\n    width var(--transition-normal),\n    height var(--transition-normal);\n}\n\n.btn:hover::before,\n.control-btn:hover::before {\n  width: 300px;\n  height: 300px;\n}\n\n.btn:hover,\n.control-btn:hover {\n  transform: translateY(-1px);\n}\n\n.btn:active,\n.control-btn:active {\n  transform: translateY(0);\n}\n\n.btn:disabled,\n.control-btn:disabled {\n  opacity: 0.3;\n  cursor: not-allowed;\n}\n\n.control-btn.primary {\n  background: var(--accent);\n  color: var(--text-on-accent);\n}\n\n.control-btn.primary:hover {\n  background: var(--accent-bright);\n}\n\n.control-btn.primary.recording {\n  background: var(--warning);\n}\n\n.control-btn.primary.paused {\n  background: var(--success);\n}\n\n.control-btn.stop {\n  background: rgba(255, 59, 48, 0.2);\n  color: var(--danger);\n}\n\n.control-btn.stop:hover {\n  background: rgba(255, 59, 48, 0.3);\n}\n\n/* ============================================================================\n   User Menu - Floating Avatar\n   ============================================================================ */\n\n.user-menu {\n  position: relative;\n}\n\n.user-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  background: var(--bg-glass);\n  backdrop-filter: blur(40px);\n  -webkit-backdrop-filter: blur(40px);\n  border: none;\n  cursor: pointer;\n  transition: all var(--transition-fast);\n  position: relative;\n}\n\n.user-btn:hover {\n  transform: scale(1.05);\n  background: var(--bg-glass-strong);\n}\n\n.user-avatar {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n}\n\n.avatar-initial {\n  font-size: var(--font-size-base);\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.guest-icon {\n  font-size: var(--font-size-lg);\n  opacity: 0.7;\n}\n\n/* Status indicator dot */\n.status-dot {\n  position: absolute;\n  bottom: -2px;\n  right: -2px;\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  border: 2px solid var(--bg-primary);\n  transition: all var(--transition-fast);\n}\n\n.status-dot.location-sharing {\n  width: 14px;\n  height: 14px;\n  bottom: -4px;\n  right: -4px;\n  animation: pulse-glow 2s ease-in-out infinite;\n}\n\n@keyframes pulse-glow {\n  0%,\n  100% {\n    box-shadow: 0 0 4px rgba(59, 130, 246, 0.5);\n  }\n  50% {\n    box-shadow: 0 0 8px rgba(59, 130, 246, 0.8);\n  }\n}\n\n.status-dot.pulse {\n  animation: pulse 2s infinite;\n}\n\n.install-badge {\n  position: absolute;\n  bottom: -2px;\n  left: -2px;\n  width: 16px;\n  height: 16px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: var(--font-size-xs);\n  background: var(--bg-primary);\n  border-radius: 50%;\n  border: 2px solid var(--bg-primary);\n}\n\n.install-badge.pulse {\n  animation: installPulse 2.5s ease-out infinite;\n}\n\n@keyframes installPulse {\n  0% {\n    box-shadow: 0 0 0 0 rgba(62, 106, 225, 1);\n    opacity: 1;\n  }\n  35% {\n    box-shadow: 0 0 0 6px rgba(62, 106, 225, 0.7);\n    opacity: 0.85;\n  }\n  60% {\n    box-shadow: 0 0 0 7px rgba(62, 106, 225, 0);\n    opacity: 0.7;\n  }\n  100% {\n    box-shadow: 0 0 0 7px rgba(62, 106, 225, 0);\n    opacity: 1;\n  }\n}\n\n@keyframes pulse {\n  0% {\n    box-shadow: 0 0 0 0 currentColor;\n    opacity: 1;\n  }\n  70% {\n    box-shadow: 0 0 0 6px transparent;\n    opacity: 0.7;\n  }\n  100% {\n    box-shadow: 0 0 0 0 transparent;\n    opacity: 1;\n  }\n}\n\n.menu-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: var(--z-modal);\n}\n\n.menu-dropdown {\n  position: absolute;\n  top: calc(100% + var(--spacing-sm));\n  right: 0;\n  min-width: 280px;\n  max-height: calc(100vh - 60px);\n  background: var(--bg-modal);\n  backdrop-filter: blur(40px) saturate(150%);\n  -webkit-backdrop-filter: blur(40px) saturate(150%);\n  border-radius: 16px;\n  overflow-y: auto;\n  z-index: var(--z-modal);\n  box-shadow: 0 10px 40px var(--bg-overlay);\n  animation: slideDown var(--transition-fast);\n}\n\n@keyframes slideDown {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Center menu on smaller screens */\n@media (max-width: 480px) {\n  .menu-dropdown {\n    position: fixed;\n    top: 60px;\n    left: 50%;\n    right: auto;\n    transform: translateX(-50%);\n    animation: slideDownCentered var(--transition-fast);\n  }\n\n  @keyframes slideDownCentered {\n    from {\n      opacity: 0;\n      transform: translateX(-50%) translateY(-10px);\n    }\n    to {\n      opacity: 1;\n      transform: translateX(-50%) translateY(0);\n    }\n  }\n}\n\n/* Update banner */\n.update-banner {\n  padding: 10px 12px;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: var(--text-on-accent);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n}\n\n.update-content {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex: 1;\n}\n\n.update-icon {\n  font-size: var(--font-size-md);\n}\n\n.update-text {\n  font-size: 13px;\n  font-weight: 500;\n}\n\n.update-actions {\n  display: flex;\n  gap: 4px;\n}\n\n.update-btn {\n  padding: 4px 10px;\n  background: rgba(255, 255, 255, 0.2);\n  border: 1px solid rgba(255, 255, 255, 0.3);\n  border-radius: 6px;\n  color: var(--text-on-accent);\n  font-size: 11px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all var(--transition-fast);\n}\n\n.update-btn:hover {\n  background: rgba(255, 255, 255, 0.35);\n}\n\n.dismiss-btn {\n  background: transparent;\n  border: none;\n  color: var(--text-on-accent);\n  font-size: var(--font-size-lg);\n  cursor: pointer;\n  opacity: 0.7;\n  transition: opacity var(--transition-fast);\n  padding: 0 4px;\n}\n\n.dismiss-btn:hover {\n  opacity: 1;\n}\n\n.menu-header {\n  padding: var(--spacing-lg);\n  background: var(--bg-subtle);\n  position: relative;\n}\n\n.menu-header-close {\n  position: absolute;\n  top: 0;\n  right: 0;\n  background: transparent;\n  border: none;\n  color: var(--text-secondary);\n  font-size: 28px;\n  line-height: 1;\n  cursor: pointer;\n  opacity: 0.7;\n  transition: opacity var(--transition-fast);\n  padding: 16px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.menu-header-close:hover {\n  opacity: 1;\n}\n\n/* User details section */\n.user-details {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 16px;\n}\n\n.user-avatar-large {\n  width: 42px;\n  height: 42px;\n  border-radius: 50%;\n  background: var(--accent);\n  color: var(--text-on-accent);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: var(--font-size-lg);\n  font-weight: 600;\n}\n\n.user-info {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  flex: 1;\n  width: 240px;\n}\n\n.user-name {\n  font-size: var(--font-size-md);\n  font-weight: 600;\n  color: var(--text-primary);\n  letter-spacing: -0.01em;\n}\n\n.user-email {\n  font-size: var(--font-size-sm);\n  color: var(--text-secondary);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n/* Status grid */\n.status-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n  padding: 12px;\n  background: rgba(255, 255, 255, 0.02);\n  border-radius: 10px;\n}\n\n.status-item {\n  text-align: center;\n}\n\n.status-item-toggle {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.status-item-toggle .status-value {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.status-label {\n  font-size: var(--font-size-xs);\n  text-transform: uppercase;\n  color: var(--text-muted);\n  letter-spacing: 0.05em;\n  margin-bottom: 4px;\n}\n\n.status-label-clickable {\n  font-size: var(--font-size-xs);\n  text-transform: uppercase;\n  color: var(--text-muted);\n  letter-spacing: 0.05em;\n  margin-bottom: 4px;\n  cursor: pointer;\n  transition: color var(--transition-fast);\n}\n\n.status-label-clickable:hover {\n  color: var(--text-primary);\n}\n\n.status-value {\n  font-size: var(--font-size-sm);\n  font-weight: 500;\n  color: var(--text-primary);\n}\n\n.status-value.online {\n  color: var(--success);\n}\n\n.status-value.offline {\n  color: var(--text-muted);\n}\n\n.status-value.warning {\n  color: var(--warning);\n}\n\n/* Guest state */\n.guest-state {\n  text-align: center;\n  padding: var(--spacing-md) 0;\n}\n\n.guest-avatar {\n  width: 48px;\n  height: 48px;\n  margin: 0 auto 12px;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.05);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: var(--font-size-xl);\n}\n\n.guest-message {\n  font-size: var(--font-size-base);\n  font-weight: 500;\n  color: var(--text-primary);\n  margin-bottom: 4px;\n}\n\n.guest-submessage {\n  font-size: var(--font-size-sm);\n  color: var(--text-secondary);\n}\n\n.menu-items {\n  padding: var(--spacing-sm);\n}\n\n.menu-item {\n  width: 100%;\n  padding: 12px var(--spacing-md);\n  background: transparent;\n  border: none;\n  border-radius: 8px;\n  color: var(--text-secondary);\n  font-size: var(--font-size-base);\n  text-align: left;\n  cursor: pointer;\n  transition: all var(--transition-fast);\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.menu-item .menu-icon {\n  font-size: var(--font-size-md);\n  width: 20px;\n  text-align: center;\n}\n\n.menu-item:hover {\n  background: var(--bg-subtle);\n  color: var(--text-primary);\n}\n\n.menu-item.logout {\n  color: var(--danger);\n}\n\n.menu-item.primary {\n  background: var(--accent);\n  color: var(--text-on-accent);\n  font-weight: 500;\n  justify-content: center;\n  padding: 14px;\n}\n\n.menu-item.primary:hover {\n  background: var(--accent-bright);\n}\n\n.menu-item:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n.menu-item:disabled:hover {\n  background: transparent;\n}\n\n.menu-divider {\n  margin: var(--spacing-sm);\n  border: none;\n  height: 1px;\n  background: var(--bg-subtle);\n}\n\n/* ============================================================================\n   Modals - Clean & Modern\n   ============================================================================ */\n\n.modal-overlay,\n.login-modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: var(--bg-overlay);\n  backdrop-filter: blur(20px);\n  -webkit-backdrop-filter: blur(20px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: var(--z-modal);\n  animation: fadeIn var(--transition-fast);\n}\n\n.modal,\n.login-modal {\n  position: relative;\n  width: 90%;\n  max-width: 380px;\n  background: var(--bg-modal);\n  backdrop-filter: blur(40px) saturate(150%);\n  -webkit-backdrop-filter: blur(40px) saturate(150%);\n  border-radius: 24px;\n  padding: var(--spacing-2xl) var(--spacing-xl) var(--spacing-xl);\n  animation: slideUp var(--transition-normal);\n  box-shadow: 0 20px 60px var(--bg-overlay);\n}\n\n.modal h2,\n.login-modal h2 {\n  font-size: var(--font-size-xl);\n  font-weight: 300;\n  margin-bottom: var(--spacing-xl);\n  text-align: center;\n  letter-spacing: -0.02em;\n}\n\n.settings-modal .close-btn {\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 48px;\n  height: calc(\n    var(--spacing-lg) + 8px + 12px + 2px\n  ); /* Match tab area height */\n  background: transparent;\n  border: none;\n  color: var(--text-muted);\n  font-size: var(--font-size-lg);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all var(--transition-fast);\n  z-index: 10;\n}\n\n.settings-modal .close-btn:hover {\n  background: var(--bg-subtle);\n  color: var(--text-primary);\n}\n\n.settings-modal .close-btn span {\n  transition: transform var(--transition-fast);\n}\n\n.settings-modal .close-btn:hover span {\n  transform: rotate(90deg);\n}\n\n/* ============================================================================\n   Forms - Minimal & Clean\n   ============================================================================ */\n\n.form-group {\n  margin-bottom: var(--spacing-md);\n}\n\ninput[type=\"text\"],\ninput[type=\"email\"],\ninput[type=\"password\"],\ninput[type=\"number\"],\ntextarea,\nselect {\n  width: 100%;\n  padding: 14px var(--spacing-md);\n  background: var(--bg-subtle);\n  border: 1px solid transparent;\n  border-radius: 12px;\n  color: var(--text-primary);\n  font-size: var(--font-size-base);\n  font-weight: 400;\n  transition: all var(--transition-fast);\n}\n\ninput:focus,\ntextarea:focus,\nselect:focus {\n  outline: none;\n  background: var(--bg-elevated);\n  border-color: var(--accent);\n}\n\ninput:disabled,\ntextarea:disabled,\nselect:disabled {\n  opacity: 0.3;\n  cursor: not-allowed;\n}\n\ninput::placeholder {\n  color: var(--text-muted);\n}\n\n.submit-btn {\n  width: 100%;\n  padding: 14px;\n  background: var(--accent);\n  border: none;\n  border-radius: 100px;\n  color: var(--text-on-accent);\n  font-size: var(--font-size-sm);\n  font-weight: 500;\n  letter-spacing: 0.02em;\n  cursor: pointer;\n  transition: all var(--transition-fast);\n  margin-top: var(--spacing-lg);\n}\n\n.submit-btn:hover {\n  background: var(--accent-bright);\n  transform: scale(1.02);\n}\n\n.submit-btn:active {\n  transform: scale(0.98);\n}\n\n.submit-btn:disabled {\n  opacity: 0.3;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.text-btn {\n  background: transparent;\n  border: none;\n  color: var(--text-secondary);\n  font-size: var(--font-size-sm);\n  cursor: pointer;\n  padding: var(--spacing-sm);\n  transition: opacity var(--transition-fast);\n}\n\n.text-btn:hover {\n  color: var(--text-primary);\n}\n\n.text-btn.guest {\n  color: var(--text-muted);\n}\n\n.modal-footer {\n  margin-top: var(--spacing-xl);\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-sm);\n}\n\n.error-message {\n  padding: var(--spacing-sm) var(--spacing-md);\n  background: rgba(255, 59, 48, 0.1);\n  border-radius: 8px;\n  color: var(--danger);\n  font-size: var(--font-size-sm);\n  margin-bottom: var(--spacing-md);\n}\n\n/* ============================================================================\n   Panels - Slide-out Design\n   ============================================================================ */\n\n.panel {\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  width: 320px;\n  max-width: 80vw;\n  background: var(--bg-overlay);\n  backdrop-filter: blur(40px) saturate(150%);\n  -webkit-backdrop-filter: blur(40px) saturate(150%);\n  transform: translateX(-100%);\n  transition: transform var(--transition-normal);\n  z-index: var(--z-controls);\n  overflow-y: auto;\n}\n\n.panel.open {\n  transform: translateX(0);\n  box-shadow: 0 0 40px var(--shadow-lg);\n}\n\n.panel-header {\n  padding: var(--spacing-lg);\n  background: var(--bg-subtle);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  position: sticky;\n  top: 0;\n  z-index: 1;\n}\n\n.panel-title {\n  font-size: var(--font-size-md);\n  font-weight: 400;\n  letter-spacing: -0.02em;\n}\n\n.panel-content {\n  padding: var(--spacing-lg);\n}\n\n/* ============================================================================\n   Animations\n   ============================================================================ */\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes slideUp {\n  from {\n    opacity: 0;\n    transform: translateY(20px) scale(0.95);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n/* ============================================================================\n   Settings Modal\n   ============================================================================ */\n\n.modal.settings-modal {\n  position: fixed !important;\n  top: 50% !important;\n  left: 50% !important;\n  transform: translate(-50%, -50%) !important;\n  width: min(80vw, calc(100vw - 40px)) !important;\n  max-width: none !important;\n  height: min(80vh, calc(100vh - 40px)) !important;\n  min-height: min(500px, calc(100vh - 80px)) !important;\n  overflow: hidden !important;\n  display: flex !important;\n  flex-direction: column !important;\n  padding: 0 !important;\n}\n\n@media (max-width: 600px) {\n  .modal.settings-modal {\n    top: 40px !important;\n    left: 10px !important;\n    transform: none !important;\n    width: calc(100vw - 20px) !important;\n    height: calc(100vh - 80px) !important;\n    min-height: calc(100vh - 80px) !important;\n    border-radius: 6px !important;\n  }\n}\n\n.settings-modal h2 {\n  flex-shrink: 0;\n  padding: 0 var(--spacing-xl);\n  margin-bottom: var(--spacing-lg);\n}\n\n.settings-tabs {\n  display: flex;\n  gap: 4px;\n  margin-bottom: var(--spacing-md);\n  flex-shrink: 0;\n  border-bottom: 1px solid var(--bg-subtle);\n  overflow-x: auto;\n  padding: 0 var(--spacing-xl) 0 var(--spacing-xl);\n  padding-right: 48px; /* Make room for close button */\n  position: relative;\n}\n\n.settings-tabs .tab {\n  padding: var(--spacing-lg) 12px 8px 12px; /* Extra top padding for larger click area */\n  background: transparent;\n  border: none;\n  border-bottom: 2px solid transparent;\n  color: var(--text-secondary);\n  font-size: var(--font-size-sm);\n  font-weight: 500;\n  cursor: pointer;\n  transition: all var(--transition-fast);\n  white-space: nowrap;\n}\n\n.settings-tabs .tab:hover {\n  color: var(--text-primary);\n}\n\n.settings-tabs .tab.active {\n  color: var(--accent);\n  border-bottom-color: var(--accent);\n}\n\n.settings-content {\n  flex: 1;\n  overflow-y: auto;\n  overflow-x: hidden;\n  padding: 0 var(--spacing-xl) var(--spacing-xl) var(--spacing-xl);\n}\n\n/* Custom scrollbar for settings */\n.settings-content::-webkit-scrollbar {\n  width: 6px;\n}\n\n.settings-content::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.settings-content::-webkit-scrollbar-thumb {\n  background: var(--bg-subtle);\n  border-radius: 3px;\n}\n\n/* Activity detail modal with full map background */\n.modal.activity-detail-modal {\n  padding: 0 !important;\n  background: transparent !important;\n  backdrop-filter: none !important;\n  -webkit-backdrop-filter: none !important;\n}\n\n/* Ensure embedded maps fill their containers */\n.embedded-map .ol-viewport {\n  position: absolute !important;\n  top: 0 !important;\n  left: 0 !important;\n  right: 0 !important;\n  bottom: 0 !important;\n  width: 100% !important;\n  height: 100% !important;\n}\n\n.settings-content::-webkit-scrollbar-thumb:hover {\n  background: var(--border);\n}\n\n.settings-section {\n  display: flex;\n  flex-direction: column;\n}\n\n.settings-group-header {\n  font-size: var(--font-size-md);\n  font-weight: 700;\n  color: var(--text-primary);\n  margin: var(--spacing-2xl) calc(var(--spacing-xl) * -1) var(--spacing-lg)\n    calc(var(--spacing-xl) * -1);\n  padding: var(--spacing-md) var(--spacing-xl);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  border-left: 4px solid var(--accent);\n  background: var(--bg-subtle);\n}\n\n.settings-group-header:first-child {\n  margin-top: 0;\n}\n\n/* Setting Row with Toggle */\n.setting-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: var(--spacing-md) 0;\n}\n\n/* Ensure slider comes before toggle on larger screens */\n.setting-row .slider-controls {\n  order: 1;\n}\n\n.setting-row .toggle-button {\n  order: 2;\n}\n\n@media (max-width: 500px) {\n  .setting-row {\n    flex-wrap: wrap;\n  }\n\n  .setting-info {\n    margin-right: var(--spacing-sm);\n    min-width: auto;\n    flex: 1;\n  }\n\n  .setting-row .setting-description {\n    display: none;\n  }\n\n  /* Stack slider controls below on mobile */\n  .setting-row .slider-controls {\n    order: 3;\n    width: 100%;\n    margin-top: var(--spacing-sm);\n    justify-content: flex-start !important;\n  }\n\n  .setting-row .toggle-button {\n    order: 2;\n  }\n}\n\n.setting-info {\n  flex: 1;\n  margin-right: var(--spacing-lg);\n  min-width: 200px;\n}\n\n.setting-label {\n  font-size: var(--font-size-base);\n  font-weight: 500;\n  color: var(--text-primary);\n  margin-bottom: 2px;\n}\n\n.setting-row .setting-description {\n  font-size: var(--font-size-sm);\n  color: var(--text-secondary);\n  margin: 0;\n  line-height: 1.3;\n}\n\n/* Toggle Switch */\n.toggle-button {\n  position: relative;\n  width: 48px;\n  height: 26px;\n  background: var(--bg-subtle);\n  border: 1px solid var(--border);\n  border-radius: 13px;\n  cursor: pointer;\n  transition: all var(--transition-fast);\n  padding: 0;\n  flex-shrink: 0;\n}\n\n.toggle-button.checked {\n  background: var(--accent);\n  border-color: var(--accent);\n}\n\n.toggle-slider {\n  position: absolute;\n  top: 2px;\n  left: 2px;\n  width: 20px;\n  height: 20px;\n  background: var(--bg-button-slider);\n  border-radius: 50%;\n  box-shadow: 0 2px 4px var(--shadow-sm);\n  transition: all var(--transition-fast);\n}\n\n.toggle-button.checked .toggle-slider {\n  transform: translateX(22px);\n}\n\n/* High contrast light theme - add white border to knob */\n.theme-high-contrast-light .toggle-slider {\n  border: 1px solid #ffffff;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n}\n\n/* Traditional Setting Groups */\n.setting-group {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n}\n\n.setting-group > label {\n  display: block;\n  font-size: var(--font-size-sm);\n  font-weight: 500;\n  color: var(--text-primary);\n  margin-bottom: var(--spacing-sm);\n}\n\n.setting-group select {\n  width: 100%;\n  padding: 10px 12px;\n  background: var(--bg-subtle);\n  border: 1px solid var(--border-light);\n  border-radius: 8px;\n  color: var(--text-primary);\n  font-size: var(--font-size-sm);\n  cursor: pointer;\n}\n\n/* Slider Settings */\n.slider-setting {\n  padding: var(--spacing-sm) 0;\n  border-bottom: 1px solid var(--border);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.slider-setting label {\n  color: var(--text-primary);\n  font-size: var(--font-size-base);\n  font-weight: 500;\n  margin-right: var(--spacing-md);\n  flex-shrink: 0;\n}\n\n.slider-setting input[type=\"range\"],\n.opacity-slider,\n.track-width-slider {\n  width: 150px;\n  height: 4px;\n  background: var(--bg-subtle);\n  border-radius: 2px;\n  outline: none;\n  -webkit-appearance: none;\n  border: none;\n}\n\n.track-width-slider {\n  background: var(--track-color, #3e6ae1) !important;\n  height: var(--track-width, 4px) !important;\n  border-radius: calc(var(--track-width, 4px) / 2) !important;\n  min-height: 1px !important;\n  max-height: 15px !important;\n  box-shadow: var(\n    --track-outline,\n    0 0 0 1px #ffffff\n  ) !important; /* White outline if enabled */\n}\n\n.slider-setting input[type=\"range\"]::-webkit-slider-thumb,\n.opacity-slider::-webkit-slider-thumb,\n.track-width-slider::-webkit-slider-thumb {\n  -webkit-appearance: none;\n  width: 20px;\n  height: 20px;\n  background: var(--accent);\n  border-radius: 50%;\n  cursor: pointer;\n  box-shadow: 0 2px 4px var(--shadow-sm);\n  border: none;\n}\n\n.slider-setting input[type=\"range\"]::-moz-range-thumb,\n.opacity-slider::-moz-range-thumb,\n.track-width-slider::-moz-range-thumb {\n  width: 20px;\n  height: 20px;\n  background: var(--accent);\n  border-radius: 50%;\n  cursor: pointer;\n  box-shadow: 0 2px 4px var(--shadow-sm);\n  border: none;\n}\n\n.setting-description {\n  font-size: var(--font-size-sm);\n  color: var(--text-secondary);\n  line-height: 1.5;\n  margin: 4px 0;\n}\n\n.setting-description a {\n  color: var(--accent);\n  text-decoration: none;\n}\n\n.setting-description a:hover {\n  text-decoration: underline;\n}\n\n.radio-group {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-sm);\n}\n\n.radio-group label {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-sm);\n  margin-bottom: 0;\n  font-weight: normal;\n}\n\n/* Map Styles Section */\n.map-category {\n  font-size: var(--font-size-sm);\n  font-weight: 600;\n  color: var(--text-secondary);\n  margin: var(--spacing-lg) 0 var(--spacing-sm) 0;\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-sm);\n}\n\n.api-badge {\n  font-size: var(--font-size-xs);\n  background: var(--accent);\n  color: var(--text-on-accent);\n  padding: 2px 6px;\n  border-radius: 4px;\n}\n\n.map-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: var(--spacing-sm);\n  margin-bottom: var(--spacing-md);\n}\n\n.map-style-button {\n  padding: var(--spacing-sm);\n  border-radius: 8px;\n  border: 1px solid var(--border);\n  background: transparent;\n  cursor: pointer;\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  text-align: left;\n  position: relative;\n  transition: all var(--transition-fast);\n  color: var(--text-primary);\n}\n\n.map-style-button.selected {\n  border-color: var(--accent);\n  background: var(--bg-subtle);\n}\n\n.map-style-button.unavailable {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.map-style-button:hover:not(.unavailable) {\n  border-color: var(--accent);\n}\n\n.map-style-info {\n  flex: 1;\n}\n\n.map-style-name {\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--text-primary);\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 4px;\n  white-space: nowrap;\n}\n\n.map-style-desc {\n  font-size: var(--font-size-xs);\n  color: var(--text-secondary);\n  margin-top: 2px;\n}\n\n.star-icon {\n  font-size: var(--font-size-base);\n  opacity: 0.3;\n  transition: opacity var(--transition-fast);\n}\n\n.star-icon.starred {\n  opacity: 1;\n}\n\n.lock-icon {\n  font-size: var(--font-size-xs);\n}\n\n.api-key-input {\n  display: flex;\n  gap: var(--spacing-sm);\n  align-items: center;\n}\n\n.api-key-input input {\n  flex: 1;\n}\n\n.api-key-input .btn {\n  padding: 10px 20px;\n  background: var(--accent);\n  color: var(--text-on-accent);\n  border: none;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all var(--transition-fast);\n}\n\n.api-key-input .btn:hover {\n  background: var(--accent-bright);\n}\n\n/* Help Section Styles */\n.help-section {\n  margin-bottom: var(--spacing-xl);\n}\n\n.help-section-title {\n  font-size: var(--font-size-base);\n  font-weight: 600;\n  color: var(--text-primary);\n  margin-bottom: var(--spacing-md);\n}\n\n.help-content {\n  font-size: var(--font-size-sm);\n  color: var(--text-secondary);\n  line-height: 1.6;\n}\n\n.help-content p {\n  margin-bottom: var(--spacing-md);\n}\n\n.help-content ul {\n  margin: var(--spacing-md) 0;\n  padding-left: var(--spacing-xl);\n}\n\n.help-content li {\n  margin-bottom: var(--spacing-sm);\n}\n\n.help-content strong {\n  color: var(--text-primary);\n  font-weight: 600;\n}\n\n.help-image-placeholder {\n  background: var(--bg-subtle);\n  border: 2px dashed var(--border);\n  border-radius: 8px;\n  padding: var(--spacing-xl);\n  margin: var(--spacing-md) 0;\n  text-align: center;\n  color: var(--text-secondary);\n  font-size: 13px;\n  font-style: italic;\n}\n\n/* ============================================================================\n   Dynamic Island - iOS-style expandable notification\n   ============================================================================ */\n\n.dynamic-island {\n  position: fixed;\n  top: 0;\n  left: 50%;\n  transform: translateX(-50%);\n  transform-origin: top center;\n  z-index: calc(var(--z-modal) + 100);\n  background: var(--bg-glass);\n  backdrop-filter: blur(40px) saturate(150%);\n  -webkit-backdrop-filter: blur(40px) saturate(150%);\n  border-radius: 0 0 20px 20px;\n  overflow: visible;\n  animation: dynamicIslandSlideDown 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94)\n    forwards;\n  transition:\n    width 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94),\n    height 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94),\n    background 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94),\n    transform 0.2s cubic-bezier(0.25, 0.46, 0.45, 0.94);\n  pointer-events: auto;\n  cursor: pointer;\n  width: 200px;\n  height: 36px;\n  box-shadow: 0 4px 20px var(--shadow-md);\n}\n\n.dynamic-island.expanded {\n  width: 380px;\n  max-width: calc(100vw - 20px);\n  height: 200px;\n  background: var(--bg-glass-strong);\n  cursor: default;\n  padding-top: 0;\n}\n\n.dynamic-island:hover:not(.expanded) {\n  transform: translateX(-50%) scale(1.05);\n}\n\n.dynamic-island.notification {\n  border: 1px solid rgba(62, 106, 225, 0.3);\n}\n\n.dynamic-island.warning {\n  border: 1px solid rgba(255, 149, 0, 0.3);\n}\n\n.dynamic-island.success {\n  border: 1px solid rgba(0, 210, 0, 0.3);\n}\n\n.island-compact-container {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  padding: 0;\n}\n\n.island-compact {\n  padding: 13px var(--spacing-sm) var(--spacing-xs);\n  display: flex;\n  align-items: center;\n  gap: 0;\n  min-height: 30px;\n  width: 100%;\n  transform-origin: top center;\n}\n\n.island-compact:hover {\n  background: rgba(255, 255, 255, 0.05);\n}\n\n.island-compact-left {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-xs);\n}\n\n.island-compact-icon {\n  font-size: var(--font-size-base);\n  width: 16px;\n  text-align: center;\n}\n\n.island-compact-text {\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--text-primary);\n  white-space: nowrap;\n}\n\n.island-compact-center {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: var(--spacing-xs);\n  min-width: 0; /* Allow shrinking */\n}\n\n.island-compact-progress {\n  flex: 1;\n  height: 2px;\n  background: rgba(255, 255, 255, 0.15);\n  border-radius: 1px;\n  overflow: hidden;\n  max-width: 60px;\n}\n\n.island-compact-progress-fill {\n  height: 100%;\n  background: var(--accent);\n  transition: width var(--transition-fast);\n  border-radius: 1px;\n}\n\n.island-compact-progress-fill.sim {\n  background: rgba(255, 193, 7, 0.9);\n}\n\n.island-compact-right {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-xs);\n}\n\n.island-compact-stat {\n  font-size: var(--font-size-xs);\n  font-weight: 500;\n  color: var(--text-secondary);\n  white-space: nowrap;\n}\n\n.island-compact-percentage {\n  font-size: var(--font-size-xs);\n  font-weight: 600;\n  color: var(--text-primary);\n  white-space: nowrap;\n}\n\n.dynamic-island-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: calc(var(--z-modal) + 99);\n  background: transparent;\n  cursor: pointer;\n}\n\n.island-expanded-container {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  overflow: hidden;\n}\n\n.island-expanded-content {\n  padding: 0;\n  width: 380px;\n  height: 200px;\n  transform-origin: top center;\n  flex-shrink: 0;\n  box-sizing: border-box;\n}\n\n.island-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: var(--spacing-md);\n  padding: var(--spacing-sm);\n}\n\n.island-header-content {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-sm);\n  flex: 1;\n}\n\n.island-icon {\n  font-size: var(--font-size-md);\n  width: 20px;\n  text-align: center;\n}\n\n.island-text {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.island-title {\n  font-size: var(--font-size-sm);\n  font-weight: 600;\n  color: var(--text-primary);\n  line-height: 1.2;\n}\n\n.island-subtitle {\n  font-size: var(--font-size-xs);\n  color: var(--text-secondary);\n  line-height: 1.2;\n}\n\n.island-actions {\n  display: flex;\n  gap: 4px;\n  align-items: center;\n}\n\n.island-btn {\n  padding: 6px 12px;\n  border: none;\n  border-radius: 8px;\n  background: rgba(255, 255, 255, 0.1);\n  color: var(--text-primary);\n  font-size: 11px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all var(--transition-fast);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  min-width: 50px;\n}\n\n.island-btn:hover {\n  background: rgba(255, 255, 255, 0.2);\n}\n\n.island-btn.primary {\n  background: var(--accent);\n  color: var(--text-on-accent);\n}\n\n.island-btn.primary:hover {\n  background: var(--accent-bright);\n}\n\n.island-btn.stop {\n  background: rgba(255, 59, 48, 0.2);\n  color: var(--danger);\n}\n\n.island-btn.stop:hover {\n  background: rgba(255, 59, 48, 0.3);\n}\n\n.island-close {\n  width: 40px;\n  height: 40px;\n  border: none;\n  background: none;\n  color: var(--text-secondary);\n  cursor: pointer;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 22px; /* Larger × symbol for easier clicking */\n  transition: all var(--transition-fast);\n  margin-left: var(--spacing-xs);\n  margin-right: -8px; /* Expand clickable area to the edge */\n  margin-top: -6px;\n  margin-bottom: -6px;\n}\n\n.island-close:hover {\n  background: rgba(255, 255, 255, 0.1);\n  color: var(--text-primary);\n}\n\n.island-close-btn {\n  width: 40px !important;\n  height: 40px !important;\n  font-size: 22px !important;\n  background: none;\n  border: none;\n  color: var(--text-secondary);\n  cursor: pointer;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  transition: all var(--transition-fast);\n  padding: 0 !important;\n  margin: -6px -8px -6px -4px !important; /* Expand clickable area: top right bottom left */\n}\n\n.island-close-btn:hover {\n  background: rgba(255, 255, 255, 0.1) !important;\n  color: var(--text-primary);\n}\n\n.island-details {\n  padding: 0 var(--spacing-md) var(--spacing-sm) var(--spacing-md);\n  border-top: 1px solid rgba(255, 255, 255, 0.08);\n  background: rgba(255, 255, 255, 0.02);\n}\n\n.island-progress {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: var(--spacing-xs);\n}\n\n.island-progress-text {\n  font-size: var(--font-size-xs);\n  color: var(--text-secondary);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.island-progress-bar {\n  flex: 1;\n  height: 2px;\n  background: rgba(255, 255, 255, 0.1);\n  border-radius: 1px;\n  margin: 0 var(--spacing-sm);\n  overflow: hidden;\n}\n\n.island-progress-fill {\n  height: 100%;\n  background: var(--accent);\n  transition: width var(--transition-fast);\n  border-radius: 1px;\n}\n\n.island-progress-fill.sim {\n  background: rgba(255, 193, 7, 0.8);\n}\n\n.island-stats {\n  display: flex;\n  justify-content: space-between;\n  font-size: var(--font-size-xs);\n  color: var(--text-secondary);\n}\n\n.island-stat {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 2px;\n}\n\n.island-stat-value {\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.island-stat-label {\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n@keyframes dynamicIslandSlideDown {\n  from {\n    opacity: 0;\n    transform: translateX(-50%) translateY(-20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateX(-50%) translateY(0);\n  }\n}\n\n/* always fixed size */\n.dynamic-island {\n  width: 160px;\n  height: 40px;\n}\n\n/* Mobile responsive */\n@media (max-width: 600px) {\n  .dynamic-island {\n    width: 160px;\n    height: 40px;\n  }\n\n  /* .dynamic-island.expanded {\n    width: calc(100vw - 20px);\n    max-width: calc(100vw - 20px);\n  } */\n\n  .island-title {\n    font-size: var(--font-size-sm);\n  }\n\n  .island-subtitle {\n    font-size: var(--font-size-xs);\n  }\n\n  .island-btn {\n    padding: 6px 12px;\n    font-size: 11px;\n    min-width: 50px;\n  }\n\n  .island-actions {\n    gap: 4px;\n  }\n}\n\n/* ============================================================================\n   Utility Classes\n   ============================================================================ */\n\n.hidden {\n  display: none !important;\n}\n\n.text-center {\n  text-align: center;\n}\n\n.text-muted {\n  color: var(--text-secondary);\n}\n\n/* ============================================================================\n   Responsive Design\n   ============================================================================ */\n\n@media (max-width: 768px) {\n  .header {\n    padding: 0 var(--spacing-md);\n  }\n\n  .activity-bar {\n    bottom: var(--spacing-md);\n    width: calc(100vw - var(--spacing-xl));\n    border-radius: 20px;\n  }\n\n  .metrics {\n    gap: var(--spacing-lg);\n  }\n\n  .metric-value {\n    font-size: 28px;\n  }\n\n  /* Compact layout responsive */\n  .activity-bar--compact {\n    width: calc(100vw - var(--spacing-lg));\n  }\n\n  .activity-bar--compact .metric-value {\n    font-size: var(--font-size-lg);\n  }\n\n  .activity-bar--compact .metrics {\n    gap: var(--spacing-sm);\n  }\n\n  /* Overlay layout responsive */\n  .activity-bar--overlay {\n    width: calc(100vw - var(--spacing-lg));\n    padding: var(--spacing-xs) var(--spacing-lg);\n    gap: var(--spacing-lg);\n  }\n\n  .metric-value-hero {\n    font-size: 144px;\n  }\n\n  .metric-label-hero {\n    font-size: 32px;\n  }\n\n  .metric-value-secondary {\n    font-size: 26px;\n  }\n\n  .control-btn-overlay {\n    font-size: var(--font-size-sm);\n    padding: 8px 16px;\n    min-width: 75px;\n  }\n\n  .modal,\n  .login-modal {\n    width: 95%;\n    padding: var(--spacing-xl) var(--spacing-lg) var(--spacing-lg);\n  }\n\n  .panel {\n    width: 100%;\n    max-width: 100%;\n  }\n}\n\n/* Map button styling */\n.map-cycle-btn {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-xs);\n}\n\n.map-icon {\n  font-size: 16px;\n  line-height: 1;\n  display: inline-block;\n}\n\n.map-name {\n  max-width: 150px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n@media (max-width: 480px) {\n  .map-cycle-btn {\n    padding: var(--spacing-sm);\n    min-width: auto;\n    width: auto;\n    max-width: 90px;\n    height: 32px;\n    border-radius: 16px;\n    justify-content: center;\n    gap: var(--spacing-xs);\n  }\n\n  .map-icon {\n    font-size: 14px;\n  }\n\n  .map-name {\n    max-width: 50px;\n  }\n\n  .activity-bar {\n    padding: var(--spacing-md);\n  }\n\n  .metric-value {\n    font-size: var(--font-size-xl);\n  }\n\n  /* Compact layout - extra small screens */\n  .activity-bar--compact {\n    padding: var(--spacing-xs) var(--spacing-sm);\n    border-radius: 16px;\n  }\n\n  .activity-bar--compact .metric {\n    min-width: 50px;\n  }\n\n  .activity-bar--compact .metric-value {\n    font-size: var(--font-size-lg);\n  }\n\n  .activity-bar--compact .metric-label {\n    font-size: 7px;\n  }\n\n  .activity-bar--compact .control-btn {\n    padding: 6px 16px;\n    font-size: 11px;\n    min-width: 70px;\n  }\n\n  /* Overlay layout - extra small screens */\n  .activity-bar--overlay {\n    padding: var(--spacing-xs) var(--spacing-md);\n    border-radius: 16px;\n    gap: var(--spacing-md);\n  }\n\n  .metric-value-hero {\n    font-size: 128px;\n  }\n\n  .metric-label-hero {\n    font-size: 28px;\n  }\n\n  .metric-value-secondary {\n    font-size: var(--font-size-lg);\n  }\n\n  .metric-label-secondary {\n    font-size: 9px;\n  }\n\n  .control-btn-overlay {\n    padding: 8px 14px;\n    font-size: 11px;\n    min-width: 65px;\n  }\n}\n\n/* ============================================================================\n   Debug Console - Allow Text Selection\n   ============================================================================ */\n\n/* Allow text selection in debug console and related elements */\n.debug-console,\n.debug-console *,\n.debug-object,\npre {\n  -webkit-user-select: text !important;\n  -moz-user-select: text !important;\n  -ms-user-select: text !important;\n  user-select: text !important;\n}\n\n.debug-console *[style*=\"display: none\"],\n.debug-console *[id^=\"caret-stack-\"] {\n  -webkit-user-select: none !important;\n  -moz-user-select: none !important;\n  -ms-user-select: none !important;\n  user-select: none !important;\n}\n\n/* Debug Console Scrollbars */\n.debug-console-scroll {\n  scrollbar-width: thin;\n  scrollbar-color: rgba(255, 255, 255, 0.3) rgba(255, 255, 255, 0.1);\n  overflow-y: scroll !important;\n  overflow-x: hidden !important;\n}\n\n.debug-console-scroll::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n  -webkit-appearance: none;\n}\n\n.debug-console-scroll::-webkit-scrollbar-track {\n  background: rgba(255, 255, 255, 0.1);\n  border-radius: 4px;\n}\n\n.debug-console-scroll::-webkit-scrollbar-thumb {\n  background: rgba(255, 255, 255, 0.3);\n  border-radius: 4px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  min-height: 20px;\n}\n\n.debug-console-scroll::-webkit-scrollbar-thumb:hover {\n  background: rgba(255, 255, 255, 0.5);\n}\n\n.debug-console-scroll::-webkit-scrollbar-corner {\n  background: rgba(255, 255, 255, 0.1);\n}\n\n/* Make stack trace arrows inherit container font size */\n.debug-console-scroll [id*=\"caret-\"] {\n  font-size: inherit !important;\n  margin-top: 0 !important;\n  line-height: inherit !important;\n}\n\n/* Hide VSCode file links on small screens - only the right-side file link divs */\n@media (max-width: 768px) {\n  .debug-console-scroll\n    div[style*=\"margin-left: auto\"][style*=\"padding-left: 8px\"] {\n    display: none !important;\n  }\n}\n\n/* ============================================================================\n   Activity Detail View\n   ============================================================================ */\n\n.activity-detail-header {\n  position: absolute;\n  top: var(--spacing-lg);\n  left: 70px; /* Account for fit button */\n  right: 70px; /* Account for close button */\n  width: auto;\n  margin: 0 auto;\n  max-width: 400px;\n  background: var(--bg-overlay);\n  backdrop-filter: blur(40px) saturate(150%);\n  -webkit-backdrop-filter: blur(40px) saturate(150%);\n  border-radius: 16px;\n  padding: 4px 12px;\n  pointer-events: auto;\n}\n\n.activity-detail-header h2 {\n  margin: 0;\n  padding: 0 !important; /* Override any inherited padding */\n  color: var(--text-primary);\n  font-size: 1.1rem;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  text-align: left;\n}\n\n.activity-detail-stats {\n  position: absolute;\n  bottom: var(--spacing-lg);\n  left: var(--spacing-lg);\n  right: var(--spacing-lg);\n  width: auto;\n  margin: 0 auto;\n  max-width: fit-content;\n  background: var(--bg-overlay);\n  backdrop-filter: blur(40px) saturate(150%);\n  -webkit-backdrop-filter: blur(40px) saturate(150%);\n  border-radius: 16px;\n  padding: 12px 20px;\n  pointer-events: auto;\n}\n\n.activity-detail-stats-grid {\n  display: flex;\n  gap: 24px;\n  justify-content: center;\n}\n\n.activity-detail-stat {\n  text-align: center;\n  white-space: nowrap;\n  flex-shrink: 1;\n}\n\n.activity-detail-stat-label {\n  font-size: var(--font-size-xs);\n  text-transform: uppercase;\n  letter-spacing: 0.1em;\n  color: var(--text-muted);\n  margin-bottom: 2px;\n  line-height: 1;\n  opacity: 0.7;\n}\n\n.activity-detail-stat-value {\n  font-size: var(--font-size-lg);\n  font-weight: 300;\n  color: var(--text-primary);\n  line-height: 1.1;\n}\n\n/* Distance and Duration - larger */\n.activity-detail-stat:nth-child(1) .activity-detail-stat-value,\n.activity-detail-stat:nth-child(2) .activity-detail-stat-value {\n  font-size: var(--font-size-xl);\n}\n\n/* Avg Speed and Max Speed - smaller */\n.activity-detail-stat:nth-child(3) .activity-detail-stat-value,\n.activity-detail-stat:nth-child(4) .activity-detail-stat-value {\n  font-size: var(--font-size-lg);\n}\n\n/* Responsive adjustments - only layout changes, not font sizes */\n@media (max-width: 600px) {\n  .activity-detail-stats {\n    padding: var(--spacing-md);\n  }\n\n  .activity-detail-stats-grid {\n    gap: var(--spacing-md);\n    flex-wrap: wrap;\n  }\n\n  /* All stats wrap to 2x2 grid */\n  .activity-detail-stat {\n    flex: 1 1 calc(50% - var(--spacing-md) / 2);\n    min-width: 0;\n  }\n}\n\n/* ============================================================================\n   Persistent Quick Island - Always visible mini control center\n   ============================================================================ */\n\n.persistent-quick-island {\n  position: fixed;\n  top: 8px;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: calc(var(--z-modal) + 50);\n  background: var(--bg-glass-strong);\n  backdrop-filter: blur(40px) saturate(150%);\n  -webkit-backdrop-filter: blur(40px) saturate(150%);\n  border-radius: 100px;\n  padding: 4px 8px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 280px;\n  height: 40px;\n  box-shadow: 0 4px 20px var(--shadow-md);\n  transition: all var(--transition-fast);\n}\n\n.quick-island-items {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.quick-island-items.left {\n  flex: 1;\n  justify-content: flex-end;\n}\n\n.quick-island-items.right {\n  flex: 1;\n  justify-content: flex-start;\n}\n\n.quick-island-clock {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0 12px;\n  min-width: 80px;\n}\n\n.clock-time {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--text-primary);\n  font-variant-numeric: tabular-nums;\n  letter-spacing: -0.01em;\n}\n\n.quick-island-item {\n  position: relative;\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all var(--transition-fast);\n  padding: 0;\n}\n\n.quick-island-item:hover {\n  background: var(--bg-subtle);\n  transform: scale(1.1);\n}\n\n.quick-island-item:active {\n  transform: scale(0.95);\n}\n\n.quick-island-item.active {\n  background: rgba(var(--accent-rgb, 62, 106, 225), 0.2);\n}\n\n.quick-island-item.pulse {\n  animation: quickIslandPulse 2s ease-in-out infinite;\n}\n\n@keyframes quickIslandPulse {\n  0%,\n  100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n  50% {\n    opacity: 0.7;\n    transform: scale(0.95);\n  }\n}\n\n.quick-island-item.expanded {\n  background: var(--bg-elevated);\n}\n\n.quick-island-icon {\n  font-size: var(--font-size-md);\n  z-index: 2;\n  position: relative;\n}\n\n.quick-island-badge {\n  position: absolute;\n  top: -2px;\n  right: -2px;\n  background: var(--danger);\n  color: var(--text-on-accent);\n  font-size: 9px;\n  font-weight: 600;\n  padding: 1px 4px;\n  border-radius: 10px;\n  min-width: 14px;\n  text-align: center;\n  z-index: 3;\n}\n\n.progress-ring {\n  pointer-events: none;\n}\n\n/* Detail view that expands from clicked item */\n.quick-island-detail-view {\n  position: fixed;\n  top: 60px;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: calc(var(--z-modal) + 45);\n  background: var(--bg-modal);\n  backdrop-filter: blur(40px) saturate(150%);\n  -webkit-backdrop-filter: blur(40px) saturate(150%);\n  border-radius: 20px;\n  padding: var(--spacing-lg);\n  min-width: 320px;\n  max-width: 420px;\n  box-shadow: 0 10px 40px var(--bg-overlay);\n  animation: expandIn var(--transition-normal);\n}\n\n@keyframes expandIn {\n  from {\n    opacity: 0;\n    transform: translateX(-50%) translateY(-10px) scale(0.9);\n  }\n  to {\n    opacity: 1;\n    transform: translateX(-50%) translateY(0) scale(1);\n  }\n}\n\n.detail-view-close {\n  position: absolute;\n  top: 12px;\n  right: 12px;\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  background: var(--bg-subtle);\n  border: none;\n  color: var(--text-secondary);\n  font-size: var(--font-size-lg);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all var(--transition-fast);\n  padding: 0;\n  line-height: 1;\n}\n\n.detail-view-close:hover {\n  background: rgba(255, 255, 255, 0.2);\n  color: var(--text-primary);\n  transform: rotate(90deg);\n}\n\n/* Map styles selector overlay */\n.map-styles-overlay {\n  position: fixed;\n  top: 60px;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: calc(var(--z-modal) + 48);\n  background: rgba(10, 10, 10, 0.98);\n  backdrop-filter: blur(40px) saturate(150%);\n  -webkit-backdrop-filter: blur(40px) saturate(150%);\n  border-radius: 20px;\n  padding: var(--spacing-md);\n  width: min(90vw, 480px);\n  max-width: 480px;\n  box-shadow: 0 10px 40px var(--shadow-lg);\n  animation: slideUpFast var(--transition-fast);\n}\n\n@keyframes slideUpFast {\n  from {\n    opacity: 0;\n    transform: translateX(-50%) translateY(10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateX(-50%) translateY(0);\n  }\n}\n\n.map-styles-header {\n  font-size: var(--font-size-sm);\n  font-weight: 600;\n  color: var(--text-secondary);\n  text-transform: uppercase;\n  letter-spacing: 0.1em;\n  margin-bottom: var(--spacing-md);\n  text-align: center;\n}\n\n.map-styles-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));\n  gap: 8px;\n  max-height: calc(100vh - 160px);\n  overflow-y: auto;\n  padding: 4px;\n}\n\n.map-styles-grid::-webkit-scrollbar {\n  width: 4px;\n}\n\n.map-styles-grid::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.map-styles-grid::-webkit-scrollbar-thumb {\n  background: rgba(255, 255, 255, 0.2);\n  border-radius: 2px;\n}\n\n.map-style-option {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: center;\n  padding: 8px 4px;\n  background: transparent;\n  border: 1px solid transparent;\n  border-radius: 12px;\n  cursor: pointer;\n  transition: all var(--transition-fast);\n  position: relative;\n  min-height: fit-content;\n  gap: 4px;\n}\n\n.map-style-option:hover:not(.unavailable) {\n  background: rgba(255, 255, 255, 0.05);\n  border-color: rgba(255, 255, 255, 0.2);\n}\n\n.map-style-option.current {\n  background: rgba(var(--accent-rgb, 62, 106, 225), 0.1);\n  border-color: var(--accent);\n}\n\n.map-style-option.selected {\n  background: rgba(var(--accent-rgb, 62, 106, 225), 0.2);\n  border-color: var(--accent-bright);\n  transform: scale(0.95);\n}\n\n.map-style-option.unavailable {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n.map-style-icon {\n  font-size: var(--font-size-xl);\n  margin-bottom: 4px;\n  flex-shrink: 0;\n}\n\n.map-style-name {\n  font-size: var(--font-size-xs);\n  font-weight: 500;\n  color: var(--text-primary);\n  text-align: center;\n  line-height: 1.2;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  padding: 0 2px;\n  flex: 0 1 auto;\n}\n\n.map-style-star {\n  position: absolute;\n  top: 2px;\n  right: 2px;\n  font-size: var(--font-size-xs);\n}\n\n.map-style-lock {\n  position: absolute;\n  top: 2px;\n  left: 2px;\n  font-size: var(--font-size-xs);\n  opacity: 0.7;\n}\n\n/* ============================================================================\n   Alert Popover\n   ============================================================================ */\n\n.alert-popover {\n  position: fixed;\n  bottom: 140px; /* Above activity bar */\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 999998;\n  background: var(--warning);\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  border-radius: 20px;\n  padding: 8px 16px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n  box-shadow: 0 4px 12px var(--warning);\n  animation: pulse 2s ease-in-out infinite;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--text-primary);\n  user-select: none;\n  max-width: min(400px, calc(100vw - 48px));\n}\n\n.alert-popover--info {\n  background: var(--accent);\n  box-shadow: 0 4px 12px var(--accent);\n}\n\n.alert-popover--success {\n  background: var(--success);\n  box-shadow: 0 4px 12px var(--success);\n}\n\n.alert-popover--danger {\n  background: var(--danger);\n  box-shadow: 0 4px 12px var(--danger);\n}\n\n.alert-popover-icon {\n  font-size: var(--font-size-md);\n}\n\n.alert-popover-message {\n  flex: 1;\n  cursor: pointer;\n}\n\n.alert-popover-dismiss {\n  background: transparent;\n  border: none;\n  color: var(--text-primary);\n  font-size: 24px;\n  line-height: 1;\n  cursor: pointer;\n  padding: 0;\n  width: 24px;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  opacity: 0.8;\n  transition: opacity var(--transition-fast);\n}\n\n.alert-popover-dismiss:hover {\n  opacity: 1;\n}\n\n/* ============================================================================\n   Search Busy Indicator\n   ============================================================================ */\n\n.search-busy-indicator {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 100000;\n  background: var(--bg-overlay);\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  border-radius: 12px;\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 12px;\n}\n\n.search-busy-indicator-spinner {\n  width: 40px;\n  height: 40px;\n  border: 3px solid var(--border);\n  border-top: 3px solid var(--text-primary);\n  border-radius: 50%;\n  animation: spin 0.8s linear infinite;\n}\n\n.search-busy-indicator-text {\n  color: var(--text-primary);\n  font-size: var(--font-size-base);\n}\n\n/* ============================================================================\n   Quick Island Inline Components\n   ============================================================================ */\n\n.quick-island-icon-btn {\n  background: none;\n  border: none;\n  color: var(--text-primary);\n  font-size: 14px;\n  padding: 12px 2px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n}\n\n.quick-island-search-icon {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n}\n\n.quick-island-search-spinner {\n  position: absolute;\n  top: 0;\n  left: 0;\n  transform: rotate(-90deg);\n  animation: spin 1s linear infinite;\n}\n\n.quick-island-search-spinner circle {\n  stroke: var(--accent-bright);\n}\n\n.quick-island-cache-grid {\n  display: grid;\n  gap: 0.5px;\n  padding: 2px;\n  background: var(--bg-glass);\n  border-radius: 3px;\n  position: relative;\n  width: 24px;\n  height: 24px;\n  box-sizing: border-box;\n}\n\n.quick-island-cache-cell {\n  width: 100%;\n  height: 100%;\n  border-radius: 1px;\n  transition: background 0.3s;\n}\n\n.quick-island-cache-cell--cached {\n  background: rgba(100, 255, 100, 0.5);\n}\n\n.quick-island-cache-cell--failed {\n  background: rgba(255, 50, 50, 0.6);\n}\n\n.quick-island-cache-cell--fetching {\n  background: rgba(50, 100, 50, 0.7);\n}\n\n.quick-island-cache-cell--none {\n  background: rgba(120, 120, 120, 0.3);\n}\n\n.quick-island-cache-dot {\n  position: absolute;\n  width: 3px;\n  height: 3px;\n  background: var(--accent);\n  border: 0.5px solid var(--bg-elevated);\n  border-radius: 50%;\n  transform: translate(-50%, -50%);\n  pointer-events: none;\n  box-shadow: 0 0 3px var(--accent);\n}\n\n.quick-island-clock {\n  font-size: 24px;\n  font-weight: 600;\n  line-height: 1;\n  padding: 8px 0;\n  cursor: pointer;\n}\n\n.quick-island-route-icon {\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 12px 4px;\n  color: var(--accent-bright);\n  font-size: 18px;\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.quick-island-route-icon path {\n  stroke: var(--accent-bright);\n}\n\n.quick-island-placeholder {\n  width: 24px;\n  padding: 8px 0;\n}\n\n/* Wake lock indicator */\n.wake-lock-indicator {\n  position: fixed;\n  top: 60px;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 999999;\n  background: var(--warning);\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  border-radius: 20px;\n  padding: 8px 16px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n  box-shadow: 0 4px 12px var(--warning);\n  animation: pulse 2s ease-in-out infinite;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--text-primary);\n  user-select: none;\n}\n\n.wake-lock-indicator--centered {\n  top: 50%;\n  transform: translate(-50%, -50%);\n}\n\n.wake-lock-indicator-icon {\n  font-size: var(--font-size-md);\n}\n\n/* ============================================================================\n   Activity Context Menu - Theme-aware dropdown menu\n   ============================================================================ */\n\n.activity-context-menu {\n  background: var(--bg-modal);\n  border: 1px solid var(--border);\n  border-radius: 8px;\n  padding: 4px 0;\n  min-width: 200px;\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  box-shadow: 0 4px 12px var(--shadow-lg);\n}\n\n.activity-context-menu-header {\n  padding: 8px 12px;\n  font-size: 12px;\n  color: var(--text-secondary);\n  border-bottom: 1px solid var(--border-light);\n}\n\n.activity-context-menu-item {\n  display: block;\n  width: 100%;\n  padding: 8px 12px;\n  background: transparent;\n  border: none;\n  color: var(--text-primary);\n  text-align: left;\n  cursor: pointer;\n  font-size: 13px;\n  transition: background var(--transition-fast);\n}\n\n.activity-context-menu-item:hover {\n  background: var(--bg-subtle);\n}\n\n.activity-context-menu-item--danger {\n  color: var(--danger);\n}\n\n.activity-context-menu-item--danger:hover {\n  background: rgba(255, 107, 107, 0.1);\n}\n\n/* Mobile responsiveness */\n@media (max-width: 480px) {\n  .persistent-quick-island {\n    min-width: 240px;\n    transform: translateX(-50%) scale(0.95);\n  }\n\n  .clock-time {\n    font-size: 12px;\n  }\n\n  .quick-island-clock {\n    min-width: 70px;\n    padding: 0 8px;\n  }\n\n  .quick-island-detail-view {\n    width: calc(100vw - 20px);\n    max-width: calc(100vw - 20px);\n  }\n\n  .map-styles-overlay {\n    width: calc(100vw - 20px);\n    max-width: calc(100vw - 20px);\n    min-width: auto;\n  }\n\n  .map-styles-grid {\n    grid-template-columns: repeat(auto-fill, minmax(60px, 1fr));\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
